// // v184
// // mab // mouse ok step 2// // ok mouse move, walk, scroll zoom, colotion, بالا پایین رفتن دوربین ok, زاویه دوربین درست, hdr درست, نور و سایه درست // پنگوئن با راه رفتن و برخورد بدون اپن و برف اضافه شده // مه اضافه شده
// // v184
import React, { useEffect, useState, useRef } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import * as CANNON from 'cannon-es';
import { Joystick } from 'react-joystick-component';


const SNOW_CONFIG = {
  enabled: true,

  // Main falling snow amount. Kept at 3600, but optimized so particles never wait on the ground.
  amount: 3600,
  fallSpeed: 0.075,

  areaWidth: 240,
  areaDepth: 120,
  spawnHeightMin: 24,
  spawnHeightMax: 55,
  groundY: 0.12,

  windX: 0.012,
  windZ: 0.006,
  windRandomness: 0.018,

  flakeSizeMin: 0.28,
  flakeSizeMax: 0.78,
  flakeOpacity: 0.86,

  settleTime: 10.7,
  fadeTime: 5.8,

  // Settled snow is capped and recycled, so it does not keep growing and lag the scene.
  maxSettled: 900,

  landingOffset: 0.04,
  targetRefreshFrames: 240,
  surfaceCacheCellSize: 5,
  maxRaycastDistance: 120
};

const FOG_CONFIG = {
  enabled: false,

  // Connected soft fog: one continuous shader layer, not separate big particles/cloud pieces.
  areaWidth: 300,
  areaDepth: 165,

  // Fog layer heights. Lower layer gives ground mist, upper layer gives soft depth in the scene.
  lowerHeight: 0.85,
  upperHeight: 2.45,

  // Main visibility controls.
  opacity: 0.18,
  opacityVariation: 0.11,

  // Larger scale = softer, more connected fog. Smaller scale = more detailed texture.
  noiseScale: 2.2,
  noiseSoftness: 0.42,

  // Movement direction/speed.
  speedX: 0.018,
  speedZ: 0.008,

  // Soft edge fade so the plane border is not visible.
  edgeSoftness: 0.12,

  // Slight tint so it is visible on the white scene without looking like cloud chunks.
  colorR: 0.80,
  colorG: 0.84,
  colorB: 0.90,

  // Hide debug collision line boxes so the fog does not make them visible in the scene.
  hideModelCollisionLines: true
};


const AVATAR_CONFIG = {
  // Avatar movement speed. Change this value to make the penguin walk slower or faster.
  moveSpeed: 4
};

const BALL_CONFIG = {
  enabled: true,
  path: '/models/mab0626/ball.glb',

  // Position and scale in the scene.
  scale: 1.5,
  startX: 0,
  startY: 1.2,
  startZ: -14,

  // Collision / ground height controls.
  radius: 1.5,
  avatarRadius: 0.58,
  collisionPadding: 0.08,

  // Movement controls. Higher pushPower / maxSpeed = ball moves more after avatar contact.
  pushPower: 4.2,
  avatarVelocityInfluence: 0.22,
  maxSpeed: 2,

  // Higher friction stops the ball faster. 0.985 is snow-like and not slippery.
  friction: 0.98,
  wallFriction: 0.45,
  minSpeedStop: 0.03,

  // Rolling controls. Lower value = slower visual rotation.
  spinMultiplier: 0.62
};

const MAIN_CAMERA_CONFIG = {
  fov: 45,
  near: 0.1,
  far: 1000,

  startX: 15,
  startY: 15,
  startZ: 15,
  lookAtX: 0,
  lookAtY: 0,
  lookAtZ: 0,

  zoomDistances: [23, 23, 24],
  orbitThetaDeg: 45,
  orbitPhiDeg: 35.26,
  targetY: 1
};

const MAIN_LIGHT_CONFIG = {
  directionalColor: 0xffe5b4,
  directionalIntensity: 5,
  initialX: 50,
  initialY: 80,
  initialZ: 50,

  followCameraOffsetX: 50,
  followY: 80,
  followCameraOffsetZ: 50,
  targetY: 1,

  castShadow: true,
  shadowCameraNear: 0.1,
  shadowCameraFar: 500,
  shadowCameraLeft: -150,
  shadowCameraRight: 150,
  shadowCameraTop: 150,
  shadowCameraBottom: -150,
  shadowMapSize: 4096,
  shadowBias: -0.001,

  ambientColor: 0xffa500,
  ambientIntensity: 0.2
};

const MAIN_RENDERER_CONFIG = {
  shadowMapEnabled: true,
  shadowMapType: THREE.PCFSoftShadowMap,
  toneMapping: THREE.ACESFilmicToneMapping,
  toneMappingExposure: 0.7,
  environmentMapIntensity: 0.2
};

const MAIN_LOGO_ROTATION_CONFIG = {
  enabled: true,
  path: '/models/winter/logo.glb',
  durationSeconds: 10,
  direction: 1, // 1 = normal, -1 = reverse
  axis: 'y' // x, y, z
};

const MAIN_MODEL_LOADING_QUEUE_CONFIG = {
  enabled: true,
  maxConcurrent: 2,
  startDelayMs: 120,
  betweenLoadsMs: 55,
  idleTimeoutMs: 240,
  idleFallbackMs: 16,
  logProgress: false
};

const simulateKeyEvent = (key, type) => {
  const event = new KeyboardEvent(type, {
    key: key,
    bubbles: true,
    cancelable: true,
  });
  document.getElementById('three-container').dispatchEvent(event);
};

const handleButtonPress = (key) => {
  simulateKeyEvent(key, 'keydown');
};

const handleButtonRelease = (key) => {
  simulateKeyEvent(key, 'keyup');
};

const handleJoystickMove = (event) => {
  const { x, y } = event;
  const threshold = 0.5;

  // if (y > threshold) {
  //   handleButtonPress('ArrowUp');
  // } else if (y < -threshold) {
  //   handleButtonPress('ArrowDown');
  // }

  if (x < -threshold) {
    handleButtonPress('ArrowLeft');
  } else if (x > threshold) {
    handleButtonPress('ArrowRight');
  }
};

const handleJoystickStop = () => {
  //handleButtonRelease('ArrowUp');
  //handleButtonRelease('ArrowDown');
  handleButtonRelease('ArrowLeft');
  handleButtonRelease('ArrowRight');
};




const PENGUIN_LOADING_AVATAR_CONFIG = {
  path: '/models/avatar-p3.glb',
  x: 0,
  y: -0.02,
  z: 0,
  scale: 0.55,
  rotationY: 0,
  walkAnimationName: 'walk',
  animationTimeScale: 1.0,
  keepInCenter: true
};

const PENGUIN_LOADING_CAMERA_CONFIG = {
  fov: 38,
  x: 0,
  y: 1.55,
  z: 8.2,
  lookAtX: 0,
  lookAtY: 0.95,
  lookAtZ: 0,
  near: 0.1,
  far: 80
};

const PENGUIN_LOADING_SCENE_CONFIG = {
  backgroundTop: '#f7fbff',
  backgroundMiddle: '#ebf2f8',
  backgroundBottom: '#ffffff',
  fogColor: '#eef4fa',
  fogNear: 8,
  fogFar: 25
};

const PENGUIN_LOADING_ENVIRONMENT_CONFIG = {
  enabled: true,
  path: '/hdri.png',
  intensity: 1.0,
  visibleInBackground: false
};

const PENGUIN_LOADING_LIGHT_CONFIG = {
  ambientSkyColor: 0xffffff,
  ambientGroundColor: 0xd8e4ee,
  ambientIntensity: 1.45,
  keyColor: 0xffffff,
  keyLightIntensity: 2.6,
  keyLightX: -3.5,
  keyLightY: 1.5,
  keyLightZ: 4.5,
  fillColor: 0xeaf7ff,
  fillLightIntensity: 1.1,
  fillLightX: 4,
  fillLightY: 2.8,
  fillLightZ: 2
};

const PENGUIN_LOADING_SNOW_GROUND_CONFIG = {
  width: 46,
  depth: 58,
  segments: 150,
  y: -0.02,
  color: '#f4f7f8',
  roughness: 0.92,
  metalness: 0.0,
  bumpStrength: 0.10
};

const PENGUIN_LOADING_SHADOW_CONFIG = {
  enabled: true,
  mapSize: 2048,
  bias: -0.00025,
  normalBias: 0.02,
  radius: 4,
  cameraNear: 0.5,
  cameraFar: 16,
  cameraLeft: -4,
  cameraRight: 4,
  cameraTop: 4,
  cameraBottom: -4,
  castAvatarShadow: true,
  receiveGroundShadow: true
};

const PENGUIN_LOADING_FALLING_SNOW_CONFIG = {
  count: 7200,
  fieldWidth: 18,
  fieldDepth: 18,
  topY: 8,
  bottomY: -1.2,
  centerZ: -4,
  sizeMin: 0.018,
  sizeMax: 0.075,
  speedMin: 0.38,
  speedMax: 1.22,
  drift: 0.20,
  opacity: 0.88,
  color: '#ffffff'
};

const PENGUIN_LOADING_UI_CONFIG = {
  x: 0,
  y: 84,
  z: 1000,
  gap: 14,
  fontFamily: "'Cinzel', Georgia, serif",

  loadingText: {
    x: 0,
    y: 0,
    z: 0,
    color: 'rgba(0, 0, 0, 0.78)',
    fontSize: 13,
    letterSpacing: 0.32,
    width: '132px',
    textAlign: 'center',
    fontWeight: 700,
    shadow: '0 2px 12px rgba(255, 255, 255, 0.72)'
  },

  button: {
    x: 0,
    y: 0,
    z: 0,
    width: '132px',
    height: '40px',
    padding: '0 36px',
    borderRadius: '999px',
    textColor: 'rgba(0, 0, 0, 0.86)',
    borderColor: 'rgba(0, 0, 0, 0.34)',
    borderHoverColor: 'rgba(0, 0, 0, 0.62)',
    background: 'rgba(255, 255, 255, 0.34)',
    hoverBackground: 'rgba(255, 255, 255, 0.54)',
    fontSize: 12,
    letterSpacing: 0.34,
    fontWeight: 700,
    shadow: '0 10px 40px rgba(0, 0, 0, 0.08), inset 0 0 24px rgba(255, 255, 255, 0.38)',
    hoverShadow: '0 12px 45px rgba(0, 0, 0, 0.14), inset 0 0 28px rgba(255, 255, 255, 0.55)',
    readyLift: 0,
    hiddenLift: 8
  }
};

const PENGUIN_LOADING_PERFORMANCE_CONFIG = {
  animationMaxDelta: 0.08,
  snowMaxDelta: 0.05,
  pixelRatioMax: 1.35
};

const PenguinLoadingOverlay = ({ progress = 0, ready = false, isEntering = false, onEnter }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const fontLinkId = 'penguin-loading-cinzel-font';
    if (!document.getElementById(fontLinkId)) {
      const link = document.createElement('link');
      link.id = fontLinkId;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    let animationFrameId = null;
    let disposed = false;
    let avatar = null;
    let mixer = null;
    let snowPoints = null;
    let environmentTexture = null;

    const clock = new THREE.Clock();
    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(
      PENGUIN_LOADING_SCENE_CONFIG.fogColor,
      PENGUIN_LOADING_SCENE_CONFIG.fogNear,
      PENGUIN_LOADING_SCENE_CONFIG.fogFar
    );

    const camera = new THREE.PerspectiveCamera(
      PENGUIN_LOADING_CAMERA_CONFIG.fov,
      window.innerWidth / window.innerHeight,
      PENGUIN_LOADING_CAMERA_CONFIG.near,
      PENGUIN_LOADING_CAMERA_CONFIG.far
    );
    camera.position.set(
      PENGUIN_LOADING_CAMERA_CONFIG.x,
      PENGUIN_LOADING_CAMERA_CONFIG.y,
      PENGUIN_LOADING_CAMERA_CONFIG.z
    );
    camera.lookAt(
      PENGUIN_LOADING_CAMERA_CONFIG.lookAtX,
      PENGUIN_LOADING_CAMERA_CONFIG.lookAtY,
      PENGUIN_LOADING_CAMERA_CONFIG.lookAtZ
    );

    const renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      alpha: true,
      powerPreference: 'high-performance'
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, PENGUIN_LOADING_PERFORMANCE_CONFIG.pixelRatioMax));
    renderer.setSize(window.innerWidth, window.innerHeight, false);
    renderer.shadowMap.enabled = PENGUIN_LOADING_SHADOW_CONFIG.enabled;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.04;
    renderer.setClearColor(0xffffff, 0);

    const makeGradientSky = () => {
      const skyCanvas = document.createElement('canvas');
      skyCanvas.width = 32;
      skyCanvas.height = 512;

      const ctx = skyCanvas.getContext('2d');
      const gradient = ctx.createLinearGradient(0, 0, 0, skyCanvas.height);
      gradient.addColorStop(0, PENGUIN_LOADING_SCENE_CONFIG.backgroundTop);
      gradient.addColorStop(0.46, PENGUIN_LOADING_SCENE_CONFIG.backgroundMiddle);
      gradient.addColorStop(1, PENGUIN_LOADING_SCENE_CONFIG.backgroundBottom);
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, skyCanvas.width, skyCanvas.height);

      const texture = new THREE.CanvasTexture(skyCanvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.needsUpdate = true;

      const sky = new THREE.Mesh(
        new THREE.SphereGeometry(40, 48, 32),
        new THREE.MeshBasicMaterial({ map: texture, side: THREE.BackSide, depthWrite: false })
      );
      sky.position.set(0, 8, -10);
      scene.add(sky);
    };

    const makeGroundBumpTexture = () => {
      const bumpCanvas = document.createElement('canvas');
      bumpCanvas.width = 256;
      bumpCanvas.height = 256;

      const ctx = bumpCanvas.getContext('2d');
      ctx.fillStyle = 'rgb(128,128,128)';
      ctx.fillRect(0, 0, bumpCanvas.width, bumpCanvas.height);

      for (let i = 0; i < 1800; i++) {
        const v = 118 + Math.random() * 38;
        ctx.fillStyle = `rgba(${v},${v},${v},${0.16 + Math.random() * 0.24})`;
        ctx.beginPath();
        ctx.arc(
          Math.random() * bumpCanvas.width,
          Math.random() * bumpCanvas.height,
          Math.random() * 1.6 + 0.25,
          0,
          Math.PI * 2
        );
        ctx.fill();
      }

      const texture = new THREE.CanvasTexture(bumpCanvas);
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(18, 18);
      texture.needsUpdate = true;
      return texture;
    };

    const applyEnvironmentToMaterial = (material) => {
      if (!material || !environmentTexture) return;
      material.envMap = environmentTexture;
      material.envMapIntensity = PENGUIN_LOADING_ENVIRONMENT_CONFIG.intensity;
      material.needsUpdate = true;
    };

    const applyEnvironmentToAvatar = () => {
      if (!avatar || !environmentTexture) return;

      avatar.traverse((child) => {
        if (!child.isMesh || !child.material) return;

        if (Array.isArray(child.material)) {
          child.material.forEach(applyEnvironmentToMaterial);
        } else {
          applyEnvironmentToMaterial(child.material);
        }
      });
    };

    const createEnvironment = () => {
      if (!PENGUIN_LOADING_ENVIRONMENT_CONFIG.enabled) return;

      const loader = new THREE.TextureLoader();
      loader.load(
        PENGUIN_LOADING_ENVIRONMENT_CONFIG.path,
        (texture) => {
          if (disposed) {
            texture.dispose();
            return;
          }

          texture.mapping = THREE.EquirectangularReflectionMapping;
          texture.colorSpace = THREE.SRGBColorSpace;
          environmentTexture = texture;

          if (PENGUIN_LOADING_ENVIRONMENT_CONFIG.visibleInBackground) {
            scene.background = texture;
          }

          applyEnvironmentToAvatar();
        },
        undefined,
        () => {
          console.warn('hdri.png loading failed. Keep the file at public/hdri.png');
        }
      );
    };

    const createLights = () => {
      const ambient = new THREE.HemisphereLight(
        PENGUIN_LOADING_LIGHT_CONFIG.ambientSkyColor,
        PENGUIN_LOADING_LIGHT_CONFIG.ambientGroundColor,
        PENGUIN_LOADING_LIGHT_CONFIG.ambientIntensity
      );
      scene.add(ambient);

      const key = new THREE.DirectionalLight(
        PENGUIN_LOADING_LIGHT_CONFIG.keyColor,
        PENGUIN_LOADING_LIGHT_CONFIG.keyLightIntensity
      );
      key.position.set(
        PENGUIN_LOADING_LIGHT_CONFIG.keyLightX,
        PENGUIN_LOADING_LIGHT_CONFIG.keyLightY,
        PENGUIN_LOADING_LIGHT_CONFIG.keyLightZ
      );
      key.castShadow = PENGUIN_LOADING_SHADOW_CONFIG.enabled;

      if (PENGUIN_LOADING_SHADOW_CONFIG.enabled) {
        key.shadow.mapSize.set(PENGUIN_LOADING_SHADOW_CONFIG.mapSize, PENGUIN_LOADING_SHADOW_CONFIG.mapSize);
        key.shadow.bias = PENGUIN_LOADING_SHADOW_CONFIG.bias;
        key.shadow.normalBias = PENGUIN_LOADING_SHADOW_CONFIG.normalBias;
        key.shadow.radius = PENGUIN_LOADING_SHADOW_CONFIG.radius;
        key.shadow.camera.near = PENGUIN_LOADING_SHADOW_CONFIG.cameraNear;
        key.shadow.camera.far = PENGUIN_LOADING_SHADOW_CONFIG.cameraFar;
        key.shadow.camera.left = PENGUIN_LOADING_SHADOW_CONFIG.cameraLeft;
        key.shadow.camera.right = PENGUIN_LOADING_SHADOW_CONFIG.cameraRight;
        key.shadow.camera.top = PENGUIN_LOADING_SHADOW_CONFIG.cameraTop;
        key.shadow.camera.bottom = PENGUIN_LOADING_SHADOW_CONFIG.cameraBottom;
        key.shadow.camera.updateProjectionMatrix();
      }

      scene.add(key);

      const fill = new THREE.DirectionalLight(
        PENGUIN_LOADING_LIGHT_CONFIG.fillColor,
        PENGUIN_LOADING_LIGHT_CONFIG.fillLightIntensity
      );
      fill.position.set(
        PENGUIN_LOADING_LIGHT_CONFIG.fillLightX,
        PENGUIN_LOADING_LIGHT_CONFIG.fillLightY,
        PENGUIN_LOADING_LIGHT_CONFIG.fillLightZ
      );
      scene.add(fill);
    };

    const createGround = () => {
      const geometry = new THREE.PlaneGeometry(
        PENGUIN_LOADING_SNOW_GROUND_CONFIG.width,
        PENGUIN_LOADING_SNOW_GROUND_CONFIG.depth,
        PENGUIN_LOADING_SNOW_GROUND_CONFIG.segments,
        PENGUIN_LOADING_SNOW_GROUND_CONFIG.segments
      );

      const position = geometry.attributes.position;
      for (let i = 0; i < position.count; i++) {
        const x = position.getX(i);
        const y = position.getY(i);
        const wave =
          Math.sin(x * 0.92) * 0.012 +
          Math.sin(y * 0.48 + x * 0.16) * 0.018 +
          Math.sin((x + y) * 1.35) * 0.006;
        position.setZ(i, wave);
      }
      geometry.computeVertexNormals();

      const material = new THREE.MeshStandardMaterial({
        color: PENGUIN_LOADING_SNOW_GROUND_CONFIG.color,
        roughness: PENGUIN_LOADING_SNOW_GROUND_CONFIG.roughness,
        metalness: PENGUIN_LOADING_SNOW_GROUND_CONFIG.metalness,
        bumpMap: makeGroundBumpTexture(),
        bumpScale: PENGUIN_LOADING_SNOW_GROUND_CONFIG.bumpStrength
      });

      const ground = new THREE.Mesh(geometry, material);
      ground.rotation.x = -Math.PI / 2;
      ground.position.y = PENGUIN_LOADING_SNOW_GROUND_CONFIG.y;
      ground.receiveShadow = PENGUIN_LOADING_SHADOW_CONFIG.enabled && PENGUIN_LOADING_SHADOW_CONFIG.receiveGroundShadow;
      scene.add(ground);
    };

    const createSnow = () => {
      const count = PENGUIN_LOADING_FALLING_SNOW_CONFIG.count;
      const positions = new Float32Array(count * 3);
      const speeds = new Float32Array(count);
      const drifts = new Float32Array(count);
      const phases = new Float32Array(count);
      const sizes = new Float32Array(count);

      for (let i = 0; i < count; i++) {
        const i3 = i * 3;
        positions[i3] = (Math.random() - 0.5) * PENGUIN_LOADING_FALLING_SNOW_CONFIG.fieldWidth;
        positions[i3 + 1] = PENGUIN_LOADING_FALLING_SNOW_CONFIG.bottomY + Math.random() * (PENGUIN_LOADING_FALLING_SNOW_CONFIG.topY - PENGUIN_LOADING_FALLING_SNOW_CONFIG.bottomY);
        positions[i3 + 2] = PENGUIN_LOADING_FALLING_SNOW_CONFIG.centerZ + (Math.random() - 0.5) * PENGUIN_LOADING_FALLING_SNOW_CONFIG.fieldDepth;

        speeds[i] = THREE.MathUtils.lerp(PENGUIN_LOADING_FALLING_SNOW_CONFIG.speedMin, PENGUIN_LOADING_FALLING_SNOW_CONFIG.speedMax, Math.random());
        drifts[i] = (Math.random() - 0.5) * PENGUIN_LOADING_FALLING_SNOW_CONFIG.drift;
        phases[i] = Math.random() * Math.PI * 2;
        sizes[i] = THREE.MathUtils.lerp(PENGUIN_LOADING_FALLING_SNOW_CONFIG.sizeMin, PENGUIN_LOADING_FALLING_SNOW_CONFIG.sizeMax, Math.random());
      }

      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      geometry.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1));
      geometry.setAttribute('aSpeed', new THREE.BufferAttribute(speeds, 1));
      geometry.setAttribute('aDrift', new THREE.BufferAttribute(drifts, 1));
      geometry.setAttribute('aPhase', new THREE.BufferAttribute(phases, 1));

      const material = new THREE.ShaderMaterial({
        transparent: true,
        depthWrite: false,
        depthTest: true,
        blending: THREE.NormalBlending,
        uniforms: {
          uTime: { value: 0 },
          uTopY: { value: PENGUIN_LOADING_FALLING_SNOW_CONFIG.topY },
          uBottomY: { value: PENGUIN_LOADING_FALLING_SNOW_CONFIG.bottomY },
          uColor: { value: new THREE.Color(PENGUIN_LOADING_FALLING_SNOW_CONFIG.color) },
          uOpacity: { value: PENGUIN_LOADING_FALLING_SNOW_CONFIG.opacity },
          uPixelRatio: { value: Math.min(window.devicePixelRatio, PENGUIN_LOADING_PERFORMANCE_CONFIG.pixelRatioMax) }
        },
        vertexShader: `
          attribute float aSize;
          attribute float aSpeed;
          attribute float aDrift;
          attribute float aPhase;

          uniform float uTime;
          uniform float uTopY;
          uniform float uBottomY;
          uniform float uPixelRatio;

          varying float vDepthAlpha;

          void main() {
            float rangeY = max(0.001, uTopY - uBottomY);
            vec3 p = position;
            float shiftedY = mod((p.y - uBottomY) - uTime * aSpeed, rangeY);
            p.y = uBottomY + shiftedY;
            p.x += sin(uTime * 0.55 + aPhase + p.z * 0.2) * aDrift;

            vec4 mvPosition = modelViewMatrix * vec4(p, 1.0);
            float depthFade = smoothstep(-24.0, -2.0, mvPosition.z);
            vDepthAlpha = mix(0.42, 1.0, depthFade);
            gl_PointSize = aSize * uPixelRatio * (430.0 / max(1.0, -mvPosition.z));
            gl_Position = projectionMatrix * mvPosition;
          }
        `,
        fragmentShader: `
          uniform vec3 uColor;
          uniform float uOpacity;
          varying float vDepthAlpha;

          void main() {
            vec2 uv = gl_PointCoord - 0.5;
            float d = length(uv);
            float alpha = smoothstep(0.5, 0.0, d) * uOpacity * vDepthAlpha;
            if (alpha < 0.02) discard;
            gl_FragColor = vec4(uColor, alpha);
          }
        `
      });

      snowPoints = new THREE.Points(geometry, material);
      snowPoints.frustumCulled = false;
      scene.add(snowPoints);
    };

    const findWalkClip = (animations) => {
      if (!animations || animations.length === 0) return null;

      const searchName = PENGUIN_LOADING_AVATAR_CONFIG.walkAnimationName.toLowerCase();
      return animations.find((clip) => clip.name.toLowerCase().includes(searchName)) || animations[0];
    };

    const loadAvatar = () => {
      const loader = new GLTFLoader();

      loader.load(
        PENGUIN_LOADING_AVATAR_CONFIG.path,
        (gltf) => {
          if (disposed) return;

          avatar = gltf.scene;
          avatar.position.set(
            PENGUIN_LOADING_AVATAR_CONFIG.x,
            PENGUIN_LOADING_AVATAR_CONFIG.y,
            PENGUIN_LOADING_AVATAR_CONFIG.z
          );
          avatar.rotation.y = THREE.MathUtils.degToRad(PENGUIN_LOADING_AVATAR_CONFIG.rotationY);
          avatar.scale.setScalar(PENGUIN_LOADING_AVATAR_CONFIG.scale);

          avatar.traverse((child) => {
            if (!child.isMesh) return;
            child.castShadow = PENGUIN_LOADING_SHADOW_CONFIG.enabled && PENGUIN_LOADING_SHADOW_CONFIG.castAvatarShadow;
            child.receiveShadow = false;
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(applyEnvironmentToMaterial);
              } else {
                applyEnvironmentToMaterial(child.material);
              }
            }
          });

          scene.add(avatar);

          const walkClip = findWalkClip(gltf.animations);
          if (walkClip) {
            mixer = new THREE.AnimationMixer(avatar);
            const action = mixer.clipAction(walkClip);
            action.reset();
            action.setLoop(THREE.LoopRepeat);
            action.clampWhenFinished = false;
            action.enabled = true;
            action.timeScale = PENGUIN_LOADING_AVATAR_CONFIG.animationTimeScale;
            action.play();
          } else {
            console.warn('No animation found inside avatar.glb');
          }
        },
        undefined,
        (error) => {
          console.error('avatar.glb loading failed:', error);
        }
      );
    };

    const updateSnow = (delta, elapsed) => {
      if (!snowPoints) return;
      snowPoints.material.uniforms.uTime.value = elapsed;
    };

    const resize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      camera.aspect = width / height;
      camera.updateProjectionMatrix();

      renderer.setSize(width, height, false);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, PENGUIN_LOADING_PERFORMANCE_CONFIG.pixelRatioMax));

      if (snowPoints) {
        snowPoints.material.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, PENGUIN_LOADING_PERFORMANCE_CONFIG.pixelRatioMax);
      }
    };

    const animate = () => {
      animationFrameId = requestAnimationFrame(animate);

      const rawDelta = clock.getDelta();
      const delta = Math.min(rawDelta, PENGUIN_LOADING_PERFORMANCE_CONFIG.snowMaxDelta);
      const animationDelta = Math.min(rawDelta, PENGUIN_LOADING_PERFORMANCE_CONFIG.animationMaxDelta);
      const elapsed = clock.getElapsedTime();

      if (mixer) {
        mixer.update(animationDelta);
      }

      if (avatar && PENGUIN_LOADING_AVATAR_CONFIG.keepInCenter) {
        avatar.position.set(
          PENGUIN_LOADING_AVATAR_CONFIG.x,
          PENGUIN_LOADING_AVATAR_CONFIG.y,
          PENGUIN_LOADING_AVATAR_CONFIG.z
        );
      }

      updateSnow(delta, elapsed);
      renderer.render(scene, camera);
    };

    makeGradientSky();
    createEnvironment();
    createLights();
    createGround();
    createSnow();
    loadAvatar();
    resize();
    animate();

    window.addEventListener('resize', resize);

    return () => {
      disposed = true;
      window.removeEventListener('resize', resize);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }

      scene.traverse((object) => {
        if (object.geometry) {
          object.geometry.dispose();
        }

        if (object.material) {
          const materials = Array.isArray(object.material) ? object.material : [object.material];
          materials.forEach((material) => {
            if (!material) return;
            Object.keys(material).forEach((key) => {
              const value = material[key];
              if (value && value.isTexture) {
                value.dispose();
              }
            });
            material.dispose();
          });
        }
      });

      if (environmentTexture) {
        environmentTexture.dispose();
      }

      renderer.dispose();
    };
  }, []);

  const safeProgress = Math.max(0, Math.min(100, Math.round(progress || 0)));

  return (
    <div className="penguin-loading-overlay">
      <canvas ref={canvasRef} className="penguin-loading-canvas" />

      <div className="penguin-loading-ui">
        <button
          type="button"
          className={`penguin-enter-button ${ready ? 'ready' : ''} ${isEntering ? 'animating' : ''}`}
          disabled={!ready || isEntering}
          onClick={onEnter}
        >
          ENTER
        </button>
        <div className="penguin-progress-text">{safeProgress}%</div>
      </div>

      <style>{`
        .penguin-loading-overlay {
          position: absolute;
          inset: 0;
          width: 100vw;
          height: 100vh;
          overflow: hidden;
          z-index: ${PENGUIN_LOADING_UI_CONFIG.z};
          background:
            linear-gradient(180deg,
              ${PENGUIN_LOADING_SCENE_CONFIG.backgroundTop} 0%,
              ${PENGUIN_LOADING_SCENE_CONFIG.backgroundMiddle} 48%,
              ${PENGUIN_LOADING_SCENE_CONFIG.backgroundBottom} 100%
            );
          font-family: ${PENGUIN_LOADING_UI_CONFIG.fontFamily};
        }

        .penguin-loading-canvas {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          display: block;
          z-index: 1;
        }

        .penguin-loading-ui {
          position: absolute;
          z-index: 2;
          left: 50%;
          top: ${PENGUIN_LOADING_UI_CONFIG.y}vh;
          transform: translate3d(calc(-50% + ${PENGUIN_LOADING_UI_CONFIG.x}px), 0, 0);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: ${PENGUIN_LOADING_UI_CONFIG.gap}px;
          pointer-events: none;
          user-select: none;
        }

        .penguin-progress-text {
          transform: translate3d(${PENGUIN_LOADING_UI_CONFIG.loadingText.x}px, ${PENGUIN_LOADING_UI_CONFIG.loadingText.y}px, ${PENGUIN_LOADING_UI_CONFIG.loadingText.z}px);
          color: ${PENGUIN_LOADING_UI_CONFIG.loadingText.color};
          font-family: ${PENGUIN_LOADING_UI_CONFIG.fontFamily};
          font-size: ${PENGUIN_LOADING_UI_CONFIG.loadingText.fontSize}px;
          letter-spacing: ${PENGUIN_LOADING_UI_CONFIG.loadingText.letterSpacing}em;
          font-weight: ${PENGUIN_LOADING_UI_CONFIG.loadingText.fontWeight};
          width: ${PENGUIN_LOADING_UI_CONFIG.loadingText.width};
          text-align: ${PENGUIN_LOADING_UI_CONFIG.loadingText.textAlign};
          line-height: 1;
          text-shadow: ${PENGUIN_LOADING_UI_CONFIG.loadingText.shadow};
        }

        .penguin-enter-button {
          opacity: 0;
          transform: translate3d(${PENGUIN_LOADING_UI_CONFIG.button.x}px, ${PENGUIN_LOADING_UI_CONFIG.button.y + PENGUIN_LOADING_UI_CONFIG.button.hiddenLift}px, ${PENGUIN_LOADING_UI_CONFIG.button.z}px);
          pointer-events: none;
          width: ${PENGUIN_LOADING_UI_CONFIG.button.width};
          height: ${PENGUIN_LOADING_UI_CONFIG.button.height};
          padding: ${PENGUIN_LOADING_UI_CONFIG.button.padding};
          border: 1px solid ${PENGUIN_LOADING_UI_CONFIG.button.borderColor};
          border-radius: ${PENGUIN_LOADING_UI_CONFIG.button.borderRadius};
          background: ${PENGUIN_LOADING_UI_CONFIG.button.background};
          color: ${PENGUIN_LOADING_UI_CONFIG.button.textColor};
          font-family: ${PENGUIN_LOADING_UI_CONFIG.fontFamily};
          font-size: ${PENGUIN_LOADING_UI_CONFIG.button.fontSize}px;
          letter-spacing: ${PENGUIN_LOADING_UI_CONFIG.button.letterSpacing}em;
          font-weight: ${PENGUIN_LOADING_UI_CONFIG.button.fontWeight};
          backdrop-filter: blur(14px);
          box-shadow: ${PENGUIN_LOADING_UI_CONFIG.button.shadow};
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
          cursor: pointer;
          transition:
            opacity 900ms ease,
            transform 900ms ease,
            border-color 250ms ease,
            box-shadow 250ms ease,
            background 250ms ease;
        }

        .penguin-enter-button.ready {
          opacity: 1;
          transform: translate3d(${PENGUIN_LOADING_UI_CONFIG.button.x}px, ${PENGUIN_LOADING_UI_CONFIG.button.y + PENGUIN_LOADING_UI_CONFIG.button.readyLift}px, ${PENGUIN_LOADING_UI_CONFIG.button.z}px);
          pointer-events: auto;
        }

        .penguin-enter-button.ready:hover {
          border-color: ${PENGUIN_LOADING_UI_CONFIG.button.borderHoverColor};
          background: ${PENGUIN_LOADING_UI_CONFIG.button.hoverBackground};
          box-shadow: ${PENGUIN_LOADING_UI_CONFIG.button.hoverShadow};
        }

        .penguin-enter-button.animating {
          opacity: 0.4;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
};

const ThreeScene = () => {
  const [loading, setLoading] = useState(true);
  const [showStartScreen, setShowStartScreen] = useState(false);
  const [isButtonAnimating, setIsButtonAnimating] = useState(false);
  const [isHDRLoaded, setIsHDRLoaded] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  let callResetScene = false;
  const [progress, setProgress] = useState(0);
  const [modelsLoaded, setModelsLoaded] = useState(0);
  const [error, setError] = useState(null);
  const totalModels = BALL_CONFIG.enabled ? 38 : 37;
  const moveSpeed = 0.02;

  const rotatingModels = [];
  const savedHumanPosition = useRef(null);
  const savedHumanQuaternion = useRef(null);
  const savedCameraPosition = useRef(null);
  const savedCameraLookAt = useRef(null);
  const cameraRef = useRef(null);
  const humanBodyRef = useRef(null);

  const keyTimers = useRef({});
  const mainSceneActiveRef = useRef(false);

  const savedTargetPosition = useRef(new THREE.Vector3(0, 1, 0));

  const setupOutlineEffect = (model) => {
    // // Create a wireframe geometry from the model's geometry
    // const edges = new THREE.EdgesGeometry(model.children[0].geometry);
    // const outlineMaterial = new THREE.LineBasicMaterial({ 
    //   color: 0x00ffff, // رنگ آبی-فیروزه‌ای
    //   linewidth: 2,    // ضخامت خط
    //   transparent: true,
    //   opacity: 0.8
    // });

    // const outlineMesh = new THREE.LineSegments(edges, outlineMaterial);
    // outlineMesh.visible = false; // ابتدا مخفی باشد
    // outlineMesh.scale.set(1.05, 1.05, 1.05); // کمی بزرگتر از مدل اصلی

    // // اضافه کردن به مدل اصلی
    // model.add(outlineMesh);

    // return outlineMesh;
  };

  const createFenceEffect = (model) => {
    // Create a circular fence around the model
    const fenceGeometry = new THREE.CylinderGeometry(2, 2, 1, 32, 1, true);
    const fenceMaterial = new THREE.MeshBasicMaterial({
      color: 0x00ffff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5,
      wireframe: true
    });

    const fence = new THREE.Mesh(fenceGeometry, fenceMaterial);
    fence.rotation.x = 0;//Math.PI / 2; // افقی کردن
    fence.position.y = -0.5; // شروع از زیر زمین
    fence.visible = false;

    model.add(fence);
    return fence;
  };

  const createFenceEffectRed = (model) => {
    // Create a rectangular fence around the model
    const fenceGeometry = new THREE.BoxGeometry(4, 1, 4); // عرض (x)، ارتفاع (y)، عمق (z)
    const fenceMaterial = new THREE.MeshBasicMaterial({
      color: 0xff00ff,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.5,
      wireframe: true
    });

    const fence = new THREE.Mesh(fenceGeometry, fenceMaterial);
    fence.position.y = -0.5; // شروع از زیر زمین
    fence.visible = false;

    model.add(fence);
    return fence;
  };

  // ایجاد مدل هاور
  const createHoverModel = (mainModel) => {
    const loader = new GLTFLoader();
    loader.load('/models/x.glb', (gltf) => {
      const hoverModel = gltf.scene;
      hoverModel.visible = false; // در ابتدا مخفی باشد
      hoverModel.position.copy(mainModel.position); // موقعیت مشابه مدل اصلی
      hoverModel.scale.set(1, 1, 1); // مقیاس دلخواه
      mainModel.scene.add(hoverModel); // اضافه کردن به صحنه اصلی
      mainModel.userData.hoverModel = hoverModel; // ذخیره برای دسترسی بعدی
    });
  };

  const createOpenModelEffect = (mainModel) => {
    const loader = new GLTFLoader();
    loader.load(
      '/models/mab0626/react3.glb',
      //'/models/open/react2b.glb',
      (gltf) => {
        const fenceModel = gltf.scene;
        console.log('فنس بارگذاری شد:', fenceModel); // بررسی بارگذاری
        fenceModel.visible = false;
        fenceModel.position.set(0, 0.5, 0);
        fenceModel.scale.set(1, 1, 1);
        mainModel.add(fenceModel);

        fenceModel.traverse((child) => {
          if (child.isMesh) {
            child.material.transparent = true;
            child.material.opacity = 0;
            console.log('متریال اعمال شد:', child.material);
          }
        });

        mainModel.userData.fence = fenceModel;

        mainModel.userData.animateFence = () => {
          if (fenceModel.position.y < 0.5) {
            fenceModel.position.y += 0.05;
            fenceModel.traverse((child) => {
              if (child.isMesh) {
                child.material.opacity = Math.min(0.7, child.material.opacity + 0.02);
              }
            });
            requestAnimationFrame(mainModel.userData.animateFence);
          }
        };

        mainModel.userData.hideFence = () => {
          if (fenceModel.position.y > -0.5) {
            fenceModel.position.y -= 0.05;
            fenceModel.traverse((child) => {
              if (child.isMesh) {
                child.material.opacity = Math.max(0, child.material.opacity - 0.02);
              }
            });
            requestAnimationFrame(mainModel.userData.hideFence);
          } else {
            fenceModel.visible = false;
          }
        };
      },
      undefined,
      (error) => {
        console.error('خطا در بارگذاری فنس:', error); // لاگ خطا
      }
    );
  };

  const cloudRef = useRef(null);

  const createCloudTexture = () => {
  // const canvas = document.createElement("canvas");
  // canvas.width = 256;
  // canvas.height = 256;
  // const ctx = canvas.getContext("2d");

  // // گرادیان بسیار نرم برای شکل ابر
  // const g = ctx.createRadialGradient(128, 128, 20, 128, 128, 128);
  // g.addColorStop(0, "rgba(255,255,255,0.55)");
  // g.addColorStop(0.5, "rgba(255,255,255,0.25)");
  // g.addColorStop(1, "rgba(255,255,255,0)");

  // ctx.fillStyle = g;
  // ctx.fillRect(0, 0, 256, 256);

  // return new THREE.CanvasTexture(canvas);
};

const createCloud = () => {
  // const cloudGeo = new THREE.PlaneGeometry(200, 120); // ابعاد بزرگ ابر
  // const cloudMat = new THREE.MeshLambertMaterial({
  //   map: createCloudTexture(),
  //   transparent: true,
  //   opacity: 0.52,
  //   depthWrite: false,
  //   blending: THREE.AdditiveBlending,
  //   side: THREE.DoubleSide
  // });

  // const cloud = new THREE.Mesh(cloudGeo, cloudMat);

  // // موقعیت اولیه
  // cloud.position.set(-3, 10, (Math.random() - 0.5) * 120);
  // // cloud.position.set(-250, 10, (Math.random() - 0.5) * 120);

  // cloud.rotation.x = -0.3;
  // cloud.rotation.z = Math.random() * Math.PI;

  // // سرعت تصادفی برای هر ابر
  // cloud.userData.speed = 0.05 + Math.random() * 0.15;

  // return cloud;
};

const updateCloud = () => {
  // const cloud = cloudRef.current;
  // if (!cloud) return;

  // cloud.position.x += cloud.userData.speed;

  // // اگر از صحنه خارج شد، از سمت دیگر وارد شود
  // //if (cloud.position.x > 260) {
  // if (cloud.position.x > 20) {
  //   // cloud.position.x = -260;
  //   cloud.position.x = -20;
  //   cloud.position.z = (Math.random() - 0.5) * 120;
  //   cloud.position.y = 8 + Math.random() * 6;

  //   cloud.userData.speed = 0.05 + Math.random() * 0.15; // سرعت جدید
  //   cloud.material.opacity = 0.15 + Math.random() * 0.15; // اپسیتی جدید
  // }
};


  const fogParticles = useRef(null);
  const fogGeometry = useRef(null);
  const fogMaterial = useRef(null);

  // const createFogEffect = () => {
  //   fogGeometry.current = new THREE.BufferGeometry();
  //   const count = 2000;

  //   const positions = new Float32Array(count * 3);
  //   const speeds = new Float32Array(count);

  //   for (let i = 0; i < count; i++) {
  //     const i3 = i * 3;

  //     positions[i3]     = (Math.random() - 0.5) * 200; // x
  //     positions[i3 + 1] = Math.random() * 10 + 1;      // y
  //     positions[i3 + 2] = (Math.random() - 0.5) * 200; // z

  //     speeds[i] = 0.01 + Math.random() * 0.02; // سرعت حرکت عمودی
  //   }

  //   fogGeometry.current.setAttribute("position", new THREE.BufferAttribute(positions, 3));
  //   fogGeometry.current.setAttribute("speed", new THREE.BufferAttribute(speeds, 1));

  //   fogMaterial.current = new THREE.PointsMaterial({
  //     color: 0xffffff,
  //     size: 4,
  //     transparent: true,
  //     opacity: 0.15,
  //     depthWrite: false,
  //     blending: THREE.AdditiveBlending,
  //     map: createFogTexture()
  //   });

  //   fogParticles.current = new THREE.Points(fogGeometry.current, fogMaterial.current);
  //   return fogParticles.current;
  // };

//   // fog v 2
//   const createFogEffect = () => {
//   fogGeometry.current = new THREE.BufferGeometry();
//   const count = 900; // کاهش تعداد ذرات برای طبیعی‌تر شدن

//   const positions = new Float32Array(count * 3);
//   const directions = new Float32Array(count * 3); // جهت حرکت تصادفی
//   const speeds = new Float32Array(count);

//   for (let i = 0; i < count; i++) {
//     const i3 = i * 3;

//     // موقعیت اولیه
//     positions[i3]     = (Math.random() - 0.5) * 250;  // X
//     positions[i3 + 1] = Math.random() * 10 + 1;       // Y
//     positions[i3 + 2] = (Math.random() - 0.5) * 250;  // Z

//     // جهت حرکت کاملاً رندوم در XYZ
//     directions[i3]     = (Math.random() - 0.5) * 1.0;
//     directions[i3 + 1] = (Math.random() - 0.5) * 0.8;
//     directions[i3 + 2] = (Math.random() - 0.5) * 1.0;

//     // سرعت بسیار کم و رندوم (بخار طبیعی)
//     speeds[i] = 0.001 + Math.random() * 0.004;
//   }

//   fogGeometry.current.setAttribute("position", new THREE.BufferAttribute(positions, 3));
//   fogGeometry.current.setAttribute("direction", new THREE.BufferAttribute(directions, 3));
//   fogGeometry.current.setAttribute("speed", new THREE.BufferAttribute(speeds, 1));

//   fogMaterial.current = new THREE.PointsMaterial({
//     color: 0xffffff,
//     size: 5,
//     transparent: true,
//     opacity: 0.7,   // 👈 بسیار کم تا اصلاً دانه دیده نشود
//     depthWrite: false,
//     blending: THREE.AdditiveBlending,
//     map: createFogTexture()
//   });

//   fogParticles.current = new THREE.Points(fogGeometry.current, fogMaterial.current);
//   return fogParticles.current;
// };

const createFogEffect = () => {
  if (!FOG_CONFIG.enabled) return null;

  const fogGroup = new THREE.Group();
  fogGroup.userData.isFogSystem = true;
  fogGroup.userData.isSnowSystem = true;

  const createFogLayerMaterial = (opacityMultiplier, uvOffset) => {
    return new THREE.ShaderMaterial({
      uniforms: {
        uTime: { value: 0 },
        uColor: { value: new THREE.Color(FOG_CONFIG.colorR, FOG_CONFIG.colorG, FOG_CONFIG.colorB) },
        uOpacity: { value: FOG_CONFIG.opacity * opacityMultiplier },
        uOpacityVariation: { value: FOG_CONFIG.opacityVariation },
        uNoiseScale: { value: FOG_CONFIG.noiseScale },
        uNoiseSoftness: { value: FOG_CONFIG.noiseSoftness },
        uSpeed: { value: new THREE.Vector2(FOG_CONFIG.speedX, FOG_CONFIG.speedZ) },
        uEdgeSoftness: { value: FOG_CONFIG.edgeSoftness },
        uUvOffset: { value: new THREE.Vector2(uvOffset.x, uvOffset.y) }
      },
      vertexShader: `
        varying vec2 vUv;

        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        precision mediump float;

        uniform float uTime;
        uniform vec3 uColor;
        uniform float uOpacity;
        uniform float uOpacityVariation;
        uniform float uNoiseScale;
        uniform float uNoiseSoftness;
        uniform vec2 uSpeed;
        uniform float uEdgeSoftness;
        uniform vec2 uUvOffset;

        varying vec2 vUv;

        float hash(vec2 p) {
          p = fract(p * vec2(123.34, 456.21));
          p += dot(p, p + 45.32);
          return fract(p.x * p.y);
        }

        float noise(vec2 p) {
          vec2 i = floor(p);
          vec2 f = fract(p);
          vec2 u = f * f * (3.0 - 2.0 * f);

          float a = hash(i + vec2(0.0, 0.0));
          float b = hash(i + vec2(1.0, 0.0));
          float c = hash(i + vec2(0.0, 1.0));
          float d = hash(i + vec2(1.0, 1.0));

          return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
        }

        float fbm(vec2 p) {
          float value = 0.0;
          float amp = 0.5;

          value += noise(p) * amp;
          p *= 2.03;
          amp *= 0.5;

          value += noise(p) * amp;
          p *= 2.01;
          amp *= 0.5;

          value += noise(p) * amp;
          return value;
        }

        void main() {
          vec2 fogUv = vUv * uNoiseScale + uUvOffset + uSpeed * uTime;
          float n = fbm(fogUv);

          float softNoise = smoothstep(0.5 - uNoiseSoftness, 0.5 + uNoiseSoftness, n);
          float alpha = uOpacity + softNoise * uOpacityVariation;

          float edgeX = smoothstep(0.0, uEdgeSoftness, vUv.x) * smoothstep(0.0, uEdgeSoftness, 1.0 - vUv.x);
          float edgeY = smoothstep(0.0, uEdgeSoftness, vUv.y) * smoothstep(0.0, uEdgeSoftness, 1.0 - vUv.y);
          alpha *= edgeX * edgeY;

          gl_FragColor = vec4(uColor, alpha);
        }
      `,
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: THREE.DoubleSide,
      blending: THREE.NormalBlending,
      toneMapped: false
    });
  };

  const fogGeometryLocal = new THREE.PlaneGeometry(FOG_CONFIG.areaWidth, FOG_CONFIG.areaDepth, 1, 1);

  const lowerMaterial = createFogLayerMaterial(1.0, { x: 0.0, y: 0.0 });
  const upperMaterial = createFogLayerMaterial(0.55, { x: 12.37, y: 4.91 });

  const lowerFog = new THREE.Mesh(fogGeometryLocal, lowerMaterial);
  lowerFog.rotation.x = -Math.PI / 2;
  lowerFog.position.y = FOG_CONFIG.lowerHeight;
  lowerFog.renderOrder = 1;
  lowerFog.userData.isFogSystem = true;
  lowerFog.userData.isSnowSystem = true;

  const upperFog = new THREE.Mesh(fogGeometryLocal, upperMaterial);
  upperFog.rotation.x = -Math.PI / 2;
  upperFog.position.y = FOG_CONFIG.upperHeight;
  upperFog.renderOrder = 1;
  upperFog.userData.isFogSystem = true;
  upperFog.userData.isSnowSystem = true;

  fogGroup.add(lowerFog);
  fogGroup.add(upperFog);

  fogParticles.current = fogGroup;
  fogGeometry.current = fogGeometryLocal;
  fogMaterial.current = [lowerMaterial, upperMaterial];

  fogGroup.userData.update = (delta = 0.016) => {
    lowerMaterial.uniforms.uTime.value += delta;
    upperMaterial.uniforms.uTime.value += delta * 0.72;
  };

  return fogGroup;
};

const createFogTexture = () => {
  return null;
};

const updateFog = (delta = 0.016) => {
  if (!FOG_CONFIG.enabled || !fogParticles.current?.userData?.update) return;
  fogParticles.current.userData.update(delta);
};



  const snowParticles = useRef(null);
  const snowGeometry = useRef(null);
  const snowMaterial = useRef(null);
  const settledSnowParticles = useRef(null);
  const settledSnowGeometry = useRef(null);
  const settledSnowMaterial = useRef(null);

  const createSnowTexture = () => {
    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;

    const context = canvas.getContext('2d');
    const gradient = context.createRadialGradient(16, 16, 0, 16, 16, 16);
    gradient.addColorStop(0.0, 'rgba(255,255,255,1)');
    gradient.addColorStop(0.45, 'rgba(255,255,255,0.92)');
    gradient.addColorStop(0.78, 'rgba(255,255,255,0.22)');
    gradient.addColorStop(1.0, 'rgba(255,255,255,0)');

    context.fillStyle = gradient;
    context.fillRect(0, 0, 32, 32);

    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;
    return texture;
  };

  const createSnowMaterial = (texture) => {
    return new THREE.ShaderMaterial({
      uniforms: {
        pointTexture: { value: texture }
      },
      vertexShader: `
        attribute float aSize;
        attribute float aAlpha;
        varying float vAlpha;

        void main() {
          vAlpha = aAlpha;
          vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
          gl_PointSize = aSize * (260.0 / max(1.0, -mvPosition.z));
          gl_Position = projectionMatrix * mvPosition;
        }
      `,
      fragmentShader: `
        uniform sampler2D pointTexture;
        varying float vAlpha;

        void main() {
          vec4 tex = texture2D(pointTexture, gl_PointCoord);
          float alpha = tex.a * vAlpha;
          if (alpha < 0.01) discard;
          gl_FragColor = vec4(1.0, 1.0, 1.0, alpha);
        }
      `,
      transparent: true,
      depthWrite: false,
      depthTest: true,
      blending: THREE.NormalBlending
    });
  };

  const createSnowEffect = (sceneForSnow) => {
    if (!SNOW_CONFIG.enabled) return null;

    const particleCount = Math.max(1, Math.floor(SNOW_CONFIG.amount));
    const settledCount = Math.max(1, Math.floor(SNOW_CONFIG.maxSettled));

    const snowTexture = createSnowTexture();
    const group = new THREE.Group();
    group.userData.isSnowSystem = true;

    snowGeometry.current = new THREE.BufferGeometry();
    settledSnowGeometry.current = new THREE.BufferGeometry();

    const positions = new Float32Array(particleCount * 3);
    const sizes = new Float32Array(particleCount);
    const alphas = new Float32Array(particleCount);
    const landingY = new Float32Array(particleCount);
    const velocities = new Float32Array(particleCount);
    const wobble = new Float32Array(particleCount);
    const windVariationX = new Float32Array(particleCount);
    const windVariationZ = new Float32Array(particleCount);

    const settledPositions = new Float32Array(settledCount * 3);
    const settledSizes = new Float32Array(settledCount);
    const settledAlphas = new Float32Array(settledCount);
    const settledAge = new Float32Array(settledCount);
    const settledActive = new Uint8Array(settledCount);

    const raycaster = new THREE.Raycaster();
    const rayDirection = new THREE.Vector3(0, -1, 0);
    const rayOrigin = new THREE.Vector3();
    const snowTargets = [];
    const landingCache = new Map();

    let snowTime = 0;
    let frameCounter = 0;
    let settledCursor = 0;
    let fallingVisualNeedsUpdate = false;
    let settledVisualNeedsUpdate = false;

    const isMaterialHidden = (material) => {
      if (!material) return false;
      const materials = Array.isArray(material) ? material : [material];
      return materials.length > 0 && materials.every((mat) => mat && mat.transparent === true && mat.opacity <= 0.05);
    };

    const isMaterialWireframe = (material) => {
      if (!material) return false;
      const materials = Array.isArray(material) ? material : [material];
      return materials.some((mat) => mat && mat.wireframe === true);
    };

    const refreshSnowTargets = () => {
      snowTargets.length = 0;
      landingCache.clear();
      if (!sceneForSnow) return;

      sceneForSnow.updateMatrixWorld(true);
      sceneForSnow.traverse((object) => {
        if (!object || !object.isMesh || !object.visible) return;
        if (object.userData?.isSnowSystem || object.userData?.isCollider) return;
        if (!object.geometry || isMaterialHidden(object.material) || isMaterialWireframe(object.material)) return;
        snowTargets.push(object);
      });
    };

    const getLandingY = (x, z) => {
      const cellSize = Math.max(0.001, SNOW_CONFIG.surfaceCacheCellSize || 5);
      const key = `${Math.round(x / cellSize)}_${Math.round(z / cellSize)}`;

      if (landingCache.has(key)) {
        return landingCache.get(key);
      }

      let y = SNOW_CONFIG.groundY + SNOW_CONFIG.landingOffset;

      if (SNOW_CONFIG.maxRaycastDistance > 0 && snowTargets.length > 0) {
        rayOrigin.set(x, SNOW_CONFIG.spawnHeightMax + 5, z);
        raycaster.set(rayOrigin, rayDirection);
        raycaster.far = SNOW_CONFIG.maxRaycastDistance;

        const hits = raycaster.intersectObjects(snowTargets, false);
        if (hits.length > 0 && hits[0].point) {
          y = hits[0].point.y + SNOW_CONFIG.landingOffset;
        }
      }

      landingCache.set(key, y);
      return y;
    };

    const resetFallingParticle = (index, randomHeight = true) => {
      const i3 = index * 3;
      const x = (Math.random() - 0.5) * SNOW_CONFIG.areaWidth;
      const z = (Math.random() - 0.5) * SNOW_CONFIG.areaDepth;
      const y = randomHeight
        ? SNOW_CONFIG.spawnHeightMin + Math.random() * (SNOW_CONFIG.spawnHeightMax - SNOW_CONFIG.spawnHeightMin)
        : SNOW_CONFIG.spawnHeightMax + Math.random() * 5;

      positions[i3] = x;
      positions[i3 + 1] = y;
      positions[i3 + 2] = z;

      landingY[index] = getLandingY(x, z);
      velocities[index] = SNOW_CONFIG.fallSpeed * (0.75 + Math.random() * 0.5);
      sizes[index] = SNOW_CONFIG.flakeSizeMin + Math.random() * (SNOW_CONFIG.flakeSizeMax - SNOW_CONFIG.flakeSizeMin);
      alphas[index] = SNOW_CONFIG.flakeOpacity * (0.62 + Math.random() * 0.38);
      wobble[index] = Math.random() * Math.PI * 2;
      windVariationX[index] = (Math.random() - 0.5) * SNOW_CONFIG.windRandomness;
      windVariationZ[index] = (Math.random() - 0.5) * SNOW_CONFIG.windRandomness;
      fallingVisualNeedsUpdate = true;
    };

    const spawnSettledSnow = (x, y, z, size, alpha) => {
      const index = settledCursor;
      const i3 = index * 3;

      settledPositions[i3] = x;
      settledPositions[i3 + 1] = y;
      settledPositions[i3 + 2] = z;
      settledSizes[index] = Math.max(SNOW_CONFIG.flakeSizeMin * 0.65, size * 0.78);
      settledAlphas[index] = Math.min(SNOW_CONFIG.flakeOpacity, alpha * 0.9);
      settledAge[index] = 0;
      settledActive[index] = 1;
      settledVisualNeedsUpdate = true;

      settledCursor = (settledCursor + 1) % settledCount;
    };

    refreshSnowTargets();

    for (let i = 0; i < particleCount; i++) {
      resetFallingParticle(i, true);
    }

    for (let i = 0; i < settledCount; i++) {
      const i3 = i * 3;
      settledPositions[i3] = 0;
      settledPositions[i3 + 1] = -9999;
      settledPositions[i3 + 2] = 0;
      settledSizes[i] = 0;
      settledAlphas[i] = 0;
      settledAge[i] = 0;
      settledActive[i] = 0;
    }

    snowGeometry.current.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    snowGeometry.current.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1));
    snowGeometry.current.setAttribute('aAlpha', new THREE.BufferAttribute(alphas, 1));

    settledSnowGeometry.current.setAttribute('position', new THREE.BufferAttribute(settledPositions, 3));
    settledSnowGeometry.current.setAttribute('aSize', new THREE.BufferAttribute(settledSizes, 1));
    settledSnowGeometry.current.setAttribute('aAlpha', new THREE.BufferAttribute(settledAlphas, 1));

    snowMaterial.current = createSnowMaterial(snowTexture);
    settledSnowMaterial.current = createSnowMaterial(snowTexture);

    const fallingPoints = new THREE.Points(snowGeometry.current, snowMaterial.current);
    const settledPoints = new THREE.Points(settledSnowGeometry.current, settledSnowMaterial.current);

    fallingPoints.frustumCulled = false;
    settledPoints.frustumCulled = false;
    fallingPoints.userData.isSnowSystem = true;
    settledPoints.userData.isSnowSystem = true;

    group.add(fallingPoints);
    group.add(settledPoints);

    snowParticles.current = fallingPoints;
    settledSnowParticles.current = settledPoints;

    fallingVisualNeedsUpdate = false;
    settledVisualNeedsUpdate = false;

    group.userData.update = (delta) => {
      snowTime += delta;
      frameCounter++;

      if (frameCounter % Math.max(1, SNOW_CONFIG.targetRefreshFrames) === 0) {
        refreshSnowTargets();
      }

      const halfWidth = SNOW_CONFIG.areaWidth * 0.5;
      const halfDepth = SNOW_CONFIG.areaDepth * 0.5;

      for (let i = 0; i < particleCount; i++) {
        const i3 = i * 3;

        positions[i3] += (SNOW_CONFIG.windX + windVariationX[i]) * delta * 60;
        positions[i3 + 2] += (SNOW_CONFIG.windZ + windVariationZ[i]) * delta * 60;
        positions[i3] += Math.sin(snowTime * 1.35 + wobble[i]) * 0.0018 * delta * 60;
        positions[i3 + 2] += Math.cos(snowTime * 1.05 + wobble[i]) * 0.0018 * delta * 60;
        positions[i3 + 1] -= velocities[i] * delta * 60;

        if (positions[i3] < -halfWidth || positions[i3] > halfWidth || positions[i3 + 2] < -halfDepth || positions[i3 + 2] > halfDepth) {
          resetFallingParticle(i, false);
          continue;
        }

        if (positions[i3 + 1] <= landingY[i]) {
          spawnSettledSnow(positions[i3], landingY[i], positions[i3 + 2], sizes[i], alphas[i]);
          resetFallingParticle(i, false);
        }
      }

      const totalSettleFade = Math.max(0.001, SNOW_CONFIG.settleTime + SNOW_CONFIG.fadeTime);
      for (let i = 0; i < settledCount; i++) {
        if (!settledActive[i]) continue;

        settledAge[i] += delta;

        if (settledAge[i] <= SNOW_CONFIG.settleTime) {
          continue;
        }

        const fadeProgress = Math.min(1, (settledAge[i] - SNOW_CONFIG.settleTime) / Math.max(0.001, SNOW_CONFIG.fadeTime));
        settledAlphas[i] = SNOW_CONFIG.flakeOpacity * (1 - fadeProgress);

        if (settledAge[i] >= totalSettleFade) {
          const i3 = i * 3;
          settledActive[i] = 0;
          settledAlphas[i] = 0;
          settledPositions[i3 + 1] = -9999;
        }
      }

      snowGeometry.current.attributes.position.needsUpdate = true;
      if (fallingVisualNeedsUpdate) {
        snowGeometry.current.attributes.aSize.needsUpdate = true;
        snowGeometry.current.attributes.aAlpha.needsUpdate = true;
        fallingVisualNeedsUpdate = false;
      }

      settledSnowGeometry.current.attributes.position.needsUpdate = true;
      settledSnowGeometry.current.attributes.aAlpha.needsUpdate = true;
      if (settledVisualNeedsUpdate) {
        settledSnowGeometry.current.attributes.aSize.needsUpdate = true;
        settledVisualNeedsUpdate = false;
      }
    };

    return group;
  };

  const updateSnowParticles = (delta) => {
    const snowSystem = snowParticles.current?.parent;
    if (!snowSystem?.userData?.update) return;
    snowSystem.userData.update(delta || 0.016);
  };

  useEffect(() => {
    let isMounted = true;
    const maxLoadTime = 60000;
    let loadTimeout;
    let loadedModelsCount = 0;
    let expectedModelLoads = 0;
    let modelLoadRegistrationComplete = false;
    let finalLoadStarted = false;
    let localHumanModel = null;
    const boxes = [];
    let collidedBox = null;

    let scene = null;
    let camera = null;
    let renderer = null;
    let world = null;
    let humanMixer = null;
    let idleAction = null;
    let walkAction = null;
    let humanBody = null;
    let humanBox = null;
    let isWalking = false;
    let humanRotationAngle = 0;
    let zoomLevel = 2;
    let isMouseControlling = false;
    let isTouchingControlling = false;
    let mouseX = 0;
    let mouseY = 0;
    let targetPosition = new THREE.Vector3(0, 1, 0);

    let snowBallModel = null;
    let snowBallState = null;
    const mainLogoModels = [];

    let directionalLight = new THREE.DirectionalLight(MAIN_LIGHT_CONFIG.directionalColor, MAIN_LIGHT_CONFIG.directionalIntensity);

let isTelegramBotTransparent = false;
const triggerRadius = 1;
const triggerPosition = new THREE.Vector3(0, 0, 0); // نقطه مورد نظر

let originalOpacities = new Map();

    let localAIagentModel, localARboardModel, localARframeModel, localInteractiveModel, localMetawebModel,
        localTelegrambotModel, localUseYourModel, localXModel, localTreeModel,localBilboardModel,
        localinstagramSocialModel, localtelegramSocialModel, localxSocialModel, localemailSocialModel,
        localdrone1Model, localdrone2Model,
        localXlab1XModel, localXlab1LModel, localXlab1AModel, localXlab1BModel,
        localXlab2XModel, localXlab2LModel, localXlab2AModel, localXlab2BModel,
        localXlab3XModel, localXlab3LModel, localXlab3AModel, localXlab3BModel,
        localXlab4XModel, localXlab4LModel, localXlab4AModel, localXlab4BModel,
        localOpenAIagentModel, localOpenARboardModel, localOpenARframeModel, localOpenInteractiveModel, localOpenMetawebModel,localOpenTelegrambotModel,
        localOpeninstagramSocialModel, localOpentelegramSocialModel, localOpenxSocialModel, localOpenemailSocialModel,
        localwall1Model, localwall2Model,
        localSphareModel,
        localAIagenttxtModel, localARboardtxtModel, localARframetxtModel, localInteractivetxtModel, localMetawebtxtModel, localTelegrambottxtModel = null;

    let aIagentBox, aRboardBox, aRframeBox, interactiveBox, metawebBox, telegrambotBox, useYourBox, xBox, treeBox, bilboardBox,
        instagramSocialBox, telegramSocialBox, xSocialBox, emailSocialBox,
        drone1Box, drone2Box,
        xlab1XBox, xlab1LBox, xlab1ABox, xlab1BBox,
        xlab2XBox, xlab2LBox, xlab2ABox, xlab2BBox,
        xlab3XBox, xlab3LBox, xlab3ABox, xlab3BBox,
        xlab4XBox, xlab4LBox, xlab4ABox, xlab4BBox,
        openAIagentBox, openARboardBox, openARframeBox, openInteractiveBox, openMetawebBox, openTelegrambotBox,
        openinstagramSocialBox, opentelegramSocialBox, openxSocialBox, openemailSocialBox,
        wall1Box, wall2Box,
        sphareBox,
        aIagenttxtBox, aRboardtxtBox, aRframetxtBox, interactivetxtBox, metawebtxtBox, telegrambottxtBox;

    let aIagentBody, aRboardBody, aRframeBody, interactiveBody, metawebBody, telegrambotBody, useYourBody, xBody, treeBody, bilboardBody,
        instagramSocialBody, telegramSocialBody, xSocialBody, emailSocialBody,
        drone1Body, drone2Body,
        xlab1XBody, xlab1LBody, xlab1ABody, xlab1BBody,
        xlab2XBody, xlab2LBody, xlab2ABody, xlab2BBody,
        xlab3XBody, xlab3LBody, xlab3ABody, xlab3BBody,
        xlab4XBody, xlab4LBody, xlab4ABody, xlab4BBody,
        openAIagentBody, openARboardBody, openARframeBody, openInteractiveBody, openMetawebBody, openTelegrambotBody,
        openinstagramSocialBody, opentelegramSocialBody, openxSocialBody, openemailSocialBody,
        wall1Body, wall2Body,
        sphareBody,
        aIagenttxtBody, aRboardtxtBody, aRframetxtBody, interactivetxtBody, metawebtxtBody, telegrambottxtBody;

    let aIagentMixer, aRboardMixer, aRframeMixer, interactiveMixer, metawebMixer, telegrambotMixer, useYourMixer, xMixer, treeMixer, bilboardMixer,
        instagramSocialMixer, telegramSocialMixer, xSocialMixer, emailSocialMixer,
        drone1Mixer, drone2Mixer,
        xlab1XMixer, xlab1LMixer, xlab1AMixer, xlab1BMixer,
        xlab2XMixer, xlab2LMixer, xlab2AMixer, xlab2BMixer,
        xlab3XMixer, xlab3LMixer, xlab3AMixer, xlab3BMixer,
        xlab4XMixer, xlab4LMixer, xlab4AMixer, xlab4BMixer,
        openAIagentMixer, openARboardMixer, openARframeMixer, openInteractiveMixer, openMetawebMixer,openTelegrambotMixer,
        openinstagramSocialMixer, opentelegramSocialMixer, openxSocialMixer, openemailSocialMixer,
        wall1Mixer, wall2Mixer,
        sphareMixer,
        aIagenttxtMixer, aRboardtxtMixer, aRframetxtMixer, interactivetxtMixer, metawebtxtMixer, telegrambottxtMixer;

    let aIagentAnimations, aRboardAnimations, aRframeAnimations, interactiveAnimations, metawebAnimations,
        telegrambotAnimations, useYourAnimations, xAnimations, treeAnimations, bilboardAnimations,
        instagramSocialAnimations, telegramSocialAnimations, xSocialAnimations, emailSocialAnimations,
        drone1Animations, drone2Animations,
        xlab1XAnimations, xlab1LAnimations, xlab1AAnimations, xlab1BAnimations,
        xlab2XAnimations, xlab2LAnimations, xlab2AAnimations, xlab2BAnimations,
        xlab3XAnimations, xlab3LAnimations, xlab3AAnimations, xlab3BAnimations,
        xlab4XAnimations, xlab4LAnimations, xlab4AAnimations, xlab4BAnimations,
        openAIagentAnimations, openARboardAnimations, openARframeAnimations, openInteractiveAnimations, openMetawebAnimations, openTelegrambotAnimations,
        openinstagramSocialAnimations, opentelegramSocialAnimations, openxSocialAnimations, openemailSocialAnimations,
        wall1Animations, wall2Animations,
        sphareAnimations,
        aIagenttxtAnimations, aRboardtxtAnimations, aRframetxtAnimations, interactivetxtAnimations, metawebtxtAnimations,
        telegrambottxtAnimations = [];

    const interactiveModels = [
    // {
    //   name: 'OpenAIagent',
    //   modelRef: () => localOpenAIagentModel,
    //   mixer: () => openAIagentMixer,
    //   link: '/viewModel?modelref=aiagent',
    //   external: false
    // },
    // {
    //   name: 'OpenTelegrambot',
    //   modelRef: () => localOpenTelegrambotModel,
    //   mixer: () => openTelegrambotMixer,
    //   link: '/viewModel?modelref=telegrambot',
    //   external: false
    // },
    // {
    //   name: 'OpeninstagramSocial',
    //   modelRef: () => localOpeninstagramSocialModel,
    //   mixer: null,
    //   link: 'https://instagram.com',
    //   external: true
    // },
    // // ادامه مدل‌ها ...
    ];

                const humanEnvTextureLoader = new THREE.TextureLoader();
let humanEnvTexture = null;

// بارگذاری HDR مخصوص مدل انسانی
humanEnvTextureLoader.load(
  '/textures/mab/humanspecifichdr.jpg', // مسیر HDR مخصوص
  (texture) => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    humanEnvTexture = texture;
    
    // اعمال HDR روی مدل انسانی پس از بارگذاری
    if (localHumanModel) {
      applyHumanSpecificEnvMap(localHumanModel, humanEnvTexture);
    }
  }
);
const applyHumanSpecificEnvMap = (model, envMap) => {
  model.traverse((node) => {
    if (node.isMesh && node.material) {
      if (node.material.isMeshStandardMaterial || node.material.isMeshPhysicalMaterial) {
        // غیرفعال کردن envMap از صحنه عمومی
        node.material.envMap = envMap;
        node.material.envMapIntensity = 3.0; // مقدار دلخواه
        node.material.needsUpdate = true;
      }
    }
  });
};

    const loadHDRTexture = (path) => {
      return new Promise((resolve, reject) => {
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(
          path,
          (texture) => {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            resolve(texture);
          },
          undefined,
          (err) => {
            reject(err);
          }
        );
      });
    };

//     const checkProximityAndChangeOpacity = () => {
//   if (!localHumanModel || !localTelegrambotModel) return;

//   const humanPosition = new THREE.Vector3();
//   localHumanModel.getWorldPosition(humanPosition);
  
//   // محاسبه فاصله از نقطه مورد نظر
//   const distance = humanPosition.distanceTo(triggerPosition);
  
//   // اگر در شعاع مورد نظر هستیم و هنوز opacity تغییر نکرده
//   if (distance <= triggerRadius && !isTelegramBotTransparent) {
//     // تغییر opacity مدل telegrambot به نصف
//     localTelegrambotModel.traverse((node) => {
//       if (node.isMesh && node.material) {
//         node.material.transparent = true;
//         node.material.opacity = 0.5;
//         node.material.needsUpdate = true;
//       }
//     });
//     isTelegramBotTransparent = true;
//     console.log('TelegramBot opacity changed to 0.5');
//   }
//   // اگر از شعاع خارج شدیم و opacity تغییر کرده
//   else if (distance > triggerRadius && isTelegramBotTransparent) {
//     // بازگرداندن opacity به حالت اولیه (1)
//     localTelegrambotModel.traverse((node) => {
//       if (node.isMesh && node.material) {
//         node.material.opacity = 1;
//         node.material.needsUpdate = true;
//         // اگر materialهای دیگر transparent نبودند، آن را به حالت قبل برگردانید
//         if (node.material.opacity === 1) {
//           node.material.transparent = false;
//         }
//       }
//     });
//     isTelegramBotTransparent = false;
//     console.log('TelegramBot opacity restored to 1');
//   }
// };

const checkProximityAndChangeOpacity = () => {
  // if (!localHumanModel || !localTelegrambotModel) return;

  // const humanPosition = new THREE.Vector3();
  // localHumanModel.getWorldPosition(humanPosition);
  
  // const distance = humanPosition.distanceTo(triggerPosition);
  
  // if (distance <= triggerRadius && !isTelegramBotTransparent) {
  //   // ذخیره opacityهای اصلی و اعمال opacity جدید
  //   localTelegrambotModel.traverse((node) => {
  //     if (node.isMesh && node.material) {
  //       // ذخیره opacity اصلی
  //       originalOpacities.set(node, node.material.opacity);
        
  //       node.material.transparent = true;
  //       node.material.opacity = 0.5;
  //       node.material.needsUpdate = true;
  //     }
  //   });
  //   isTelegramBotTransparent = true;
  // }
  // else if (distance > triggerRadius && isTelegramBotTransparent) {
  //   // بازگرداندن opacityهای اصلی
  //   localTelegrambotModel.traverse((node) => {
  //     if (node.isMesh && node.material && originalOpacities.has(node)) {
  //       const originalOpacity = originalOpacities.get(node);
  //       node.material.opacity = originalOpacity;
  //       node.material.needsUpdate = true;
        
  //       // فقط اگر opacity اصلی 1 نبود، transparent را true نگه دارید
  //       if (originalOpacity === 1) {
  //         node.material.transparent = false;
  //       }
  //     }
  //   });
  //   isTelegramBotTransparent = false;
  //   originalOpacities.clear(); // پاک کردن map برای استفاده بعدی
  // }
};


    const updateLoadingProgress = () => {
      if (expectedModelLoads <= 0) {
        setProgress(0);
        return;
      }

      // Keep 100% reserved for the moment when every model AND the HDR are fully ready.
      const newProgress = Math.min(99, Math.floor((loadedModelsCount / expectedModelLoads) * 100));
      setProgress(newProgress);
    };

    const registerModelLoad = () => {
      expectedModelLoads++;
      updateLoadingProgress();
    };

    const checkAllLoaded = async () => {
      if (finalLoadStarted) return;
      if (!modelLoadRegistrationComplete) return;
      if (expectedModelLoads <= 0) return;
      if (loadedModelsCount < expectedModelLoads) return;

      finalLoadStarted = true;

      try {
        const envTexture = await loadHDRTexture('/textures/mab/hdr.jpg');
        scene.environment = envTexture;

        // تنظیم شدت environment برای همه مواد
        scene.traverse((object) => {
          if (object.isMesh && object.material) {
            if (object.material.isMeshStandardMaterial || object.material.isMeshPhysicalMaterial) {
              object.material.envMapIntensity = MAIN_RENDERER_CONFIG.environmentMapIntensity; // مقدار قابل تنظیم
            }
          }
        });

        // تنظیم tone mapping برای renderer
        renderer.toneMapping = MAIN_RENDERER_CONFIG.toneMapping;
        renderer.toneMappingExposure = MAIN_RENDERER_CONFIG.toneMappingExposure;

        setIsHDRLoaded(true);

        // اعمال environment map مخصوص مدل انسانی اگر قبلاً بارگذاری شده
        if (humanEnvTexture && localHumanModel) {
          applyHumanSpecificEnvMap(localHumanModel, humanEnvTexture);
        }

        setProgress(100);
        setLoading(false);
        clearTimeout(loadTimeout);
        setShowStartScreen(true);
        console.log('All models and HDR loaded');
      } catch (err) {
        finalLoadStarted = false;
        console.error('Error loading environment texture:', err.message || err);
        setError('Failed to load environment texture. Check the file path.');
        setLoading(false);
      }
    };

    const updateProgress = async () => {
      loadedModelsCount++;
      updateLoadingProgress();
      await checkAllLoaded();
    };

    loadTimeout = setTimeout(() => {
      if (isMounted && loading) {
        setError('Loading models took too long. Please check your internet connection or file paths.');
        setLoading(false);
        console.error('Loading timeout: Models not loaded');
      }
    }, maxLoadTime);

    const updateCameraPosition = () => {
      const humanBody = humanBodyRef.current;
      if (localHumanModel && humanBody) {
        const zoomDistances = MAIN_CAMERA_CONFIG.zoomDistances;
        const currentZoomDistance = zoomDistances[zoomLevel - 1];

        // تعریف زاویه‌های دلخواه (اینجا می‌توانید تغییر دهید)
    const theta = MAIN_CAMERA_CONFIG.orbitThetaDeg;  // زاویه افقی نسبت به شرق-غرب (در درجه، 0=شرق، 45=شمال‌شرقی، 90=شمال)
    const phi = MAIN_CAMERA_CONFIG.orbitPhiDeg; // زاویه ارتفاع

    const thetaRad = theta * Math.PI / 180; // تبدیل به رادیان
    const phiRad = phi * Math.PI / 180;

        if (isTouchingControlling || isMouseControlling) {
          camera.position.set(
            targetPosition.x + currentZoomDistance * Math.cos(thetaRad) * Math.cos(phiRad),
            targetPosition.y + currentZoomDistance * Math.sin(phiRad),
            targetPosition.z + currentZoomDistance * Math.sin(thetaRad) * Math.cos(phiRad)
          );
          camera.lookAt(targetPosition);
        } else {
          targetPosition.set(humanBody.position.x, MAIN_CAMERA_CONFIG.targetY, humanBody.position.z);
          camera.position.set(
            humanBody.position.x + currentZoomDistance * Math.cos(thetaRad) * Math.cos(phiRad),
            MAIN_CAMERA_CONFIG.targetY + currentZoomDistance * Math.sin(phiRad),
            humanBody.position.z + currentZoomDistance * Math.sin(thetaRad) * Math.cos(phiRad)
          );
          camera.lookAt(humanBody.position.x, MAIN_CAMERA_CONFIG.targetY, humanBody.position.z);
        }

        directionalLight.position.set(
          camera.position.x + MAIN_LIGHT_CONFIG.followCameraOffsetX,
          MAIN_LIGHT_CONFIG.followY,
          camera.position.z + MAIN_LIGHT_CONFIG.followCameraOffsetZ
        );
        directionalLight.target.position.set(
          humanBody.position.x,
          MAIN_LIGHT_CONFIG.targetY,
          humanBody.position.z
        );
        directionalLight.target.updateMatrixWorld();
      }
    };

    const handlePageShow = (event) => {
      const navType = window.performance.getEntriesByType("navigation")[0].type;
      if (event.persisted || navType === "back_forward") {
        console.log("🔄 برگشت به صفحه با back. ریست کردن صحنه...");
        callResetScene = true;
        // resetScene();
      }
    };
    window.addEventListener("pageshow", handlePageShow);

    const keysPressed = {};

    const handleKeyDown = (event) => {
      // جلوگیری از فعال شدن همزمان کلیدهای متضاد
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'w', 's', 'a', 'd'].includes(event.key)) {
        if (humanBodyRef.current && humanBodyRef.current.wakeUp) {
          humanBodyRef.current.wakeUp();
        }
      }

      if (event.key === 'ArrowLeft' || event.key === 'a') {
        keysPressed['ArrowRight'] = false;
        keysPressed['d'] = false;
      }

      if (event.key === 'ArrowRight' || event.key === 'd') {
        keysPressed['ArrowLeft'] = false;
        keysPressed['a'] = false;
      }

      keysPressed[event.key] = true;

      // Clear any existing timer for this key
      if (keyTimers[event.key]) {
        clearTimeout(keyTimers[event.key]);
      }

      console.log(`Key down: ${event.key}`);
      
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'w', 's', 'a', 'd'].includes(event.key)) {
        isMouseControlling = false;
      }
      if (event.key === 'Escape') {
        isMouseControlling = false;
        console.log('Mouse control disabled with Escape key');
      }
      
      // console.log(`collidedBox: ${collidedBox}`);
      // if (event.key === 'Enter' && collidedBox && collidedBox.hasLink) {
      //   window.open(collidedBox.link, '_blank');
      //   console.log(`Navigating to ${collidedBox.link} on Enter key press`);
      // }

      if (event.key === 'Enter') {
        interactiveModels.forEach(({ modelRef, link, external }) => {
          const model = modelRef();
          if (model && localHumanModel) {
            //const humanBox = new THREE.Box3().setFromObject(localHumanModel);
            const humanBox = new THREE.Box3().setFromObject(
  localHumanModel.userData.collider || localHumanModel
);

            const targetBox = new THREE.Box3().setFromObject(model);
            if (humanBox.intersectsBox(targetBox)) {
              window.open(link, external ? '_blank' : '_self');
              console.log(`Navigating to ${link} on Enter key press`);
            }
          }
        });
      }

    };

    const handleResize = () => {
      renderer.setSize(window.innerWidth, window.innerHeight);
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
    };

    const handleKeyUp = (event) => {
      keysPressed[event.key] = false;

      // Set a timer to ensure the key is properly released
  keyTimers[event.key] = setTimeout(() => {
    keysPressed[event.key] = false;
  }, 50);
  
      console.log(`Key up: ${event.key}`);
      if (
        !keysPressed['ArrowUp'] &&
        !keysPressed['ArrowDown'] &&
        !keysPressed['ArrowLeft'] &&
        !keysPressed['ArrowRight'] &&
        !keysPressed['w'] &&
        !keysPressed['s'] &&
        !keysPressed['a'] &&
        !keysPressed['d'] &&
        isWalking
      ) {
        if (walkAction) walkAction.stop();
        idleAction.play();
        isWalking = false;
      }
    };

    const handleClick = (event) => {
      const mouse = new THREE.Vector2();
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, camera);
      
      interactiveModels.forEach(({ modelRef, link, external }) => {
        const model = modelRef();
        if (model) {
          const intersects = raycaster.intersectObjects([model], true);
          if (intersects.length > 0) {
            window.open(link, external ? '_blank' : '_self');
          }
        }
      });

    };
    
    const handleWheel = (event) => {
      console.log(`Wheel detected: deltaY=${event.deltaY}`);
      if (event.deltaY < 0) {
        zoomLevel = Math.max(1, zoomLevel - 1);
      } else if (event.deltaY > 0) {
        zoomLevel = Math.min(3, zoomLevel + 1);
      }
      updateCameraPosition();
    };

    const handleMouseDown = (event) => {
      if (event.button === 0) {
        isMouseControlling = true;
        mouseX = event.clientX;
        mouseY = event.clientY;
        console.log(`Mouse control started, isMouseControlling: ${isMouseControlling}`);
      }
    };

    const handleMouseUp = () => {
      console.log(`Mouse released, isMouseControlling: ${isMouseControlling}`);
      document.getElementById('three-container').focus();
    };

    const handleMouseMove = (event) => {
      // تشخیص موقعیت ماوس و بررسی برخورد با مدل
      const mouse = new THREE.Vector2();
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    
      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, camera);
            
      // Reset previous outline
      if (localAIagentModel?.userData?.outline) {
        localAIagentModel.userData.outline.visible = false;
      }

      const intersectsAIagentModel = localAIagentModel ? raycaster.intersectObjects([localAIagentModel], true) : [];

      // // ریست افکت قبلی (برای همه مدل‌ها)
      // if (localOpenAIagentModel?.userData?.outline) {
      //   localOpenAIagentModel.userData.outline.visible = false;  // اضافه کردن برای مدل باز
      // }
      // // بررسی برخورد موس با مدل باز (OpenAIagent)
      // const intersectsOpenAIagentModel = localOpenAIagentModel ? raycaster.intersectObjects([localOpenAIagentModel], true) : [];
      // if (intersectsOpenAIagentModel.length > 0) {
      //   console.log('Mouse over OpenAIagent area');  // پیام کنسول برای موس
      //   if (localOpenAIagentModel.userData.outline) {
      //     localOpenAIagentModel.userData.outline.visible = true;  // نمایش outline
      //   }
      //   if (localOpenAIagentModel.userData.fence) {
      //     localOpenAIagentModel.userData.fence.visible = true;  // نمایش فنس
      //     localOpenAIagentModel.userData.animateFence();  // انیمیشن فنس
      //   }
      // } else {
      //   // مخفی کردن افکت وقتی موس خارج می‌شود
      //   if (localOpenAIagentModel.userData.fence) {
      //     localOpenAIagentModel.userData.hideFence();
      //   }
      // }

      // const intersectsAiboardModel = localARboardModel ? raycaster.intersectObjects([localARboardModel], true) : [];
      // const intersectsArframeModel = localARframeModel ? raycaster.intersectObjects([localARframeModel], true) : [];
      // const intersectsInteractiveModel = localInteractiveModel ? raycaster.intersectObjects([localInteractiveModel], true) : [];
      // const intersectsTelegrambotModel = localTelegrambotModel ? raycaster.intersectObjects([localTelegrambotModel], true) : [];
      // const intersectsMetawebModel = localMetawebModel ? raycaster.intersectObjects([localMetawebModel], true) : [];

      // const intersectsOpenAIagentModel = localOpenAIagentModel ? raycaster.intersectObjects([localOpenAIagentModel], true) : [];
      // const intersectsOpenARboardModel = localOpenARboardModel ? raycaster.intersectObjects([localOpenARboardModel], true) : [];
      // const intersectsOpenARframeModel = localOpenARframeModel ? raycaster.intersectObjects([localOpenARframeModel], true) : [];
      // const intersectsOpenInteractiveModel = localOpenInteractiveModel ? raycaster.intersectObjects([localOpenInteractiveModel], true) : [];
      // const intersectsOpenMetawebModel = localOpenMetawebModel ? raycaster.intersectObjects([localOpenMetawebModel], true) : [];
      // const intersectsOpenTelegrambotModel = localOpenTelegrambotModel ? raycaster.intersectObjects([localOpenTelegrambotModel], true) : [];
      
      // const intersectsOpeninstagramSocialModel = localOpeninstagramSocialModel ? raycaster.intersectObjects([localOpeninstagramSocialModel], true) : [];
      // const intersectsOpentelegramSocialModel = localOpentelegramSocialModel ? raycaster.intersectObjects([localOpentelegramSocialModel], true) : [];
      // const intersectsOpenxSocialModel = localOpenxSocialModel ? raycaster.intersectObjects([localOpenxSocialModel], true) : [];
      // const intersectsOpenemailSocialModel = localOpenemailSocialModel ? raycaster.intersectObjects([localOpenemailSocialModel], true) : [];
      
      // تغییر cursor بر اساس برخورد
      const canvas = document.getElementById('three-canvas');
      // if (canvas) {
      //   canvas.style.cursor = 
      //   // intersectsAIagentModel.length || intersectsAiboardModel.length || intersectsArframeModel.length || 
      //   // intersectsInteractiveModel.length || intersectsTelegrambotModel.length || intersectsMetawebModel.length
      //   // || 
      //   intersectsOpenAIagentModel.length|| intersectsOpenARframeModel.length || intersectsOpenARboardModel.length
      //   || intersectsOpenInteractiveModel.length || intersectsOpenMetawebModel.length || intersectsOpenTelegrambotModel.length
      //   || intersectsOpeninstagramSocialModel.length || intersectsOpentelegramSocialModel.length || intersectsOpenxSocialModel.length || intersectsOpenemailSocialModel.length
      //    > 0 ? 'pointer' : 'auto';
      // }
      const cursorShouldBePointer = interactiveModels.some(({ modelRef }) => {
        const model = modelRef();
        if (!model) return false;
        const intersects = raycaster.intersectObjects([model], true);
        return intersects.length > 0;
      });
      canvas.style.cursor = cursorShouldBePointer ? 'pointer' : 'auto';


      // Show outline when hovering
      if (intersectsAIagentModel.length > 0 && localAIagentModel?.userData?.outline) {
        localAIagentModel.userData.outline.visible = true;
      }

      if (isMouseControlling && event.buttons === 1) {
        const deltaX = event.clientX - mouseX;
        const deltaY = event.clientY - mouseY;

        // محاسبه جهت دید دوربین در صفحه افقی (xz)
        const cameraDirection = new THREE.Vector3();
        camera.getWorldDirection(cameraDirection);
        cameraDirection.y = 0; // فقط جهت افقی
        cameraDirection.normalize();

        // محاسبه بردار عمود بر جهت دوربین (برای حرکت چپ و راست)
        const rightVector = new THREE.Vector3();
        rightVector.crossVectors(cameraDirection, new THREE.Vector3(0, 1, 0)).normalize();

        // محاسبه حرکت در جهت‌های دوربین
        const moveX = rightVector.multiplyScalar(-deltaX * moveSpeed);
        const moveZ = cameraDirection.multiplyScalar(deltaY * moveSpeed);

        // اعمال حرکت به targetPosition
        targetPosition.add(moveX);
        targetPosition.add(moveZ);

        // محدود کردن targetPosition به حدود دیوارهای نامرئی
        const minX = -200;
        const maxX = 200;
        const minZ = -50;
        const maxZ = 50;
        targetPosition.x = Math.max(minX, Math.min(maxX, targetPosition.x));
        targetPosition.z = Math.max(minZ, Math.min(maxZ, targetPosition.z));

        mouseX = event.clientX;
        mouseY = event.clientY;
        console.log(`Camera target moved to: ${targetPosition.x}, ${targetPosition.z}`);
      }

      interactiveModels.forEach(({ modelRef, mixer, name, onEnter, onExit }) => {
        const model = modelRef();
        if (!model?.userData?.fence) return;

        const intersects = raycaster.intersectObjects([model], true);
        const isMouseOver = intersects.length > 0;
        model.userData.isMouseOverOpenTrigger = isMouseOver;

        const shouldShowOpenEffect = isMouseOver || model.userData.isAvatarOverOpenTrigger === true;

        if (shouldShowOpenEffect) {
          if (!model.userData.fence.visible) {
            if (onEnter) {
              onEnter(model);
            } else {
              model.userData.fence.visible = true;
              model.userData.fence.position.y = -0.5;
              model.userData.fence.traverse(child => {
                if (child.isMesh) child.material.opacity = 0;
              });
              model.userData.animateFence();
            }
            if (mixer) {
              const clock = new THREE.Clock();
              const delta = Math.min(clock.getDelta(), 0.1);
              mixer().update(delta);
            }
          }
          model.userData.isOpenEffectActive = true;
        } else if (model.userData.isOpenEffectActive) {
          if (onExit) {
            onExit(model);
          } else if (model.userData.fence.visible) {
            model.userData.hideFence();
          }
          model.userData.isOpenEffectActive = false;
        }
      });

    };

//     const handleTouchStart = (e) => {
//       e.preventDefault();
//       if (e.touches.length > 0) {
//         isTouchingControlling = true;
//         const touch = e.touches[0];
//         mouseX = touch.clientX;
//         mouseY = touch.clientY;
//         // ذخیره موقعیت اولیه targetPosition
//         if (targetPosition) {
//           savedTargetPosition.current = targetPosition.clone();
//           console.log('savedTargetPosition updated:', savedTargetPosition.current);
//         }
//         console.log(`Touch control started, isTouchingControlling: ${isTouchingControlling}`);
//       }
//     };

//     // const handleTouchMove = (e) => {
//     //   e.preventDefault();
//     //   if (isTouchingControlling && e.touches.length > 0) {
//     //     const touch = e.touches[0];
//     //     const deltaX = touch.clientX - mouseX;
//     //     const deltaY = touch.clientY - mouseY;
      
//     //     const cameraDirection = new THREE.Vector3();
//     //     camera.getWorldDirection(cameraDirection);
//     //     cameraDirection.y = 0;
//     //     cameraDirection.normalize();
      
//     //     const rightVector = new THREE.Vector3();
//     //     rightVector.crossVectors(cameraDirection, new THREE.Vector3(0, 1, 0)).normalize();
      
//     //     const moveX = rightVector.multiplyScalar(-deltaX * moveSpeed);
//     //     const moveZ = cameraDirection.multiplyScalar(-deltaY * moveSpeed);
      
//     //     // اعمال حرکت به savedTargetPosition
//     //     targetPosition.copy(savedTargetPosition).add(moveX).add(moveZ);
      
//     //     const minX = -200;
//     //     const maxX = 200;
//     //     const minZ = -50;
//     //     const maxZ = 50;
//     //     targetPosition.x = Math.max(minX, Math.min(maxX, targetPosition.x));
//     //     targetPosition.z = Math.max(minZ, Math.min(maxZ, targetPosition.z));
      
//     //     mouseX = touch.clientX;
//     //     mouseY = touch.clientY;
//     //     isMouseControlling = false;
//     //   }
//     // };

//     const handleTouchMove = (e) => {
//   e.preventDefault();
//   if (isTouchingControlling && e.touches.length > 0) {
//     const touch = e.touches[0];
    
//     // تبدیل مختصات لمس به مختصات نرمال‌شده (مانند ماوس)
//     const mouse = new THREE.Vector2();
//     mouse.x = (touch.clientX / window.innerWidth) * 2 - 1;
//     mouse.y = -(touch.clientY / window.innerHeight) * 2 + 1;


//     // مدیریت حرکت دوربین
//     if (isTouchingControlling) {
//       const deltaX = touch.clientX - mouseX;
//       const deltaY = touch.clientY - mouseY;

//       const cameraDirection = new THREE.Vector3();
//       camera.getWorldDirection(cameraDirection);
//       cameraDirection.y = 0;
//       cameraDirection.normalize();

//       const rightVector = new THREE.Vector3();
//       rightVector.crossVectors(cameraDirection, new THREE.Vector3(0, 1, 0)).normalize();

//       const moveX = rightVector.multiplyScalar(-deltaX * moveSpeed);
//       const moveZ = cameraDirection.multiplyScalar(-deltaY * moveSpeed);

//       targetPosition.copy(savedTargetPosition.current).add(moveX).add(moveZ);

//       const minX = -200;
//       const maxX = 200;
//       const minZ = -50;
//       const maxZ = 50;
//       targetPosition.x = Math.max(minX, Math.min(maxX, targetPosition.x));
//       targetPosition.z = Math.max(minZ, Math.min(maxZ, targetPosition.z));

//       mouseX = touch.clientX;
//       mouseY = touch.clientY;
//       isMouseControlling = false;

//       console.log(`Touch moved, camera target: ${targetPosition.x}, ${targetPosition.z}`);
//     }

//   }
// };

//     const handleTouchEnd = () => {
//       console.log(`Touch released, isTouchingControlling: ${isTouchingControlling}`);
//       isTouchingControlling = false;
//       document.getElementById('three-container').focus();
//     };


// کامنت برای کار کردن کلیک
// شروع لمس
  const handleTouchStart = (e) => {
    // e.preventDefault();
    // if (e.touches.length > 0) {
    //   isMouseControlling = false;
    //   isTouchingControlling = true;
    //   const touch = e.touches[0];
    //   mouseX = touch.clientX;
    //   mouseY = touch.clientY;
    //   savedTargetPosition.current.copy(targetPosition);
    //   console.log('Touch started, savedTargetPosition:', savedTargetPosition.current);
    // }
  };

  // حرکت لمس
  const handleTouchMove = (e) => {
    // e.preventDefault();
    // if (isTouchingControlling && e.touches.length > 0) {
    //   const touch = e.touches[0];
    //   const deltaX = touch.clientX - mouseX;
    //   const deltaY = touch.clientY - mouseY;

    //   const cameraDirection = new THREE.Vector3();
    //   camera.getWorldDirection(cameraDirection);
    //   cameraDirection.y = 0;
    //   cameraDirection.normalize();

    //   const rightVector = new THREE.Vector3();
    //   rightVector.crossVectors(cameraDirection, new THREE.Vector3(0, 1, 0)).normalize();

    //   const moveX = rightVector.multiplyScalar(-deltaX * moveSpeed);
    //   const moveZ = cameraDirection.multiplyScalar(-deltaY * moveSpeed);

    //   targetPosition.copy(savedTargetPosition.current).add(moveX).add(moveZ);

    //   // محدود کردن موقعیت
    //   const minX = -200;
    //   const maxX = 200;
    //   const minZ = -50;
    //   const maxZ = 50;
    //   targetPosition.x = Math.max(minX, Math.min(maxX, targetPosition.x));
    //   targetPosition.z = Math.max(minZ, Math.min(maxZ, targetPosition.z));

    //   mouseX = touch.clientX;
    //   mouseY = touch.clientY;
    //   console.log('Touch moved, targetPosition:', targetPosition);
    // }
  };

  // پایان لمس
  const handleTouchEnd = () => {
    // isTouchingControlling = false;
    // console.log('Touch ended');
  };

    const handleVisibilityChange = () => {
      // if (document.visibilityState === 'visible') {
      //   console.log("🔄 تب دوباره فعال شد، ریست کردن صحنه...");
      //   callResetScene = true;
      //   resetScene();
      // }
    };

    const resetScene = () => {
      callResetScene = true;
      if (humanBodyRef.current) {
        savedHumanPosition.current = humanBodyRef.current.position.clone();
        savedHumanQuaternion.current = humanBodyRef.current.quaternion.clone();
        console.log(`Saving human position: ${savedHumanPosition.current.x}, ${savedHumanPosition.current.z}, quaternion: ${savedHumanQuaternion.current.x}, ${savedHumanQuaternion.current.y}, ${savedHumanQuaternion.current.z}, ${savedHumanQuaternion.current.w}`);
      }
      if (cameraRef.current) {
        savedCameraPosition.current = cameraRef.current.position.clone();
        savedCameraLookAt.current = new THREE.Vector3();
        cameraRef.current.getWorldDirection(savedCameraLookAt.current);
        const lookAtPoint = cameraRef.current.position.clone().add(savedCameraLookAt.current.multiplyScalar(10));
        savedCameraLookAt.current.copy(lookAtPoint);
      }

      cleanupScene();
      setTimeout(() => {
        console.log("🔄 در حال مقداردهی مجدد صحنه...");
        setLoading(false);
        initializeScene();
      }, 100);
    };

    const cleanupScene = () => {
      console.log("🧹 Cleaning up scene...");

      const canvas = document.getElementById('three-canvas');
      if (canvas && canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }

      if (humanMixer) {
        humanMixer.stopAllAction();
        humanMixer = null;
      }
      if (idleAction) {
        idleAction.stop();
        idleAction = null;
      }
      if (walkAction) {
        walkAction.stop();
        walkAction = null;
      }

      if (scene) {
        while (scene.children > 0) {
          scene.remove(scene.children[0]);
        }
      }

      if (world) {
        while (world.bodies.length > 0) {
          world.removeBody(world.bodies[0]);
        }
      }

      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('click', handleClick);
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('resize', handleResize);

      localHumanModel = null;
      humanBody = null;
      humanBox = null;
      isWalking = false;
      humanRotationAngle = 0;
      zoomLevel = 2;
      isMouseControlling = false;
      isTouchingControlling = false;
      savedTargetPosition.current = null;
      mouseX = 0;
      mouseY = 0;
      targetPosition = new THREE.Vector3(0, 1, 0);
      boxes.length = 0;
      collidedBox = null;
      Object.keys(keysPressed).forEach(key => delete keysPressed[key]);

      if (renderer) {
        renderer.dispose();
        renderer.forceContextLoss();
        renderer = null;
      }

      setModelsLoaded(0);
      setProgress(0);
      setLoading(true);
      if (callResetScene) {
        setLoading(false);
      }
      setError(null);

      console.log("✅ Scene cleaned up successfully");
    };

    const checkSnowAccumulation = () => {
      // if (!snowParticles.current || !localHumanModel) return;
      
      // const positions = snowGeometry.current.attributes.position.array;
      // const velocities = snowGeometry.current.attributes.velocity.array;
      // const humanBox = new THREE.Box3().setFromObject(localHumanModel);
      
      // for (let i = 0; i < positions.length / 3; i++) {
      //   const i3 = i * 3;
      //   const particlePos = new THREE.Vector3(
      //     positions[i3],
      //     positions[i3 + 1],
      //     positions[i3 + 2]
      //   );
        
      //   // بررسی برخورد با مدل انسانی
      //   if (humanBox.containsPoint(particlePos)) {
      //     // اگر برف با مدل برخورد کرد، روی مدل بنشیند
      //     positions[i3 + 1] = humanBox.max.y + 0.05;
      //     velocities[i] = 0; // توقف حرکت
      //   }
      // }
      
      // snowGeometry.current.attributes.position.needsUpdate = true;
      // snowGeometry.current.attributes.velocity.needsUpdate = true;
    };

    const getModelRoot = (object) => {
      let current = object;
      while (current.parent && !current.userData.isModelRoot) {
        current = current.parent;
      }
      return current;
    };

    const initializeScene = () => {
      const container = document.getElementById('three-container');
      if (!container) {
        console.warn('#three-container not ready, retrying...');
        setTimeout(initializeScene, 100);
        return;
      }

      const existingCanvas = document.getElementById('three-canvas');
      if (existingCanvas) existingCanvas.remove();

      scene = new THREE.Scene();
      //scene.background = new THREE.Color(0x1e007b);
      scene.background = new THREE.Color(0xffffff);

      // Main fog removed.

      // cloudRef.current = createCloud();
      // scene.add(cloudRef.current);


      // ایجاد و اضافه کردن سیستم برف به صحنه
      const snowSystem = createSnowEffect(scene);
      if (snowSystem) scene.add(snowSystem);

      camera = new THREE.PerspectiveCamera(MAIN_CAMERA_CONFIG.fov, window.innerWidth / window.innerHeight, MAIN_CAMERA_CONFIG.near, MAIN_CAMERA_CONFIG.far);
      cameraRef.current = camera;
      if (savedCameraPosition.current) {
        camera.position.copy(savedCameraPosition.current);
        if (savedCameraLookAt.current) camera.lookAt(savedCameraLookAt.current);
      } else {
        camera.position.set(MAIN_CAMERA_CONFIG.startX, MAIN_CAMERA_CONFIG.startY, MAIN_CAMERA_CONFIG.startZ);
        camera.lookAt(MAIN_CAMERA_CONFIG.lookAtX, MAIN_CAMERA_CONFIG.lookAtY, MAIN_CAMERA_CONFIG.lookAtZ);
      }

      try {
        renderer = new THREE.WebGLRenderer({
          antialias: true,
          powerPreference: "high-performance",
          failIfMajorPerformanceCaveat: false,
        });
      } catch (err) {
        console.error("WebGL Error:", err);
        setError('Your browser does not support 3D graphics. Please update your browser.');
        setLoading(false);
        clearTimeout(loadTimeout);
        return;
      }
      renderer.setSize(window.innerWidth, window.innerHeight);
      // renderer.setClearColor(0x1e007b);
      renderer.shadowMap.enabled = MAIN_RENDERER_CONFIG.shadowMapEnabled;
      renderer.shadowMap.type = MAIN_RENDERER_CONFIG.shadowMapType;
      renderer.domElement.id = 'three-canvas';
      container.appendChild(renderer.domElement);

      directionalLight = new THREE.DirectionalLight(MAIN_LIGHT_CONFIG.directionalColor, MAIN_LIGHT_CONFIG.directionalIntensity);
      directionalLight.position.set(MAIN_LIGHT_CONFIG.initialX, MAIN_LIGHT_CONFIG.initialY, MAIN_LIGHT_CONFIG.initialZ);
      directionalLight.castShadow = MAIN_LIGHT_CONFIG.castShadow;
      directionalLight.shadow.camera.near = MAIN_LIGHT_CONFIG.shadowCameraNear;
      directionalLight.shadow.camera.far = MAIN_LIGHT_CONFIG.shadowCameraFar;
      directionalLight.shadow.camera.left = MAIN_LIGHT_CONFIG.shadowCameraLeft;
      directionalLight.shadow.camera.right = MAIN_LIGHT_CONFIG.shadowCameraRight;
      directionalLight.shadow.camera.top = MAIN_LIGHT_CONFIG.shadowCameraTop;
      directionalLight.shadow.camera.bottom = MAIN_LIGHT_CONFIG.shadowCameraBottom;
      directionalLight.shadow.mapSize.width = MAIN_LIGHT_CONFIG.shadowMapSize;
      directionalLight.shadow.mapSize.height = MAIN_LIGHT_CONFIG.shadowMapSize;
      directionalLight.shadow.bias = MAIN_LIGHT_CONFIG.shadowBias;
      
      scene.add(directionalLight);

      const ambientLight = new THREE.AmbientLight(MAIN_LIGHT_CONFIG.ambientColor, MAIN_LIGHT_CONFIG.ambientIntensity);
      scene.add(ambientLight);

      world = new CANNON.World();
      world.gravity.set(0, -30, 0);
      world.broadphase = new CANNON.NaiveBroadphase();
      world.solver.iterations = 10;
      world.solver.tolerance = 0.0001;
      world.allowSleep = true;

//       // Sphere
//       const textureLoadersb = new THREE.TextureLoader();
//       const sphere = new THREE.Mesh(
//           new THREE.SphereGeometry(0.5, 32, 32),
//           new THREE.MeshStandardMaterial({
//               metalness: 0.3,
//               roughness: 0.4,
//               envMap: textureLoadersb,
//               envMapIntensity: 0.5
//           })
//       );
//       sphere.castShadow = true;
//       sphere.position.y = 0.5;
//       scene.add(sphere);

//       const sphereShape = new CANNON.Sphere(0.5);
//       const sphereBody = new CANNON.Body({
//           mass: 1,
//           position: new CANNON.Vec3(0, 3, 0), // موقعیت اولیه بالاتر از سایر اجسام
//           shape: sphereShape,
//           material: new CANNON.Material({
//               friction: 0.5,    // افزایش اصطکاک
//               restitution: 0.8 // کاهش کشسانی
//           })
//       });

//       // اعمال نیرو با دقت بیشتر
//       sphereBody.applyLocalForce(new CANNON.Vec3(150, 0, 0), new CANNON.Vec3(0, 0, 0));
//       world.addBody(sphereBody);

//       // افزایش زیرتقسیم‌ها برای دقت بیشتر در محاسبات فیزیکی
//       // world.step(1/60, 20, 3);
//       world.step(1/120, 20, 3);
// // world.broadphase.useBoundingBoxes = true;
// // world.broadphase.boundingVolumeType = CANNON.BoundingVolumeType.AABB;
      
// ایجاد و اضافه کردن سیستم برف به صحنه
  //const snowSystem = createSnowEffect(scene);
  if (snowSystem && snowSystem.parent !== scene) scene.add(snowSystem);

      const groundMaterial = new CANNON.Material('groundMaterial');
      const objectMaterial = new CANNON.Material('objectMaterial');
      groundMaterial.restitution = 0.0;
      objectMaterial.restitution = 0.0;

      const contactMaterial = new CANNON.ContactMaterial(groundMaterial, objectMaterial, {
        friction: 0.5,
        restitution: 0.0,
        contactEquationStiffness: 1e8,
        contactEquationRelaxation: 3,
      });
      world.addContactMaterial(contactMaterial);

      const humanBoxContactMaterial = new CANNON.ContactMaterial(objectMaterial, groundMaterial, {
        friction: 0.5,
        restitution: 0.0,
        contactEquationStiffness: 1e8,
        contactEquationRelaxation: 3,
      });
      world.addContactMaterial(humanBoxContactMaterial);

      // اضافه کردن ContactMaterial برای برخورد بین اشیاء (objectMaterial و objectMaterial)
      const objectObjectContactMaterial = new CANNON.ContactMaterial(objectMaterial, objectMaterial, {
        friction: 0.5,
        restitution: 0.0,
        contactEquationStiffness: 1e8,
        contactEquationRelaxation: 3,
      });
      world.addContactMaterial(objectObjectContactMaterial);

      // const planeGeometry = new THREE.PlaneGeometry(1000, 1000);
      // const planeMaterial = new THREE.MeshStandardMaterial
      // ({ 
      //   color: 0x032585,
      //   //roughness: new CANNON.Vec3(0,0,0)
      //   roughness: 0.1, // زبری کم برای ایجاد انعکاس ملایم
      //   metalness: 0.8, // مقداری فلزی بودن برای انعکاس محیطی
      //   envMapIntensity: 1 // شدت انعکاس محیط HDR را کم می‌کند
      // });
      // const plane = new THREE.Mesh(planeGeometry, planeMaterial);
      // plane.rotation.x = -Math.PI / 2;
      // plane.receiveShadow = true;
      // scene.add(plane);

      // const groundBody = new CANNON.Body({
      //   mass: 0,
      //   shape: new CANNON.Box(new CANNON.Vec3(200, 0.1, 50)),
      //   material: groundMaterial,
      //   position: new CANNON.Vec3(0, 0, 0),
      // });
      // world.addBody(groundBody);

      const loader = new GLTFLoader();
      const dracoLoader = new DRACOLoader();
      dracoLoader.setDecoderPath('/draco/');
      loader.setDRACOLoader(dracoLoader);

      if (MAIN_MODEL_LOADING_QUEUE_CONFIG.enabled) {
        const originalLoaderLoad = loader.load.bind(loader);
        const pendingLoads = [];
        let activeLoads = 0;
        let pumpTimer = null;
        let firstPump = true;

        const scheduleLoadPump = (delay = 0) => {
          if (pumpTimer !== null) return;
          pumpTimer = window.setTimeout(() => {
            pumpTimer = null;
            pumpLoadQueue();
          }, delay);
        };

        const finishQueuedLoad = () => {
          activeLoads = Math.max(0, activeLoads - 1);
          scheduleLoadPump(MAIN_MODEL_LOADING_QUEUE_CONFIG.betweenLoadsMs);
        };

        const pumpLoadQueue = () => {
          if (!isMounted) {
            pendingLoads.length = 0;
            return;
          }

          while (activeLoads < MAIN_MODEL_LOADING_QUEUE_CONFIG.maxConcurrent && pendingLoads.length > 0) {
            const job = pendingLoads.shift();
            activeLoads++;

            originalLoaderLoad(
              job.path,
              (gltf) => {
                const runLoadCallback = () => {
                  window.requestAnimationFrame(() => {
                    try {
                      job.onLoad?.(gltf);
                    } finally {
                      finishQueuedLoad();
                    }
                  });
                };

                if (window.requestIdleCallback) {
                  window.requestIdleCallback(runLoadCallback, { timeout: MAIN_MODEL_LOADING_QUEUE_CONFIG.idleTimeoutMs });
                } else {
                  window.setTimeout(runLoadCallback, MAIN_MODEL_LOADING_QUEUE_CONFIG.idleFallbackMs);
                }
              },
              job.onProgress,
              (error) => {
                try {
                  job.onError?.(error);
                } finally {
                  finishQueuedLoad();
                }
              }
            );
          }
        };

        loader.load = (path, onLoad, onProgress, onError) => {
          pendingLoads.push({ path, onLoad, onProgress, onError });
          scheduleLoadPump(firstPump ? MAIN_MODEL_LOADING_QUEUE_CONFIG.startDelayMs : MAIN_MODEL_LOADING_QUEUE_CONFIG.betweenLoadsMs);
          firstPump = false;
          return loader;
        };
      }

//       // بارگذاری مدل زمین برفی/تررین
// const groundLoader = new GLTFLoader();
// // const dracoLoader = new DRACOLoader();
// // dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
// groundLoader.setDRACOLoader(dracoLoader);

// groundLoader.load(
//   '/models/winter/floor.glb', // ← مسیر دقیق فایل خودتون
//   (gltf) => {
//     const groundModel = gltf.scene;

//     // تنظیمات ضروری
//     groundModel.position.set(1, 1, 1);        // معمولاً y=0
//     groundModel.rotation.x = -Math.PI / 2;    // اگر مدل در Blender ایستاده بود، این خط لازمه
//     groundModel.scale.set(100, 100, 100);        // ← این عدد رو بسته به اندازه مدل تنظیم کنید (معمولاً 20 تا 100)

//     // دریافت سایه‌های همه اشیا (نور directional شما سایه می‌اندازه)
//     groundModel.traverse((child) => {
//       if (child.isMesh && child.material) {
//     child.material.envMap = null;  // بازتاب HDR رو برای زمین خاموش کن
//     child.material.envMapIntensity = 0;
//     child.material.needsUpdate = true;
//   }
//       if (child.isMesh) {
//         child.receiveShadow = true;
//         child.castShadow = false; // زمین معمولاً سایه نمی‌اندازه
//         // اگر متریال‌ها خیلی تیره/روشن شدن، می‌تونید envMapIntensity رو تنظیم کنید
//         if (child.material) {
//           child.material.envMapIntensity = 0.6; // اختیاری - بسته به HDR شما
//         }
//       }
//     });

//     scene.add(groundModel);

//     // افزایش شمارنده لودینگ (چون totalModels = 63 دارید)
//     loadedModelsCount++;
//     updateProgress();

//     console.log('✅ زمین GLB با موفقیت اضافه شد');
//   },
//   (progress) => {
//     console.log(`لود زمین: ${(progress.loaded / progress.total * 100).toFixed(1)}%`);
//   },
//   (error) => {
//     console.error('❌ خطا در بارگذاری زمین:', error);
//     setError('بارگذاری مدل زمین失敗 کرد. مسیر فایل را چک کنید.');
//   }
// );

      const createBoundingBox = (geometry, position, color = 0xffffff, opacity = 0) => {
        const edges = new THREE.EdgesGeometry(geometry);
        const shouldHideCollisionLine = FOG_CONFIG.hideModelCollisionLines;
        const material = new THREE.LineBasicMaterial({
          color: color,
          linewidth: 2,
          transparent: true,
          opacity: shouldHideCollisionLine ? 0 : opacity,
        });
        const boundingBox = new THREE.LineSegments(edges, material);
        boundingBox.visible = !shouldHideCollisionLine;
        boundingBox.userData.isCollider = true;
        boundingBox.userData.isSnowSystem = true;
        const boxSize = new THREE.Vector3();
        geometry.computeBoundingBox();
        geometry.boundingBox.getSize(boxSize);
        boundingBox.position.set(position.x, position.y + boxSize.y / 2, position.z);
        boundingBox.geometry.boundingBox = geometry.boundingBox.clone();
        boundingBox.geometry.boundingBox.translate(new THREE.Vector3(position.x, position.y + boxSize.y / 2, position.z));
        scene.add(boundingBox);
        return boundingBox;
      };

      // ایجاد sphere برای نمایش منطقه تأثیر
const createTriggerZone = () => {
  // const geometry = new THREE.SphereGeometry(triggerRadius, 32, 32);
  // const material = new THREE.MeshBasicMaterial({
  //   color: 0xff0000,
  //   transparent: true,
  //   opacity: 0.2,
  //   wireframe: true
  // });
  // const sphere = new THREE.Mesh(geometry, material);
  // sphere.position.copy(triggerPosition);
  // scene.add(sphere);
};

// فراخوانی در initializeScene بعد از ایجاد scene
createTriggerZone();

// تعریف جهت‌های مختلف
const DIRECTIONS = {
  NORTH: new THREE.Vector3(0, 0, 0),
  EAST: new THREE.Vector3(0, Math.PI / 2, 0),       // 90 درجه
  SOUTH: new THREE.Vector3(0, Math.PI, 0),          // 180 درجه
  WEST: new THREE.Vector3(0, -Math.PI / 2, 0),      // -90 درجه
  NORTHEAST: new THREE.Vector3(0, Math.PI / 4, 0),  // 45 درجه
  NORTHWEST: new THREE.Vector3(0, -Math.PI / 4, 0), // -45 درجه
};

// تابع کمکی برای چرخش آسان
const createRotation = (yawDegrees = 0, pitchDegrees = 0, rollDegrees = 0) => {
  const degToRad = (deg) => deg * (Math.PI / 180);
  return new THREE.Vector3(
    degToRad(pitchDegrees),  // حول محور X
    degToRad(yawDegrees),    // حول محور Y (مهم برای جهت‌های شرق/غرب)
    degToRad(rollDegrees)    // حول محور Z
  );
};


      const clampSnowBallSpeed = () => {
        if (!snowBallState) return;
        const velocity = snowBallState.velocity;
        const speed = Math.sqrt(velocity.x * velocity.x + velocity.z * velocity.z);
        if (speed > BALL_CONFIG.maxSpeed) {
          const scale = BALL_CONFIG.maxSpeed / speed;
          velocity.x *= scale;
          velocity.z *= scale;
        } else if (speed < BALL_CONFIG.minSpeedStop) {
          velocity.set(0, 0, 0);
        }
      };

      const resolveSnowBallStaticBoxes = (oldX, oldZ) => {
        if (!snowBallModel || !snowBallState) return;
        const radius = BALL_CONFIG.radius + BALL_CONFIG.collisionPadding;
        const ballX = snowBallModel.position.x;
        const ballZ = snowBallModel.position.z;

        boxes.forEach((hitBox) => {
          if (!hitBox?.mesh?.geometry?.boundingBox) return;
          const staticBox = hitBox.mesh.geometry.boundingBox;

          const insideX = ballX > staticBox.min.x - radius && ballX < staticBox.max.x + radius;
          const insideZ = ballZ > staticBox.min.z - radius && ballZ < staticBox.max.z + radius;
          if (!insideX || !insideZ) return;

          const overlapLeft = Math.abs(ballX - (staticBox.min.x - radius));
          const overlapRight = Math.abs((staticBox.max.x + radius) - ballX);
          const overlapBack = Math.abs(ballZ - (staticBox.min.z - radius));
          const overlapFront = Math.abs((staticBox.max.z + radius) - ballZ);
          const minOverlap = Math.min(overlapLeft, overlapRight, overlapBack, overlapFront);

          if (minOverlap === overlapLeft) {
            snowBallModel.position.x = staticBox.min.x - radius;
            snowBallState.velocity.x = -Math.abs(snowBallState.velocity.x) * BALL_CONFIG.wallFriction;
          } else if (minOverlap === overlapRight) {
            snowBallModel.position.x = staticBox.max.x + radius;
            snowBallState.velocity.x = Math.abs(snowBallState.velocity.x) * BALL_CONFIG.wallFriction;
          } else if (minOverlap === overlapBack) {
            snowBallModel.position.z = staticBox.min.z - radius;
            snowBallState.velocity.z = -Math.abs(snowBallState.velocity.z) * BALL_CONFIG.wallFriction;
          } else if (minOverlap === overlapFront) {
            snowBallModel.position.z = staticBox.max.z + radius;
            snowBallState.velocity.z = Math.abs(snowBallState.velocity.z) * BALL_CONFIG.wallFriction;
          }
        });
      };

      const updateSnowBall = (delta) => {
        if (!BALL_CONFIG.enabled || !snowBallModel || !snowBallState || !localHumanModel || !humanBody) return;

        const dt = Math.min(delta || 0.016, 0.05);
        const ballPosition = snowBallModel.position;
        ballPosition.y = BALL_CONFIG.startY;

        const humanX = humanBody.position.x;
        const humanZ = humanBody.position.z;
        const dx = ballPosition.x - humanX;
        const dz = ballPosition.z - humanZ;
        const distance = Math.sqrt(dx * dx + dz * dz);
        const minDistance = BALL_CONFIG.radius + BALL_CONFIG.avatarRadius;

        if (distance < minDistance) {
          const fallbackForward = new THREE.Vector3(0, 0, 1).applyQuaternion(localHumanModel.quaternion).normalize();
          const normalX = distance > 0.0001 ? dx / distance : fallbackForward.x;
          const normalZ = distance > 0.0001 ? dz / distance : fallbackForward.z;
          const pushDistance = minDistance - Math.max(distance, 0.0001);

          ballPosition.x += normalX * pushDistance;
          ballPosition.z += normalZ * pushDistance;

          const avatarVelocity = Math.sqrt((humanBody.velocity.x || 0) ** 2 + (humanBody.velocity.z || 0) ** 2);
          const pushSpeed = Math.min(
            BALL_CONFIG.maxSpeed,
            BALL_CONFIG.pushPower + avatarVelocity * BALL_CONFIG.avatarVelocityInfluence
          );

          snowBallState.velocity.x = normalX * pushSpeed;
          snowBallState.velocity.z = normalZ * pushSpeed;
          clampSnowBallSpeed();
        }

        const oldX = ballPosition.x;
        const oldZ = ballPosition.z;

        ballPosition.x += snowBallState.velocity.x * dt;
        ballPosition.z += snowBallState.velocity.z * dt;
        resolveSnowBallStaticBoxes(oldX, oldZ);

        const moveX = ballPosition.x - oldX;
        const moveZ = ballPosition.z - oldZ;
        const moveDistance = Math.sqrt(moveX * moveX + moveZ * moveZ);

        if (moveDistance > 0.0001) {
          const rollAxis = new THREE.Vector3(moveZ, 0, -moveX).normalize();
          const rollAngle = (moveDistance / Math.max(0.001, BALL_CONFIG.radius)) * BALL_CONFIG.spinMultiplier;
          const rollQuat = new THREE.Quaternion().setFromAxisAngle(rollAxis, rollAngle);
          snowBallModel.quaternion.premultiply(rollQuat);
        }

        const damping = Math.pow(BALL_CONFIG.friction, dt * 60);
        snowBallState.velocity.multiplyScalar(damping);
        clampSnowBallSpeed();
      };

      const createSnowBall = () => {
        if (!BALL_CONFIG.enabled) return;

        registerModelLoad();

        loader.load(
          BALL_CONFIG.path,
          (gltf) => {
            if (!isMounted) return;

            const model = gltf.scene;
            snowBallModel = model;
            snowBallModel.userData.isSnowBall = true;

            model.position.set(BALL_CONFIG.startX, BALL_CONFIG.startY, BALL_CONFIG.startZ);
            model.scale.set(BALL_CONFIG.scale, BALL_CONFIG.scale, BALL_CONFIG.scale);

            model.traverse((node) => {
              if (node.isMesh) {
                node.castShadow = true;
                node.receiveShadow = true;
              }
            });

            scene.add(model);

            snowBallState = {
              velocity: new THREE.Vector3(0, 0, 0)
            };

            updateProgress();
          },
          undefined,
          (err) => {
            console.error('Error loading snow ball:', err);
            setError('Failed to load model /models/mab0626/ball.glb. Please check the file path.');
            setLoading(false);
            clearTimeout(loadTimeout);
          }
        );
      };

      const loadModel = (
        path,
        onLoad,
        scale,
        position,
        bodyMass = 0,
        useCylinder = false,
        retryCount = 0,
        createWhiteBox = false,
        whiteBoxSize = new THREE.Vector3(5, 5, 5),
        whiteBoxColor = 0xffffff,
        whiteBoxOpacity = 0.5,
        whiteBoxPosition = new THREE.Vector3(0, 0, 0),
        whiteBoxHasLink = false,
        whiteBoxLink = '',
        createRedBox = false,
        redBoxSize = new THREE.Vector3(6, 6, 6),
        redBoxColor = 0xff0000,
        redBoxOpacity = 0.3,
        redBoxPosition = new THREE.Vector3(0, 0, 0),
        redBoxHasLink = false,
        redBoxLink = '',
        noPhysics = false,
        rotation = new THREE.Vector3(0, 0, 0),
        rotationSpeed = new THREE.Vector3(0, 0, 0),
        customBoxSize = null // اضافه کردن پارامتر برای اندازه سفارشی جعبه برخورد
      ) => {
        const maxRetries = 1;
        if (retryCount === 0) {
          registerModelLoad();
        }

        loader.load(
          path,
          (gltf) => {
            if (!isMounted) return;
            if (MAIN_MODEL_LOADING_QUEUE_CONFIG.logProgress) console.log(`Model ${path} loaded successfully`);
            const model = gltf.scene;

            model.userData.isModelRoot = true;

            model.position.copy(position);
            model.scale.set(scale, scale, scale);

            model.rotation.set(rotation.x, rotation.y, rotation.z);

            model.castShadow = true;
            model.traverse((node) => {
              if (node.isMesh) {
                node.castShadow = true;
                node.receiveShadow = true;
              }
            });

            scene.add(model);

            let body = null;
            if (!noPhysics) {
              const box = new THREE.Box3().setFromObject(model);
              const size = new THREE.Vector3();
              box.getSize(size);
              // const shape = new CANNON.Box(new CANNON.Vec3(size.x / 1.6 , size.y / 2.7 , size.z / 2.7));
              // استفاده از customBoxSize اگر تعریف شده باشد، در غیر این صورت از ابعاد مدل
              const hasValidCustomBoxSize = customBoxSize && customBoxSize.x > 0 && customBoxSize.y > 0 && customBoxSize.z > 0;
              const shapeSize = hasValidCustomBoxSize
                ? new CANNON.Vec3(customBoxSize.x / 2, customBoxSize.y / 2, customBoxSize.z / 2)
                : new CANNON.Vec3(size.x / 2, size.y / 2, size.z / 2); // بدون ضرایب ثابت
              let shape = new CANNON.Box(shapeSize);
              body = new CANNON.Body({
                mass: bodyMass,
                shape: shape,
                material: objectMaterial,
              });
              body.position.copy(position);
              body.quaternion.setFromEuler(rotation.x, rotation.y, rotation.z);

              body.linearDamping = 0.0;
              body.angularDamping = 0.0;
              if(path.includes('x.glb') || path.includes('l.glb')|| path.includes('a.glb')|| path.includes('b.glb') || path.includes('sphere.glb')|| path.includes('ball.glb'))
              {
                body.linearDamping = 0.9;
                body.angularDamping = 0.9;
              }
              if(path.includes('sphere.glb'))
              {
                body.linearDamping = 0.5;
                body.angularDamping = 0.5;
              }
              if (useCylinder) {
                body.angularFactor = new CANNON.Vec3(0, 1, 0);
              }
              world.addBody(body);

              if (path.includes('avatar') && savedHumanPosition.current && savedHumanQuaternion.current && callResetScene) {
                body.position.copy(savedHumanPosition.current);
                body.quaternion.copy(savedHumanQuaternion.current);
                console.log(`Restored human position: ${body.position.x}, ${body.position.z}, quaternion: ${body.quaternion.x}, ${body.quaternion.y}, ${body.quaternion.z}, ${body.quaternion.w}`);
              }
            }

            if (createWhiteBox) {
              const whiteBox = createBoundingBox(
                new THREE.BoxGeometry(whiteBoxSize.x, whiteBoxSize.y, whiteBoxSize.z),
                whiteBoxPosition,
                whiteBoxColor,
                whiteBoxOpacity
              );
              const whiteBoxBody = new CANNON.Body({
                mass: 0,
                shape: new CANNON.Box(new CANNON.Vec3(whiteBoxSize.x / 2, whiteBoxSize.y / 2, whiteBoxSize.z / 2)),
                position: new CANNON.Vec3(whiteBoxPosition.x, whiteBoxPosition.y + whiteBoxSize.y / 2, whiteBoxPosition.z),
                material: groundMaterial,
              });
              world.addBody(whiteBoxBody);
              boxes.push({ mesh: whiteBox, body: whiteBoxBody, hasLink: whiteBoxHasLink, link: whiteBoxLink });
            }

            if (createRedBox) {
              const redBox = createBoundingBox(
                new THREE.BoxGeometry(redBoxSize.x, redBoxSize.y, redBoxSize.z),
                redBoxPosition,
                redBoxColor,
                redBoxOpacity
              );
              const redBoxBody = new CANNON.Body({
                mass: 0,
                shape: new CANNON.Box(new CANNON.Vec3(redBoxSize.x / 2, redBoxSize.y / 2, redBoxSize.z / 2)),
                position: new CANNON.Vec3(redBoxPosition.x, redBoxPosition.y + redBoxSize.y / 2, redBoxPosition.z),
                material: groundMaterial,
              });
              world.addBody(redBoxBody);
              boxes.push({ mesh: redBox, body: redBoxBody, hasLink: redBoxHasLink, link: redBoxLink });
            }

            rotatingModels.push({
              model: model,
              body: body,
              speed: rotationSpeed
            });

            if (path.includes('avatar')) {
              humanBodyRef.current = body;
            }

            if (path.includes('avatar') && savedHumanPosition.current && savedHumanQuaternion.current && callResetScene) {
              body.position.copy(savedHumanPosition.current);
              body.quaternion.copy(savedHumanQuaternion.current);
              console.log(`Reeestored human position: ${body.position.x}, ${body.position.z}, quaternion: ${body.quaternion.x}, ${body.quaternion.y}, ${body.quaternion.z}, ${body.quaternion.w}`);
              callResetScene = false;
            }

            onLoad(gltf, model, body);
            updateProgress();
          },
          (xhr) => {
            if (xhr.total > 0) {
              if (MAIN_MODEL_LOADING_QUEUE_CONFIG.logProgress) console.log(`${path} ${(xhr.loaded / xhr.total * 100).toFixed(2)}% loaded`);
            } else {
              if (MAIN_MODEL_LOADING_QUEUE_CONFIG.logProgress) console.log(`${path} loading (size unknown)`);
            }
          },
          (err) => {
            console.error(`Error loading ${path}:`, err);
            if (retryCount < maxRetries) {
              console.log(`Retrying ${retryCount + 1} for ${path}`);
              setTimeout(() => {
                loadModel(path, onLoad, scale, position, bodyMass, useCylinder, retryCount + 1, createWhiteBox, whiteBoxSize, whiteBoxColor, whiteBoxOpacity, whiteBoxPosition, whiteBoxHasLink, whiteBoxLink, createRedBox, redBoxSize, redBoxColor, redBoxOpacity, redBoxPosition, redBoxHasLink, redBoxLink, noPhysics);
              }, 2000);
            } else {
              setError(`Failed to load model ${path} after ${maxRetries} attempts. Please check the file path.`);
              setLoading(false);
              clearTimeout(loadTimeout);
            }
          }
        );
      };

      createSnowBall();

      // useyour
            loadModel(
              '/models/winter/use.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localUseYourModel = model;

                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 1; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });

                // تنظیم شدت envMap برای مدل اصلی
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        if (node.material.isMeshStandardMaterial || node.material.isMeshPhysicalMaterial) {
          node.material.envMapIntensity = 500; // مقدار دلخواه
        }
      }
    });//ظاهرا کار نکرد

                useYourBody = body;
                useYourMixer = new THREE.AnimationMixer(model);
                useYourAnimations = gltf.animations;
                useYourBox = new THREE.Box3().setFromObject(model);
                if (useYourAnimations.length > 0) {
                  const useYourAction = useYourMixer.clipAction(useYourAnimations[0]);
                  useYourAction.reset().play();
                }
                await checkAllLoaded();
              },
              4,
              new THREE.Vector3(0, 0, -40),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -40),
              false,
              '',
              true,
              new THREE.Vector3(8, 4, 3),
              0xff0000,
              0.0,
              new THREE.Vector3(0, 0, -40),
              false,
              '',
              false,
              DIRECTIONS.EAST,
            );
      
            // xroad
            loadModel(
              '/models/winter/floor.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localXModel = model;
                xBody = body;
                xMixer = new THREE.AnimationMixer(model);
                xAnimations = gltf.animations;
                xBox = new THREE.Box3().setFromObject(model);
                if (xAnimations.length > 0) {
                  const xAction = xMixer.clipAction(xAnimations[0]);
                  xAction.reset().play();
                }
                await checkAllLoaded();
              },
              6,
              new THREE.Vector3(0, 0.00, 0),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              false,
              DIRECTIONS.EAST, //new THREE.Vector3(0, -80, 0),
            );
      
            // avatar
            loadModel(
              // '/models/avatar-rig3-2--.glb',
              '/models/avatar-p3.glb',
              // '/models/avatar-rig3-2---.glb',
              (gltf, model, body) => {
                if (!isMounted) return;
                localHumanModel = model;

                // const humanCollider = new THREE.Mesh(
                //   new THREE.CapsuleGeometry(0.35, 5.4, 4, 8),
                //   new THREE.MeshBasicMaterial({ visible: true ,color:0xff0000})
                // );

                // humanCollider.position.set(0, 0.9, 0);
                // scene.add(humanCollider);

                // localHumanModel.userData.collider = humanCollider;



                const box = new THREE.Box3().setFromObject(localHumanModel);
                const size = new THREE.Vector3();
                const center = new THREE.Vector3();
                box.getSize(size);
                box.getCenter(center);
                localHumanModel.worldToLocal(center);

                const colliderMesh = new THREE.Mesh(
                  new THREE.BoxGeometry(size.x * 0.6, size.y, size.z * 0.6),
                  new THREE.MeshBasicMaterial({
                    color: 0x00ffff,
                    transparent: true,
                    opacity: 0.28,
                    wireframe: true,
                    depthWrite: false
                  })
                );

                colliderMesh.position.copy(center);
                colliderMesh.visible = false;
                colliderMesh.material.opacity = 0;
                colliderMesh.renderOrder = 999;

                localHumanModel.add(colliderMesh);

                localHumanModel.userData.collider = colliderMesh;

                // const humanBox = new THREE.Box3().setFromObject(localHumanModel);
                // const size = new THREE.Vector3();
                // const center = new THREE.Vector3();

                // humanBox.getSize(size);
                // humanBox.getCenter(center);

                // const humanCollider = new THREE.Mesh(
                //   new THREE.BoxGeometry(size.x * 0.5, size.y, size.z * 0.5),
                //   new THREE.MeshBasicMaterial({ visible: false })
                // );

                // humanCollider.position.copy(center);
                // scene.add(humanCollider);

                // localHumanModel.userData.collider = humanCollider;

                // اعمال environment map مخصوص اگر قبلاً بارگذاری شده
                if (humanEnvTexture) {
                  applyHumanSpecificEnvMap(localHumanModel, humanEnvTexture);
                }

                humanBody = body;
                humanBody.linearDamping = 0.0;
                humanBody.angularDamping = 0.0;
                humanBody.fixedRotation = true;
                humanMixer = new THREE.AnimationMixer(model);
                idleAction = humanMixer.clipAction(gltf.animations[0]);
                walkAction = humanMixer.clipAction(gltf.animations[1]);
                idleAction.play();
                humanBox = new THREE.Box3().setFromObject(model);
                updateCameraPosition();
              },
              1,
              new THREE.Vector3(0, 0, -30),
              1,
              true,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(10, 0, -10),
              false,
              '',
              false,
              new THREE.Vector3(8, 8, 8),
              0xff0000,
              0.0,
              new THREE.Vector3(10, 0, -10),
              false,
              '',
              false,
              new THREE.Vector3(0, 0, 0),
              new THREE.Vector3(0, 0, 0),
              new THREE.Vector3(3.1, -0.4, -0.5)
            );
      
            // asset1 khers
            loadModel(
              '/models/winter/asset1.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localAIagentModel = model;
                
                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 0.99; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });
    
                aIagentBody = body;
                aIagentMixer = new THREE.AnimationMixer(model);
                aIagentAnimations = gltf.animations;
                aIagentBox = new THREE.Box3().setFromObject(model);
                
                // // اضافه کردن افکت outline
                // const outlineMesh = setupOutlineEffect(model);
                // model.userData.outline = outlineMesh; // ذخیره برای دسترسی بعدی

                // if (aIagentAnimations.length > 0) {
                //   const aiagentAction = aIagentMixer.clipAction(aIagentAnimations[0]);
                //   aiagentAction.reset().play();
                // }

                // // اضافه کردن افکت فنس
                // const fence = createFenceEffect(model);
                // model.userData.fence = fence;

                // // انیمیشن برای فنس
                // model.userData.animateFence = () => {
                //   if (fence.position.y < 0.5) {
                //     fence.position.y += 0.05;
                //     fence.material.opacity = Math.min(0.7, fence.material.opacity + 0.02);
                //     requestAnimationFrame(model.userData.animateFence);
                //   }
                // };
    
                // model.userData.hideFence = () => {
                //   if (fence.position.y > -0.5) {
                //     fence.position.y -= 0.05;
                //     fence.material.opacity = Math.max(0, fence.material.opacity - 0.02);
                //     requestAnimationFrame(model.userData.hideFence);
                //   } else {
                //     fence.visible = false;
                //   }
                // };

                await checkAllLoaded();
              },
              3.5,
              new THREE.Vector3(-15, 0, -23),
              0,
              false,
              0,
              false,
              new THREE.Vector3(1, 5, 1),
              0xffffff,
              0.2,
              new THREE.Vector3(-15, 0, -23),
              false,
              '',
              true,
              new THREE.Vector3(8, 5, 5.6),
              0xff0000,
              0.0,
              new THREE.Vector3(-15, 0, -23),
              true,
              '/viewModel?modelref=aiagentt',
              false,
              DIRECTIONS.EAST,
            );

            // asset2 val
            loadModel(
              '/models/winter/asset2.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localTelegrambotModel = model;
                telegrambotBody = body;
                telegrambotMixer = new THREE.AnimationMixer(model);
                telegrambotAnimations = gltf.animations;
                telegrambotBox = new THREE.Box3().setFromObject(model);
                if (telegrambotAnimations.length > 0) {
                  const telegrambotAction = telegrambotMixer.clipAction(telegrambotAnimations[0]);
                  telegrambotAction.reset().play();
                }

    //             // اضافه کردن افکت فنس
    // const fence = createFenceEffectRed(model);
    // model.userData.fence = fence;
    
    // // انیمیشن برای فنس
    // model.userData.animateFence = () => {
    //   if (fence.position.y < 0.5) {
    //     fence.position.y += 0.05;
    //     fence.material.opacity = Math.min(0.7, fence.material.opacity + 0.02);
    //     requestAnimationFrame(model.userData.animateFence);
    //   }
    // };
    
    // model.userData.hideFence = () => {
    //   if (fence.position.y > -0.5) {
    //     fence.position.y -= 0.05;
    //     fence.material.opacity = Math.max(0, fence.material.opacity - 0.02);
    //     requestAnimationFrame(model.userData.hideFence);
    //   } else {
    //     fence.visible = false;
    //   }
    // };

                await checkAllLoaded();
              },
              3.5,
              new THREE.Vector3(16, 0, -13),
              0,
              false,
              0,
              false,
              new THREE.Vector3(4, 4, 4),
              0xffffff,
              0.2,
              new THREE.Vector3(16, 0, -13),
              false,
              '',
              true,
              new THREE.Vector3(9, 5, 4.6),
              0xff0000,
              0.0,
              new THREE.Vector3(16, 0, -13),
              true,
              'https://www.google.com/search?q=telegrambot',
              false,
              DIRECTIONS.EAST,
            );
            
            // asset3 fazae
            loadModel(
              '/models/winter/asset3.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localARframeModel = model;
                aRframeBody = body;
                aRframeMixer = new THREE.AnimationMixer(model);
                aRframeAnimations = gltf.animations;
                aRframeBox = new THREE.Box3().setFromObject(model);
                if (aRframeAnimations.length > 0) {
                  const aRframeAction = aRframeMixer.clipAction(aRframeAnimations[0]);
                  aRframeAction.reset().play();
                }
                await checkAllLoaded();
              },
              3.5,
              new THREE.Vector3(-13, 0, -1),
              0,
              false,
              0,
              false,
              new THREE.Vector3(1, 5, 1),
              0xffffff,
              0.2,
              new THREE.Vector3(-13, 0, -1),
              false,
              '',
              true,
              new THREE.Vector3(6, 9, 5),
              0xff0000,
              0.0,
              new THREE.Vector3(-13, 0, -1),
              true,
              'https://www.google.com/search?q=arframe',
              false,
              DIRECTIONS.EAST,
            );

            // asset4 vr
            loadModel(
              '/models/winter/asset4.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localARboardModel = model;
                aRboardBody = body;
                aRboardMixer = new THREE.AnimationMixer(model);
                aRboardAnimations = gltf.animations;
                aRboardBox = new THREE.Box3().setFromObject(model);
                if (aRboardAnimations.length > 0) {
                  const aRboardAction = aRboardMixer.clipAction(aRboardAnimations[0]);
                  aRboardAction.reset().play();
                }
                await checkAllLoaded();
              },
              3.5,
              new THREE.Vector3(17, 0, 11),
              0,
              false,
              0,
              false,
              new THREE.Vector3(1, 5, 1),
              0xffffff,
              0.2,
              new THREE.Vector3(17, 0, 11),
              false,
              '',
              true,
              new THREE.Vector3(8, 5, 5),
              0xff0000,
              0.0,
              new THREE.Vector3(17, 0, 11),
              false,
              'https://www.google.com/search?q=aRboard',
              false,
              DIRECTIONS.EAST,
            );

            // asset5 pangoan
            loadModel(
              '/models/winter/asset5.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localInteractiveModel = model;
                interactiveBody = body;
                interactiveMixer = new THREE.AnimationMixer(model);
                interactiveAnimations = gltf.animations;
                interactiveBox = new THREE.Box3().setFromObject(model);
                if (interactiveAnimations.length > 0) {
                  const interactiveAction = interactiveMixer.clipAction(interactiveAnimations[0]);
                  interactiveAction.reset().play();
                }
                await checkAllLoaded();
              },
              3.5,
              new THREE.Vector3(-12, 0, 26),
              0,
              false,
              0,
              false,
              new THREE.Vector3(1, 5, 1),
              0xffffff,
              0.2,
              new THREE.Vector3(-12, 0, 26),
              false,
              '',
              true,
              new THREE.Vector3(6, 6, 5),
              0xff0000,
              0.0,
              new THREE.Vector3(-12, 0, 26),
              true,
              'https://www.google.com/search?q=interactive',
              false,
              DIRECTIONS.EAST,
            );

            // // all
            // loadModel(
            //   '/models/ice-interactive-transformed.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localTreeModel = model;
            //     treeBody = body;
            //     treeMixer = new THREE.AnimationMixer(model);
            //     treeAnimations = gltf.animations;
            //     treeBox = new THREE.Box3().setFromObject(model);
            //     if (treeAnimations.length > 0) {
            //       const treeAction = treeMixer.clipAction(treeAnimations[0]);
            //       treeAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   6,
            //   new THREE.Vector3(0, 0, 0),
            //   0,
            //   false,
            //   0,
            //   false,
            //   new THREE.Vector3(1, 5, 1),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-13, 0, -1),
            //   false,
            //   '',
            //   true,
            //   new THREE.Vector3(5, 9, 5),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-13, 0, -1),
            //   true,
            //   'https://www.google.com/search?q=arframe',
            //   false,
            //   DIRECTIONS.EAST,
            // );
      
            // xlab1x winter ball sphere
            // loadModel(
            //   '/models/winter/ball.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localXlab1XModel = model;
            //     xlab1XBody = body;
            //     xlab1XMixer = new THREE.AnimationMixer(model);
            //     xlab1XAnimations = gltf.animations;
            //     xlab1XBox = new THREE.Box3().setFromObject(model);
            //     if (xlab1XAnimations.length > 0) {
            //       const xlab1xAction = xlab1XMixer.clipAction(xlab1XAnimations[0]);
            //       xlab1xAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(0, 1, -20),
            //   1,
            //   true,
            //   1,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-35, 0, 30),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-35, 0, 30),
            //   false,
            //   'https://www.google.com/search?q=xlab',
            //   false,
            //   new THREE.Vector3(0, 90, 0),
            //   new THREE.Vector3(0, 0, 0),
            //   new THREE.Vector3(3.5, 4, 1.5)
            // );

            
            // // xlab1l
            // loadModel(
            //   '/models/mab0626/l.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localXlab1LModel = model;
            //     xlab1LBody = body;
            //     xlab1LMixer = new THREE.AnimationMixer(model);
            //     xlab1LAnimations = gltf.animations;
            //     xlab1LBox = new THREE.Box3().setFromObject(model);
            //     if (xlab1LAnimations.length > 0) {
            //       const xlab1LAction = xlab1LMixer.clipAction(xlab1LAnimations[0]);
            //       xlab1LAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(-17, 1, 25),
            //   1,
            //   true,
            //   1,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-35, 0, 25),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-35, 0, 25),
            //   false,
            //   'https://www.google.com/search?q=xlab',
            //   false,
            //   new THREE.Vector3(0, 90, 0),
            //   new THREE.Vector3(0, 0, 0),
            //   new THREE.Vector3(3.1, 4, 1.5)
            // );
            // // xlab1a
            // loadModel(
            //   '/models/mab0626/a.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localXlab1AModel = model;
            //     xlab1ABody = body;
            //     xlab1AMixer = new THREE.AnimationMixer(model);
            //     xlab1AAnimations = gltf.animations;
            //     xlab1ABox = new THREE.Box3().setFromObject(model);
            //     if (xlab1AAnimations.length > 0) {
            //       const xlab1AAction = xlab1AMixer.clipAction(xlab1AAnimations[0]);
            //       xlab1AAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(-17, 1, 20),
            //   1,
            //   true,
            //   1,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-35, 0, 20),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-35, 0, 20),
            //   false,
            //   'https://www.google.com/search?q=xlab',
            //   false,
            //   new THREE.Vector3(0, 90, 0),
            //   new THREE.Vector3(0, 0, 0),
            //   new THREE.Vector3(3.7, 4, 1.5)
            // );
            // // xlab1b
            // loadModel(
            //   '/models/mab0626/b.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localXlab1BModel = model;
            //     xlab1BBody = body;
            //     xlab1BMixer = new THREE.AnimationMixer(model);
            //     xlab1BAnimations = gltf.animations;
            //     xlab1BBox = new THREE.Box3().setFromObject(model);
            //     if (xlab1BAnimations.length > 0) {
            //       const xlab1BAction = xlab1BMixer.clipAction(xlab1BAnimations[0]);
            //       xlab1BAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(-17, 1, 15),
            //   1,
            //   true,
            //   1,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-35, 0, 15),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-35, 0, 15),
            //   false,
            //   'https://www.google.com/search?q=xlab',
            //   false,
            //   new THREE.Vector3(0, 90, 0),
            //   new THREE.Vector3(0, 0, 0),
            //   new THREE.Vector3(3.5, 4, 1.5)
            // );
      
            // // drone1
            // loadModel(
            //   '/models/mab0626/drone1.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localdrone1Model = model;
            //     drone1Body = body;
            //     drone1Mixer = new THREE.AnimationMixer(model);
            //     drone1Animations = gltf.animations;
            //     drone1Box = new THREE.Box3().setFromObject(model);
            //     if (drone1Animations.length > 0) {
            //       const drone1Action = drone1Mixer.clipAction(drone1Animations[0]);
            //       drone1Action.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(3, 3, -15),
            //   0.3,
            //   false,
            //   0,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(20, 30, -20),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.2,
            //   new THREE.Vector3(10, 0, 0),
            //   false,
            //   'https://www.google.com/search?q=drone1'
            // );
      
            // // drone2
            // loadModel(
            //   '/models/mab0626/drone2.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localdrone2Model = model;
            //     drone2Body = body;
            //     drone2Mixer = new THREE.AnimationMixer(model);
            //     drone2Animations = gltf.animations;
            //     drone2Box = new THREE.Box3().setFromObject(model);
            //     if (drone2Animations.length > 0) {
            //       const drone2Action = drone2Mixer.clipAction(drone2Animations[0]);
            //       drone2Action.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(-3, 3, -2),
            //   0.3,
            //   false,
            //   0,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(10, 0, 10),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(10, 0, 10),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-20, 30, -20),
            //   false,
            //   'https://www.google.com/search?q=drone2'
            // );

// // ******************
// // ******************
            // start create similar ModelsPositionSize
            // تابع کمکی برای بارگذاری مدل‌ها از آرایه
            // const treePathttt='/models/winter/tree.glb';
            async function loadSameSizeFromArray(dataArray) {
              // بررسی می‌کنیم که آیا کامپوننت مونته شده است یا نه
              // (فرض می‌کنیم isMounted به صورت گلوبال یا در اسکوپ بیرونی تعریف شده)
              if (!isMounted) return;

              const modelBoniBoxSameSize = new THREE.Vector3(6, 4, 1.5);
              // حلقه روی هر عنصر آرایه
              for (const item of dataArray) {
                const { modelPthValue, vectorLocationValue, rotationValue } = item;
              
                //const randomScaleValue = Math.round((0.8 + Math.random() * 0.4) * 100) / 100;
                const randomScaleValue = 3;//4 + Math.random() * 0.8;
              
                // فراخوانی تابع loadModel با پارامترهای مورد نظر
                loadModel(
                  modelPthValue, // مقدار رشته‌ای
                  async (gltf, model, body) => {
                    if (!isMounted) return;
                    localBilboardModel = model;
                    bilboardBody = body;
                    bilboardMixer = new THREE.AnimationMixer(model);
                    bilboardAnimations = gltf.animations;
                    bilboardBox = new THREE.Box3().setFromObject(model);
                    if (bilboardAnimations.length > 0) {
                      const bilboardAction = bilboardMixer.clipAction(bilboardAnimations[0]);
                      bilboardAction.reset().play();
                    }
                    await checkAllLoaded();
                  },
                  randomScaleValue,
                  vectorLocationValue, // مقدار THREE.Vector3
                  0,
                  false,
                  0,
                  false,
                  modelBoniBoxSameSize,
                  0xffffff,
                  0.2,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  false,
                  '',
                  true,
                  modelBoniBoxSameSize,
                  0xff0000,
                  1.0,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  true,
                  '#',
                  false,
                  rotationValue // مقدار createRotation(x, x, x)
                );
              }
            }

            // مثال استفاده از تابع:
            // آرایه‌ای از داده‌ها را تعریف می‌کنیم
            const myDataSameSizeArray = [
              {
                modelPthValue: '/models/winter/investments.glb',
                vectorLocationValue: new THREE.Vector3(-7, 0, -27),
                rotationValue: DIRECTIONS.EAST
              },
              {
                modelPthValue: '/models/winter/analytica.glb',
                vectorLocationValue: new THREE.Vector3(7, 0, -16),
                rotationValue: createRotation(90,0,0)
              },
              {
                modelPthValue: '/models/winter/unlimit.glb',
                vectorLocationValue: new THREE.Vector3(-6, 0, -5),
                rotationValue:DIRECTIONS.EAST
              },
              {
                modelPthValue: '/models/winter/cyberlab.glb',
                vectorLocationValue: new THREE.Vector3(7, 0, 7),
                rotationValue: createRotation(90,0,0)
              },
              {
                modelPthValue: '/models/winter/planb.glb',
                vectorLocationValue: new THREE.Vector3(-6, 0, 23),
                rotationValue: DIRECTIONS.EAST
              }
            ];

            // سپس تابع را فراخوانی می‌کنیم
            loadSameSizeFromArray(myDataSameSizeArray);
            // end similar Size
// // ******************
// // ******************

// // ******************
// // ******************
            // start create similar ModelsPositionSize
            // تابع کمکی برای بارگذاری مدل‌ها از آرایه
            const treePath='/models/winter/tree.glb';
            async function loadSameModelsPositionSizeFromArray(dataArray) {
              // بررسی می‌کنیم که آیا کامپوننت مونته شده است یا نه
              // (فرض می‌کنیم isMounted به صورت گلوبال یا در اسکوپ بیرونی تعریف شده)
              if (!isMounted) return;

              // حلقه روی هر عنصر آرایه
              for (const item of dataArray) {
                const { vectorLocationValue, rotationValue } = item;
              
                //const randomScaleValue = Math.round((0.8 + Math.random() * 0.4) * 100) / 100;
                const randomScaleValue = 4.5 + Math.random() * 1.2;
              
                // فراخوانی تابع loadModel با پارامترهای مورد نظر
                loadModel(
                  treePath, // مقدار رشته‌ای
                  async (gltf, model, body) => {
                    if (!isMounted) return;
                    localTreeModel = model;
                    treeBody = body;
                    treeMixer = new THREE.AnimationMixer(model);
                    treeAnimations = gltf.animations;
                    treeBox = new THREE.Box3().setFromObject(model);
                    if (treeAnimations.length > 0) {
                      const treeAction = treeMixer.clipAction(treeAnimations[0]);
                      treeAction.reset().play();
                    }
                    await checkAllLoaded();
                  },
                  randomScaleValue,
                  vectorLocationValue, // مقدار THREE.Vector3
                  0,
                  false,
                  0,
                  false,
                  new THREE.Vector3(1, 1, 1),
                  0xffffff,
                  0.2,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  false,
                  '',
                  true,
                  new THREE.Vector3(2.5, 5, 2.5),
                  0xff0000,
                  0.0,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  true,
                  'https://www.google.com/search?q=tree',
                  false,
                  rotationValue // مقدار createRotation(x, x, x)
                );
              }
            }

            // مثال استفاده از تابع:
            // آرایه‌ای از داده‌ها را تعریف می‌کنیم
            const myDataSameModelsPositionSizeArray = [
              // {
              //   vectorLocationValue: new THREE.Vector3(18, 0, 35),
              //   rotationValue: createRotation(80, 0, 0)
              // },
              // {
              //   vectorLocationValue: new THREE.Vector3(20, 0, 35),
              //   rotationValue: createRotation(70, 0, 0)
              // },
              {
                vectorLocationValue: new THREE.Vector3(-10, 0, -38),
                rotationValue: createRotation(70, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-18, 0, -38),
                rotationValue: createRotation(30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-9, 0, -46),
                rotationValue: createRotation(10, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-15, 0, -44),
                rotationValue: createRotation(-30, 0, 0)
              },
              // {
              //   vectorLocationValue: new THREE.Vector3(-10, 0, -48),
              //   rotationValue: createRotation(65, 0, 0)
              // },
              {
                vectorLocationValue: new THREE.Vector3(-12, 0, -50),
                rotationValue: createRotation(-20, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-7, 0, -54),
                rotationValue: createRotation(65, 0, 0)
              },
              // {
              //   vectorLocationValue: new THREE.Vector3(-2, 0, -50),
              //   rotationValue: createRotation(10, 0, 0)
              // },
              // {
              //   vectorLocationValue: new THREE.Vector3(-1, 0, -52),
              //   rotationValue: createRotation(-65, 0, 0)
              // },
              // {
              //   vectorLocationValue: new THREE.Vector3(-6, 0, -50),
              //   rotationValue: createRotation(25, 0, 0)
              // },

              
              {
                vectorLocationValue: new THREE.Vector3(10, 0, -38),
                rotationValue: createRotation(70, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(18, 0, -35),
                rotationValue: createRotation(30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(8, 0, -44),
                rotationValue: createRotation(10, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(15, 0, -46),
                rotationValue: createRotation(-30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(10, 0, -48),
                rotationValue: createRotation(65, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(2, 0, -45),
                rotationValue: createRotation(-20, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(0, 0, -53),
                rotationValue: createRotation(65, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(4, 0, -56),
                rotationValue: createRotation(10, 0, 0)
              },
              // {
              //   vectorLocationValue: new THREE.Vector3(1, 0, -52),
              //   rotationValue: createRotation(-65, 0, 0)
              // },
              // {
              //   vectorLocationValue: new THREE.Vector3(6, 0, -50),
              //   rotationValue: createRotation(25, 0, 0)
              // },

              
              {
                vectorLocationValue: new THREE.Vector3(-8, 0, -31),
                rotationValue: createRotation(-25, 0, 0)
              },{
                vectorLocationValue: new THREE.Vector3(-17, 0, -30),
                rotationValue: createRotation(-80, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-9, 0, -18),
                rotationValue: createRotation(25, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-19, 0, -11),
                rotationValue: createRotation(60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-11, 0, -9),
                rotationValue: createRotation(30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-11, 0, 9),
                rotationValue: createRotation(10, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-20, 0, 15),
                rotationValue: createRotation(35, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-14, 0, 19),
                rotationValue: createRotation(-80, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-10, 0, 30),
                rotationValue: createRotation(-60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-20, 0, 34),
                rotationValue: createRotation(60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-16, 0, 47),
                rotationValue: createRotation(10, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(-9, 0, 52),
                rotationValue: createRotation(-20, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(0, 0, 45),
                rotationValue: createRotation(30, 0, 0)
              }

              ,
              {
                vectorLocationValue: new THREE.Vector3(8, 0, -31),
                rotationValue: createRotation(-25, 0, 0)
              },{
                vectorLocationValue: new THREE.Vector3(17, 0, -30),
                rotationValue: createRotation(-80, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(9, 0, -18),
                rotationValue: createRotation(25, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(19, 0, -9),
                rotationValue: createRotation(60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(11, 0, -6),
                rotationValue: createRotation(30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(11, 0, 5),
                rotationValue: createRotation(10, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(20, 0, 7),
                rotationValue: createRotation(-60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(14, 0, 19),
                rotationValue: createRotation(60, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(10, 0, 30),
                rotationValue: createRotation(-30, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(20, 0, 34),
                rotationValue: createRotation(20, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(16, 0, 47),
                rotationValue: createRotation(-40, 0, 0)
              },
              {
                vectorLocationValue: new THREE.Vector3(9, 0, 52),
                rotationValue: createRotation(70, 0, 0)
              },
              // {
              //   vectorLocationValue: new THREE.Vector3(0, 0, 45),
              //   rotationValue: createRotation(60, 0, 0)
              // }
            ];

            // سپس تابع را فراخوانی می‌کنیم
            loadSameModelsPositionSizeFromArray(myDataSameModelsPositionSizeArray);
            // end similar ModelsPositionSize
// // ******************
// // ******************

// // ******************
// // ******************
            // start create logo similar ModelsPositionSize
            // تابع کمکی برای بارگذاری مدل‌ها از آرایه
            const logoPath='/models/winter/logo.glb';
            async function loadLogoSameModelsPositionSizeFromArray(dataArray) {
              // بررسی می‌کنیم که آیا کامپوننت مونته شده است یا نه
              // (فرض می‌کنیم isMounted به صورت گلوبال یا در اسکوپ بیرونی تعریف شده)
              if (!isMounted) return;

              // حلقه روی هر عنصر آرایه
              for (const item of dataArray) {
                const { vectorLocationValue, rotationValue } = item;
              
                //const randomScaleValue = Math.round((0.8 + Math.random() * 0.4) * 100) / 100;
                const randomScaleValue = 3;//4.5 + Math.random() * 1.2;
              
                // فراخوانی تابع loadModel با پارامترهای مورد نظر
                loadModel(
                  logoPath, // مقدار رشته‌ای
                  async (gltf, model, body) => {
                    if (!isMounted) return;
                    localTreeModel = model;
                    treeBody = body;
                    mainLogoModels.push(model);
                    model.userData.isMainRotatingLogo = true;
                    treeMixer = new THREE.AnimationMixer(model);
                    treeAnimations = gltf.animations;
                    treeBox = new THREE.Box3().setFromObject(model);
                    if (treeAnimations.length > 0) {
                      const treeAction = treeMixer.clipAction(treeAnimations[0]);
                      treeAction.reset().play();
                    }
                    await checkAllLoaded();
                  },
                  randomScaleValue,
                  vectorLocationValue, // مقدار THREE.Vector3
                  0,
                  false,
                  0,
                  false,
                  new THREE.Vector3(1, 1, 1),
                  0xffffff,
                  0.2,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  false,
                  '',
                  true,
                  new THREE.Vector3(2, 2, 2),
                  0xff0000,
                  0.0,
                  vectorLocationValue, // مقدار THREE.Vector3 (دوباره استفاده شده)
                  true,
                  'https://www.google.com/search?q=tree',
                  false,
                  rotationValue // مقدار createRotation(x, x, x)
                );
              }
            }

            // مثال استفاده از تابع:
            // آرایه‌ای از داده‌ها را تعریف می‌کنیم
            const myDataLogoSameModelsPositionSizeArray = [
              {
                vectorLocationValue: new THREE.Vector3(-17.5, 2, -23),
                rotationValue: DIRECTIONS.EAST
              },
              {
                vectorLocationValue: new THREE.Vector3(18.5, 2, -13),
                rotationValue: DIRECTIONS.EAST
              },
              {
                vectorLocationValue: new THREE.Vector3(-15.5, 2, -1),
                rotationValue: DIRECTIONS.EAST
              },
              {
                vectorLocationValue: new THREE.Vector3(19.5, 2, 11),
                rotationValue: DIRECTIONS.EAST
              },
              {
                vectorLocationValue: new THREE.Vector3(-14.5, 2, 26),
                rotationValue: DIRECTIONS.EAST
              },
            ];

            // سپس تابع را فراخوانی می‌کنیم
            loadLogoSameModelsPositionSizeFromArray(myDataLogoSameModelsPositionSizeArray);
            // end Logo similar ModelsPositionSize
// // ******************
// // ******************

            // open AIagent
            loadModel(
              //'/models/winter/react.glb',
              '/models/open/reactb.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localOpenAIagentModel = model;
                openAIagentBody = body;
                openAIagentMixer = new THREE.AnimationMixer(model);
                openAIagentAnimations = gltf.animations;
                openAIagentBox = new THREE.Box3().setFromObject(model);
                if (openAIagentAnimations.length > 0) {
                  const xAction = openAIagentMixer.clipAction(openAIagentAnimations[0]);
                  xAction.reset().play();
                }

                //createFenceEffect(model);
                createOpenModelEffect(localOpenAIagentModel);
                localOpenAIagentModel.userData.isInteractiveRoot =true;

                interactiveModels.push({
                  name: 'OpenAIagent',
                  modelRef: () => localOpenAIagentModel,
                  mixer: () => openAIagentMixer,
                  link: '/viewModel?modelref=aiagent',
                  external: true,
    collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiagent area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiagent area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    
    
    onEnter: () => {
      console.log(
  'openAI fence:',
  !!localOpenAIagentModel?.userData?.fence
);

  const openModel = localOpenAIagentModel;
  if (!openModel?.userData?.fence) return;

  const fence = openModel.userData.fence;

  if (!fence.visible) {
    fence.visible = true;
    fence.position.y = -0.5;

    fence.traverse(child => {
      if (child.isMesh) child.material.opacity = 0;
    });

    openModel.userData.animateFence();
  }
},

onExit: () => {
  const openModel = localOpenAIagentModel;
  if (!openModel?.userData?.hideFence) return;

  openModel.userData.hideFence();
},

            
                });

                await checkAllLoaded();
              },
              1.2,
              new THREE.Vector3(-6, 0.1, -23),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              true
            );

            // open ARboard
            loadModel(
              //'/models/winter/react.glb',
              '/models/open/reactb.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localOpenARboardModel = model;
                openARboardBody = body;
                openARboardMixer = new THREE.AnimationMixer(model);
                openARboardAnimations = gltf.animations;
                openARboardBox = new THREE.Box3().setFromObject(model);
                if (openARboardAnimations.length > 0) {
                  const xAction = openARboardMixer.clipAction(openARboardAnimations[0]);
                  xAction.reset().play();
                }

                //createFenceEffect(model);
                createOpenModelEffect(localOpenARboardModel);
                localOpenARboardModel.userData.isInteractiveRoot =true;

                interactiveModels.push({
                  name: 'OpenARboard',
                  modelRef: () => localOpenARboardModel,
                  mixer: () => openARboardMixer,
                  link: '/viewModel?modelref=aiagent',
                  external: true,
    collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiagent area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiagent area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    
    
    onEnter: () => {
      console.log(
  'openAI fence:',
  !!localOpenARboardModel?.userData?.fence
);

  const openModel = localOpenARboardModel;
  if (!openModel?.userData?.fence) return;

  const fence = openModel.userData.fence;

  if (!fence.visible) {
    fence.visible = true;
    fence.position.y = -0.5;

    fence.traverse(child => {
      if (child.isMesh) child.material.opacity = 0;
    });

    openModel.userData.animateFence();
  }
},

onExit: () => {
  const openModel = localOpenARboardModel;
  if (!openModel?.userData?.hideFence) return;

  openModel.userData.hideFence();
},

            
                });

                await checkAllLoaded();
              },
              1.2,
              new THREE.Vector3(7, 0.1, -13),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              true
            );

            // open ARframe
            loadModel(
              //'/models/winter/react.glb',
              '/models/open/reactb.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localOpenARframeModel = model;
                openARframeBody = body;
                openARframeMixer = new THREE.AnimationMixer(model);
                openARframeAnimations = gltf.animations;
                openARframeBox = new THREE.Box3().setFromObject(model);
                if (openARframeAnimations.length > 0) {
                  const xAction = openARframeMixer.clipAction(openARframeAnimations[0]);
                  xAction.reset().play();
                }

                //createFenceEffect(model);
                createOpenModelEffect(localOpenARframeModel);
                localOpenARframeModel.userData.isInteractiveRoot =true;

                interactiveModels.push({
                  name: 'OpenARframe',
                  modelRef: () => localOpenARframeModel,
                  mixer: () => openARframeMixer,
                  link: '/viewModel?modelref=aiagent',
                  external: true,
    collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiagent area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiagent area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    
    
    onEnter: () => {
      console.log(
  'openAI fence:',
  !!localOpenARframeModel?.userData?.fence
);

  const openModel = localOpenARframeModel;
  if (!openModel?.userData?.fence) return;

  const fence = openModel.userData.fence;

  if (!fence.visible) {
    fence.visible = true;
    fence.position.y = -0.5;

    fence.traverse(child => {
      if (child.isMesh) child.material.opacity = 0;
    });

    openModel.userData.animateFence();
  }
},

onExit: () => {
  const openModel = localOpenARframeModel;
  if (!openModel?.userData?.hideFence) return;

  openModel.userData.hideFence();
},

            
                });

                await checkAllLoaded();
              },
              1.2,
              new THREE.Vector3(-6, 0.1, -2),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              true
            );

            // open Interactive
            loadModel(
              //'/models/winter/react.glb',
              '/models/open/reactb.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localOpenInteractiveModel = model;
                openInteractiveBody = body;
                openInteractiveMixer = new THREE.AnimationMixer(model);
                openInteractiveAnimations = gltf.animations;
                openInteractiveBox = new THREE.Box3().setFromObject(model);
                if (openInteractiveAnimations.length > 0) {
                  const xAction = openInteractiveMixer.clipAction(openInteractiveAnimations[0]);
                  xAction.reset().play();
                }

                //createFenceEffect(model);
                createOpenModelEffect(localOpenInteractiveModel);
                localOpenInteractiveModel.userData.isInteractiveRoot =true;

                interactiveModels.push({
                  name: 'OpenInteractive',
                  modelRef: () => localOpenInteractiveModel,
                  mixer: () => openInteractiveMixer,
                  link: '/viewModel?modelref=aiagent',
                  external: true,
    collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiagent area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiagent area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    
    
    onEnter: () => {
      console.log(
  'openAI fence:',
  !!localOpenInteractiveModel?.userData?.fence
);

  const openModel = localOpenInteractiveModel;
  if (!openModel?.userData?.fence) return;

  const fence = openModel.userData.fence;

  if (!fence.visible) {
    fence.visible = true;
    fence.position.y = -0.5;

    fence.traverse(child => {
      if (child.isMesh) child.material.opacity = 0;
    });

    openModel.userData.animateFence();
  }
},

onExit: () => {
  const openModel = localOpenInteractiveModel;
  if (!openModel?.userData?.hideFence) return;

  openModel.userData.hideFence();
},

            
                });

                await checkAllLoaded();
              },
              1.2,
              new THREE.Vector3(7, 0.1, 10),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              true
            );

            // open Metaweb
            loadModel(
              //'/models/winter/react.glb',
              '/models/open/reactb.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localOpenMetawebModel = model;
                openMetawebBody = body;
                openMetawebMixer = new THREE.AnimationMixer(model);
                openMetawebAnimations = gltf.animations;
                openMetawebBox = new THREE.Box3().setFromObject(model);
                if (openMetawebAnimations.length > 0) {
                  const xAction = openMetawebMixer.clipAction(openMetawebAnimations[0]);
                  xAction.reset().play();
                }

                //createFenceEffect(model);
                createOpenModelEffect(localOpenMetawebModel);
                localOpenMetawebModel.userData.isInteractiveRoot =true;

                interactiveModels.push({
                  name: 'OpenMetaweb',
                  modelRef: () => localOpenMetawebModel,
                  mixer: () => openMetawebMixer,
                  link: '/viewModel?modelref=aiagent',
                  external: true,
    collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiagent area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiagent area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    
    
    onEnter: () => {
      console.log(
  'openAI fence:',
  !!localOpenMetawebModel?.userData?.fence
);

  const openModel = localOpenMetawebModel;
  if (!openModel?.userData?.fence) return;

  const fence = openModel.userData.fence;

  if (!fence.visible) {
    fence.visible = true;
    fence.position.y = -0.5;

    fence.traverse(child => {
      if (child.isMesh) child.material.opacity = 0;
    });

    openModel.userData.animateFence();
  }
},

onExit: () => {
  const openModel = localOpenMetawebModel;
  if (!openModel?.userData?.hideFence) return;

  openModel.userData.hideFence();
},

            
                });

                await checkAllLoaded();
              },
              1.2,
              new THREE.Vector3(-6, 0.1, 26),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(50, 50, 50),
              false,
              '',
              false,
              new THREE.Vector3(6, 6, 6),
              0xff0000,
              0.0,
              new THREE.Vector3(50, 50, 50),
              true,
              'https://www.google.com/search?q=x',
              true
            );

    //         // open Telegrambot
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenTelegrambotModel = model;
    //             openTelegrambotBody = body;
    //             openTelegrambotMixer = new THREE.AnimationMixer(model);
    //             openTelegrambotAnimations = gltf.animations;
    //             openTelegrambotBox = new THREE.Box3().setFromObject(model);
    //             if (openTelegrambotAnimations.length > 0) {
    //               const xAction = openTelegrambotMixer.clipAction(openTelegrambotAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             // createFenceEffect(model);
    //             createOpenModelEffect(model);

    //             interactiveModels.push({
    //               name: 'OpenTelegrambot',
    //               modelRef: () => localOpenTelegrambotModel,
    //               mixer: () => openTelegrambotMixer,
    //               link: '/viewModel?modelref=telegrambot',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered telegrambot area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited telegrambot area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           1.2,
    //           new THREE.Vector3(-9, 0.1, -23.5),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );

    //         // open ARboard
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenARboardModel = model;
    //             openARboardBody = body;
    //             openARboardMixer = new THREE.AnimationMixer(model);
    //             openARboardAnimations = gltf.animations;
    //             openARboardBox = new THREE.Box3().setFromObject(model);
    //             if (openARboardAnimations.length > 0) {
    //               const xAction = openARboardMixer.clipAction(openARboardAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenARboard',
    //               modelRef: () => localOpenARboardModel,
    //               mixer: () => openARboardMixer,
    //               link: '/viewModel?modelref=arboard',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered aiboard area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited aiboard area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           1.2,
    //           new THREE.Vector3(-9, 0.1, -3),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );
            
    //         // open ARframe
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenARframeModel = model;
    //             openARframeBody = body;
    //             openARframeMixer = new THREE.AnimationMixer(model);
    //             openARframeAnimations = gltf.animations;
    //             openARframeBox = new THREE.Box3().setFromObject(model);
    //             if (openARframeAnimations.length > 0) {
    //               const xAction = openARframeMixer.clipAction(openARframeAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenARframe',
    //               modelRef: () => localOpenARframeModel,
    //               mixer: () => openARframeMixer,
    //               link: '/viewModel?modelref=arframe',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered arframe area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited arframe area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           1.2,
    //           new THREE.Vector3(9, 0.1, -3),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );

    //         // open Metaweb
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenMetawebModel = model;
    //             openMetawebBody = body;
    //             openMetawebMixer = new THREE.AnimationMixer(model);
    //             openMetawebAnimations = gltf.animations;
    //             openMetawebBox = new THREE.Box3().setFromObject(model);
    //             if (openMetawebAnimations.length > 0) {
    //               const xAction = openMetawebMixer.clipAction(openMetawebAnimations[0]);
    //               xAction.reset().play();
    //             }
                
    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenMetaweb',
    //               modelRef: () => localOpenMetawebModel,
    //               mixer: () => openMetawebMixer,
    //               link: '/viewModel?modelref=metaweb',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered metaweb area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited metaweb area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           1.2,
    //           new THREE.Vector3(-9, 0.1, 16.5),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );

    //         // open Interactive
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenInteractiveModel = model;
    //             openInteractiveBody = body;
    //             openInteractiveMixer = new THREE.AnimationMixer(model);
    //             openInteractiveAnimations = gltf.animations;
    //             openInteractiveBox = new THREE.Box3().setFromObject(model);
    //             if (openInteractiveAnimations.length > 0) {
    //               const xAction = openInteractiveMixer.clipAction(openInteractiveAnimations[0]);
    //               xAction.reset().play();
    //             }
    
    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenInteractive',
    //               modelRef: () => localOpenInteractiveModel,
    //               mixer: () => openInteractiveMixer,
    //               link: '/viewModel?modelref=interactive',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered interactive area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited interactive area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           1.2,
    //           new THREE.Vector3(9, 0.1, 16.5),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );

    //         // open instagramSocial
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpeninstagramSocialModel = model;
    //             openinstagramSocialBody = body;
    //             openinstagramSocialMixer = new THREE.AnimationMixer(model);
    //             openinstagramSocialAnimations = gltf.animations;
    //             openinstagramSocialBox = new THREE.Box3().setFromObject(model);
    //             if (openinstagramSocialAnimations.length > 0) {
    //               const xAction = openinstagramSocialMixer.clipAction(openinstagramSocialAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpeninstagramSocial',
    //               modelRef: () => localOpeninstagramSocialModel,
    //               mixer: () => openinstagramSocialMixer,
    //               link: 'https://instagram.com/#',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered instagramSocial area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited instagramSocial area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           0.6,
    //           new THREE.Vector3(-5, 0.1, 29.7),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );
    //         // open telegramSocial
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpentelegramSocialModel = model;
    //             opentelegramSocialBody = body;
    //             opentelegramSocialMixer = new THREE.AnimationMixer(model);
    //             opentelegramSocialAnimations = gltf.animations;
    //             opentelegramSocialBox = new THREE.Box3().setFromObject(model);
    //             if (opentelegramSocialAnimations.length > 0) {
    //               const xAction = opentelegramSocialMixer.clipAction(opentelegramSocialAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpentelegramSocial',
    //               modelRef: () => localOpentelegramSocialModel,
    //               mixer: () => opentelegramSocialMixer,
    //               link: 'https://t.me/xlabsupport',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered telegramSocial area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited telegramSocial area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           0.6,
    //           new THREE.Vector3(-11, 0.1, 29.7),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );
    //         // open emailSocial
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenemailSocialModel = model;
    //             openemailSocialBody = body;
    //             openemailSocialMixer = new THREE.AnimationMixer(model);
    //             openemailSocialAnimations = gltf.animations;
    //             openemailSocialBox = new THREE.Box3().setFromObject(model);
    //             if (openemailSocialAnimations.length > 0) {
    //               const xAction = openemailSocialMixer.clipAction(openemailSocialAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenemailSocial',
    //               modelRef: () => localOpenemailSocialModel,
    //               mixer: () => openemailSocialMixer,
    //               link: 'mailto:address@email.com',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered emailSocial area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited emailSocial area');
    //   try {
    //     model.userData.hideFence();
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           0.6,
    //           new THREE.Vector3(5, 0.1, 29.7),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );
    //         // open xSocial
    //         loadModel(
    //           '/models/mab0626/react.glb',
    //           async (gltf, model, body) => {
    //             if (!isMounted) return;
    //             localOpenxSocialModel = model;
    //             openxSocialBody = body;
    //             openxSocialMixer = new THREE.AnimationMixer(model);
    //             openxSocialAnimations = gltf.animations;
    //             openxSocialBox = new THREE.Box3().setFromObject(model);
    //             if (openxSocialAnimations.length > 0) {
    //               const xAction = openxSocialMixer.clipAction(openxSocialAnimations[0]);
    //               xAction.reset().play();
    //             }

    //             createOpenModelEffect(model);
    //             interactiveModels.push({
    //               name: 'OpenxSocial',
    //               modelRef: () => localOpenxSocialModel,
    //               mixer: () => openxSocialMixer,
    //               link: 'https://x.com/#',
    //               external: true,
    // collisionEffect: true, // فعال بودن برخورد لحظه‌ای
    // onEnter: (model) => {
    //   console.log('Entered xSocial area');
    //   if (!model.userData.fence.visible) {
    //     model.userData.fence.visible = true;
    //     model.userData.fence.position.y = -0.5;
    //     model.userData.fence.traverse((child) => {
    //       if (child.isMesh) child.material.opacity = 0;
    //     });
    //     model.userData.animateFence();
    //   }
    // },
    // onExit: (model) => {
    //   // console.log('Exited xSocial area');
    //   try {
    //     model.userData.hideFence();  
    //   } catch (error) {}
    // },
    //             });

    //             await checkAllLoaded();
    //           },
    //           0.6,
    //           new THREE.Vector3(11, 0.1, 29.7),
    //           0,
    //           false,
    //           0,
    //           false,
    //           new THREE.Vector3(5, 5, 5),
    //           0xffffff,
    //           0.2,
    //           new THREE.Vector3(50, 50, 50),
    //           false,
    //           '',
    //           false,
    //           new THREE.Vector3(6, 6, 6),
    //           0xff0000,
    //           0.0,
    //           new THREE.Vector3(50, 50, 50),
    //           true,
    //           'https://www.google.com/search?q=x',
    //           true
    //         );
            
            
            // // sphere
            // loadModel(
            //   '/models/mab0626/sphere.glb',
            //   async (gltf, model, body) => {
            //     if (!isMounted) return;
            //     localSphareModel = model;
            //     sphareBody = body;
            //     sphareMixer = new THREE.AnimationMixer(model);
            //     sphareAnimations = gltf.animations;
            //     sphareBox = new THREE.Box3().setFromObject(model);
            //     if (sphareAnimations.length > 0) {
            //       const sphareAction = sphareMixer.clipAction(sphareAnimations[0]);
            //       sphareAction.reset().play();
            //     }
            //     await checkAllLoaded();
            //   },
            //   1,
            //   new THREE.Vector3(0, 15, -20),
            //   1,
            //   true,
            //   1,
            //   false,
            //   new THREE.Vector3(5, 5, 5),
            //   0xffffff,
            //   0.2,
            //   new THREE.Vector3(-35, 0, 30),
            //   false,
            //   '',
            //   false,
            //   new THREE.Vector3(6, 6, 6),
            //   0xff0000,
            //   0.0,
            //   new THREE.Vector3(-35, 0, 30),
            //   false,
            //   'https://www.google.com/search?q=sphare',
            //   false,
            //   new THREE.Vector3(0, 90, 0),
            //   new THREE.Vector3(0, 0, 0),
            //   new THREE.Vector3(2, 2, 2)
            // );

const aftercomment="";

            // wall1-1
            loadModel(
              '/models/winter/mounts.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localwall1Model = model;

                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 0.0; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });
                
                wall1Body = body;
                wall1Mixer = new THREE.AnimationMixer(model);
                wall1Animations = gltf.animations;
                wall1Box = new THREE.Box3().setFromObject(model);
                if (wall1Animations.length > 0) {
                  const wall1Action = wall1Mixer.clipAction(wall1Animations[0]);
                  wall1Action.reset().play();
                }
                await checkAllLoaded();
              },
              0.01,
              new THREE.Vector3(24.6, 0, -54.4),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -37),
              false,
              '',
              true,
              new THREE.Vector3(65, 3, 1),
              0xff0000,
              0.0,
              new THREE.Vector3(0, 0, -55),
              false,
              ''
            );
            
            // wall1-3
            loadModel(
              '/models/winter/mounts.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localwall1Model = model;

                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 0.0; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });

                wall1Body = body;
                wall1Mixer = new THREE.AnimationMixer(model);
                wall1Animations = gltf.animations;
                wall1Box = new THREE.Box3().setFromObject(model);
                if (wall1Animations.length > 0) {
                  const wall1Action = wall1Mixer.clipAction(wall1Animations[0]);
                  wall1Action.reset().play();
                }
                await checkAllLoaded();
              },
              0.01,
              new THREE.Vector3(24.6, 0, 54.5),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -37),
              false,
              '',
              true,
              new THREE.Vector3(65, 3, 1),
              0xff0000,
              0.0,
              new THREE.Vector3(0, 0, 54.5),
              false,
              ''
            );
            
            // wall2-1
            loadModel(
              '/models/winter/mounts.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localwall2Model = model;

                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 0.0; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });

                wall2Body = body;
                wall2Mixer = new THREE.AnimationMixer(model);
                wall2Animations = gltf.animations;
                wall2Box = new THREE.Box3().setFromObject(model);
                if (wall2Animations.length > 0) {
                  const wall2Action = wall2Mixer.clipAction(wall2Animations[0]);
                  wall2Action.reset().play();
                }
                await checkAllLoaded();
              },
              0.01,
              new THREE.Vector3(0, 0, 0),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -37),
              false,
              '',
              true,
              new THREE.Vector3(1, 3, 120),
              0xff0000,
              0.0,
              new THREE.Vector3(30, 0, 0),
              false,
              '',
              false,
              new THREE.Vector3(0, 80, 0),
              // new THREE.Vector3(0, 0, 0),
              // new THREE.Vector3(3.1, -0.4, -0.5)
            );
            
            // wall2-3
            loadModel(
              '/models/winter/mounts.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localwall2Model = model;

                // کاهش opacity برای تمام مواد مدل
    model.traverse((node) => {
      if (node.isMesh && node.material) {
        node.material.transparent = true; // ضروری برای opacity
        node.material.opacity = 0.0; // مقدار opacity دلخواه (بین 0 تا 1)
      }
    });

                wall2Body = body;
                wall2Mixer = new THREE.AnimationMixer(model);
                wall2Animations = gltf.animations;
                wall2Box = new THREE.Box3().setFromObject(model);
                if (wall2Animations.length > 0) {
                  const wall2Action = wall2Mixer.clipAction(wall2Animations[0]);
                  wall2Action.reset().play();
                }
                await checkAllLoaded();
              },
              0.01,
              new THREE.Vector3(-30, 0, 0),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -37),
              false,
              '',
              true,
              new THREE.Vector3(1, 3, 120),
              0xff0000,
              0.0,
              new THREE.Vector3(-30, 0, 0),
              false,
              ''
            );

            // wall mounts
            loadModel(
              '/models/winter/mounts.glb',
              async (gltf, model, body) => {
                if (!isMounted) return;
                localwall2Model = model;
                wall2Body = body;
                wall2Mixer = new THREE.AnimationMixer(model);
                wall2Animations = gltf.animations;
                wall2Box = new THREE.Box3().setFromObject(model);
                if (wall2Animations.length > 0) {
                  const wall2Action = wall2Mixer.clipAction(wall2Animations[0]);
                  wall2Action.reset().play();
                }
                await checkAllLoaded();
              },
              7.5,
              new THREE.Vector3(0, 0, 0),
              0,
              false,
              0,
              false,
              new THREE.Vector3(5, 5, 5),
              0xffffff,
              0.2,
              new THREE.Vector3(0, 0, -37),
              false,
              '',
              true,
              new THREE.Vector3(1, 3, 120),
              0xff0000,
              0.0,
              new THREE.Vector3(30, 0, 0),
              false,
              '',
              false,
              new THREE.Vector3(0, 80, 0),
              // new THREE.Vector3(0, 0, 0),
              // new THREE.Vector3(3.1, -0.4, -0.5)
            );
            

//             const humanEnvTextureLoader = new THREE.TextureLoader();
// let humanEnvTexture = null;

// // بارگذاری HDR مخصوص مدل انسانی
// humanEnvTextureLoader.load(
//   '/textures/mab/humanspecifichdr.jpg', // مسیر HDR مخصوص
//   (texture) => {
//     texture.mapping = THREE.EquirectangularReflectionMapping;
//     humanEnvTexture = texture;
    
//     // اعمال HDR روی مدل انسانی پس از بارگذاری
//     if (localHumanModel) {
//       applyHumanSpecificEnvMap(localHumanModel, humanEnvTexture);
//     }
//   }
// );
// const applyHumanSpecificEnvMap = (model, envMap) => {
//   model.traverse((node) => {
//     if (node.isMesh && node.material) {
//       if (node.material.isMeshStandardMaterial || node.material.isMeshPhysicalMaterial) {
//         // غیرفعال کردن envMap از صحنه عمومی
//         node.material.envMap = envMap;
//         node.material.envMapIntensity = 500; // مقدار دلخواه
//         node.material.needsUpdate = true;
//       }
//     }
//   });
// };

      modelLoadRegistrationComplete = true;
      checkAllLoaded();

      const addInvisibleWalls = () => {
        const walls = [
          { size: new CANNON.Vec3(1.5, 5, 60), pos: new CANNON.Vec3(-34, 0.2, 0) },
          { size: new CANNON.Vec3(1.5, 5, 60), pos: new CANNON.Vec3(34, 0.2, 0) },
          { size: new CANNON.Vec3(34, 5, 1.5), pos: new CANNON.Vec3(0, 0.2, -60) },
          { size: new CANNON.Vec3(34, 5, 1.5), pos: new CANNON.Vec3(0, 0.2, 60) },
        ];

        walls.forEach((wall) => {
          const wallBody = new CANNON.Body({
            mass: 0,
            shape: new CANNON.Box(wall.size),
            position: wall.pos,
            material: groundMaterial,
          });
          world.addBody(wallBody);
        });
      };

      addInvisibleWalls();

      const updateModelPosition = () => {
        const humanBody = humanBodyRef.current;
        
        if (localHumanModel && humanBody) {
//           if (localHumanModel?.userData?.collider) {
//   const box = new THREE.Box3().setFromObject(localHumanModel);
//   box.getCenter(localHumanModel.userData.collider.position);
// }
          const velocity = humanBody.velocity;
          velocity.y = 0;
          humanBody.velocity = velocity;

          const previousPosition = humanBody.position.clone();
          const previousQuaternion = humanBody.quaternion.clone();

          localHumanModel.position.copy(humanBody.position);
          localHumanModel.position.y = 0.1;
          localHumanModel.quaternion.copy(humanBody.quaternion);
          const activeHumanCollider = localHumanModel.userData.collider || localHumanModel;
          humanBox.setFromObject(activeHumanCollider);

          const getStaticBoxHit = (testBox) => {
            for (const box of boxes) {
              if (box.mesh.geometry.boundingBox && testBox.intersectsBox(box.mesh.geometry.boundingBox)) {
                return box;
              }
            }
            return null;
          };

          const getPredictedHumanBox = (offsetX, offsetZ, padding = 0.03) => {
            const testBox = humanBox.clone();
            testBox.translate(new THREE.Vector3(offsetX, 0, offsetZ));
            if (padding > 0) testBox.expandByScalar(padding);
            return testBox;
          };

          const getSafeHorizontalVelocity = (vx, vz) => {
            if (!vx && !vz) return { x: 0, z: 0 };

            const predictionTime = 1 / 30;
            const fullHit = getStaticBoxHit(getPredictedHumanBox(vx * predictionTime, vz * predictionTime));
            if (!fullHit) return { x: vx, z: vz };

            const xHit = getStaticBoxHit(getPredictedHumanBox(vx * predictionTime, 0));
            const zHit = getStaticBoxHit(getPredictedHumanBox(0, vz * predictionTime));

            if (!xHit && zHit) return { x: vx, z: 0 };
            if (xHit && !zHit) return { x: 0, z: vz };
            if (!xHit && !zHit) return { x: vx, z: vz };
            return { x: 0, z: 0 };
          };

          const resolveCurrentOverlap = (hitBox) => {
            if (!hitBox || !hitBox.mesh.geometry.boundingBox) return;

            const staticBox = hitBox.mesh.geometry.boundingBox;
            const humanCenter = new THREE.Vector3();
            const staticCenter = new THREE.Vector3();
            humanBox.getCenter(humanCenter);
            staticBox.getCenter(staticCenter);

            const overlapX = Math.min(humanBox.max.x - staticBox.min.x, staticBox.max.x - humanBox.min.x);
            const overlapZ = Math.min(humanBox.max.z - staticBox.min.z, staticBox.max.z - humanBox.min.z);
            const pushPadding = 0.015;
            let pushX = 0;
            let pushZ = 0;

            if (overlapX > 0 && overlapZ > 0) {
              if (overlapX < overlapZ) {
                pushX = humanCenter.x < staticCenter.x ? -(overlapX + pushPadding) : (overlapX + pushPadding);
              } else {
                pushZ = humanCenter.z < staticCenter.z ? -(overlapZ + pushPadding) : (overlapZ + pushPadding);
              }

              humanBody.position.x += pushX;
              humanBody.position.z += pushZ;
              localHumanModel.position.x += pushX;
              localHumanModel.position.z += pushZ;
              humanBox.translate(new THREE.Vector3(pushX, 0, pushZ));
            }
          };

          collidedBox = getStaticBoxHit(humanBox);

          if (collidedBox) {
            resolveCurrentOverlap(collidedBox);
            humanBody.velocity.set(0, 0, 0);
            humanBody.angularVelocity.set(0, 0, 0);
            humanBody.force.set(0, 0, 0);
            humanBody.position.y = 0.1;
            console.log('Collision detected with a box, stopping movement');
          }

          const moveSpeed = AVATAR_CONFIG.moveSpeed;
          const isMobile = window.innerWidth <= 1024; // تشخیص دستگاه موبایل
          const rotationSpeed = isMobile ? 0.06 : 0.18;

          if (
            (keysPressed['ArrowLeft'] || keysPressed['a']) 
            && 
            !(keysPressed['ArrowRight'] || keysPressed['d'])
          ) {
            humanRotationAngle += rotationSpeed;
            humanBody.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), humanRotationAngle);
            if (!isWalking && walkAction) {
              idleAction.stop();
              walkAction.play();
              isWalking = true;
            }
          }
          if (
            (keysPressed['ArrowRight'] || keysPressed['d']) 
            && 
            !(keysPressed['ArrowLeft'] || keysPressed['a'])
          ) {
            humanRotationAngle -= rotationSpeed;
            humanBody.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), humanRotationAngle);
            if (!isWalking && walkAction) {
              idleAction.stop();
              walkAction.play();
              isWalking = true;
            }
          }
          if (keysPressed['ArrowUp'] || keysPressed['w']) {
            const direction = new THREE.Vector3(0, 0, 1).applyQuaternion(localHumanModel.quaternion);
            const safeVelocity = getSafeHorizontalVelocity(direction.x * moveSpeed, direction.z * moveSpeed);
            humanBody.wakeUp();
            humanBody.velocity.set(safeVelocity.x, 0, safeVelocity.z);
            if (!isWalking && walkAction) {
              idleAction.stop();
              walkAction.play();
              isWalking = true;
            }
          } else if (keysPressed['ArrowDown'] || keysPressed['s']) {
            const direction = new THREE.Vector3(0, 0, -1).applyQuaternion(localHumanModel.quaternion);
            const safeVelocity = getSafeHorizontalVelocity(direction.x * moveSpeed, direction.z * moveSpeed);
            humanBody.wakeUp();
            humanBody.velocity.set(safeVelocity.x, 0, safeVelocity.z);
            if (!isWalking && walkAction) {
              idleAction.stop();
              walkAction.play();
              isWalking = true;
            }
          } else {
            humanBody.velocity.set(0, humanBody.velocity.y, 0);
            if (isWalking && walkAction) {
              walkAction.stop();
              idleAction.play();
              isWalking = false;
            }
          }

//           // --- Manual walking when using in-place animation (like avatar-p.glb)
// if (localHumanModel && humanBody && isWalking) {
//   const forward = new THREE.Vector3(0, 0, -1);
//   forward.applyQuaternion(localHumanModel.quaternion);
//   forward.normalize();

//   const manualSpeed = 6; 
//   const deltaTime = 1 / 60; // چون world.step(1/60)

//   const move = forward.clone().multiplyScalar(manualSpeed * deltaTime);

//   // تشخیص جهت حرکت بر اساس کلیدها
//   if (keysPressed['w'] || keysPressed['ArrowUp']) {
//     humanBody.position.x -= move.x;
//     humanBody.position.z -= move.z;
//   } 
//   else if (keysPressed['s'] || keysPressed['ArrowDown']) {
//     humanBody.position.x += move.x;
//     humanBody.position.z += move.z;
//   }

//   // مدل گرافیکی را با بدنه فیزیکی سینک کن
//   localHumanModel.position.copy(humanBody.position);
//   localHumanModel.position.y = 0.1;
// }
// --- Manual walking when using in-place animation (like avatar-p.glb)
// if (localHumanModel && humanBody && isWalking) {
//     const forward = new THREE.Vector3(0, 0, -1);
//     forward.applyQuaternion(localHumanModel.quaternion);
//     forward.normalize();

//     const manualSpeed = 6; 
    
//     // حفظ سرعت عمودی برای جاذبه یا پرش
//     const verticalVelocity = humanBody.velocity.y;
//     let horizontalVelocity = new THREE.Vector3(0, 0, 0);

//     // محاسبه سرعت افقی (Horizontal Velocity)
//     if (keysPressed['w'] || keysPressed['ArrowUp']) {
//         // حرکت رو به جلو: در جهت مخالف forward (جهت استفاده شما در کد اصلی)
//         horizontalVelocity.copy(forward).multiplyScalar(-manualSpeed);
//     } 
//     else if (keysPressed['s'] || keysPressed['ArrowDown']) {
//         // حرکت رو به عقب: در جهت forward (جهت استفاده شما در کد اصلی)
//         horizontalVelocity.copy(forward).multiplyScalar(manualSpeed); 
//     }

//     // اعمال سرعت جدید به بدنه فیزیکی با حفظ سرعت عمودی
//     humanBody.velocity.set(
//         horizontalVelocity.x, 
//         verticalVelocity, 
//         horizontalVelocity.z
//     );

//     // مدل گرافیکی را با بدنه فیزیکی سینک کن (همانند قبل)
//     localHumanModel.position.copy(humanBody.position);
//     localHumanModel.position.y = 0.1;
// } 
// // اگر isWalking فشرده نشده بود، سرعت افقی را صفر کن تا حرکت متوقف شود
// else if (humanBody) {
//     humanBody.velocity.x = 0;
//     humanBody.velocity.z = 0;
// }

          checkProximityAndChangeOpacity();
        }

        interactiveModels.forEach(({ modelRef, collisionEffect, onEnter, onExit }) => {
          if (!collisionEffect) return;
        
          const model = modelRef();
          if (!model || !localHumanModel) return;
        
          const humanTriggerBox = new THREE.Box3().setFromObject(localHumanModel);
          humanTriggerBox.expandByScalar(0.25);

          const modelBox = new THREE.Box3().setFromObject(model);
          const isColliding = humanTriggerBox.intersectsBox(modelBox);
          model.userData.isAvatarOverOpenTrigger = isColliding;
        
          const shouldShowOpenEffect = isColliding || model.userData.isMouseOverOpenTrigger === true;
        
          if (shouldShowOpenEffect && !model.userData.isOpenEffectActive) {
            if (onEnter) onEnter(model);
            model.userData.isOpenEffectActive = true;
          } else if (!shouldShowOpenEffect && model.userData.isOpenEffectActive) {
            if (onExit) onExit(model);
            model.userData.isOpenEffectActive = false;
          }
        
          model.userData.wasColliding = isColliding;
        });

        // به‌روزرسانی موقعیت مدل‌های xlab با بدنه‌های فیزیکی
        const xlabModels = [
          { model: localXlab1XModel, body: xlab1XBody },
          { model: localXlab1LModel, body: xlab1LBody },
          { model: localXlab1AModel, body: xlab1ABody },
          { model: localXlab1BModel, body: xlab1BBody },

          { model: localXlab2XModel, body: xlab2XBody },
          { model: localXlab2LModel, body: xlab2LBody },
          { model: localXlab2AModel, body: xlab2ABody },
          { model: localXlab2BModel, body: xlab2BBody },      

          { model: localXlab3XModel, body: xlab3XBody },
          { model: localXlab3LModel, body: xlab3LBody },
          { model: localXlab3AModel, body: xlab3ABody },
          { model: localXlab3BModel, body: xlab3BBody },      

          { model: localXlab4XModel, body: xlab4XBody },
          { model: localXlab4LModel, body: xlab4LBody },
          { model: localXlab4AModel, body: xlab4ABody },
          { model: localXlab4BModel, body: xlab4BBody },

          // { model: localSphareModel, body: sphareBody },
        ];      

        xlabModels.forEach(({ model, body }) => {
          if (model && body) {
            model.position.copy(body.position);
            model.position.y = 0; // اطمینان از قرار گرفتن روی زمین
            // if(model == localSphareModel){
            //   model.position.y = 0.65;
            // }
            model.quaternion.copy(body.quaternion);
          }
        });

        updateCameraPosition();
      };

      

      const updateMainLogoRotation = (delta) => {
        if (!MAIN_LOGO_ROTATION_CONFIG.enabled || mainLogoModels.length === 0) return;

        const duration = Math.max(0.001, MAIN_LOGO_ROTATION_CONFIG.durationSeconds);
        const direction = MAIN_LOGO_ROTATION_CONFIG.direction >= 0 ? 1 : -1;
        const amount = direction * (Math.PI * 2 / duration) * delta;

        mainLogoModels.forEach((logoModel) => {
          if (!logoModel) return;

          if (MAIN_LOGO_ROTATION_CONFIG.axis === 'x') {
            logoModel.rotation.x += amount;
          } else if (MAIN_LOGO_ROTATION_CONFIG.axis === 'z') {
            logoModel.rotation.z += amount;
          } else {
            logoModel.rotation.y += amount;
          }
        });
      };

      const clock = new THREE.Clock();
      const animate = () => {
        if (!isMounted) return;
        requestAnimationFrame(animate);

        // updateFog();

        // updateCloud();

        // // آپدیت ذرات برف - با اولویت بالاتر
        // if (snowParticles.current) {
        //   updateSnowParticles();
        //   checkSnowAccumulation();
        // }

        if (!mainSceneActiveRef.current) {
          clock.getDelta();
          return;
        }

        rotatingModels.forEach(item => {
          if (item.model) {
            item.model.rotation.x += item.speed.x;
            item.model.rotation.y += item.speed.y;
            item.model.rotation.z += item.speed.z;
          }
          if (item.body) {
            item.body.angularVelocity.set(
              item.speed.x,
              item.speed.y,
              item.speed.z
            );
          }
        });

        const delta = Math.min(clock.getDelta(), 0.1);

        updateMainLogoRotation(delta);
        updateSnowParticles(delta);

        if (!renderer || !camera || !scene) return;

        world.step(1 / 120, delta, 3);
        // sphere.position.copy(sphereBody.position);
        
        updateModelPosition();
        updateSnowBall(delta);
        if (humanMixer) humanMixer.update(delta);
        if (aIagentMixer) aIagentMixer.update(delta);
        if (aRboardMixer) aRboardMixer.update(delta);
        if (aRframeMixer) aRframeMixer.update(delta);
        if (interactiveMixer) interactiveMixer.update(delta);
        if (metawebMixer) metawebMixer.update(delta);
        if (telegrambotMixer) telegrambotMixer.update(delta);
        if (useYourMixer) useYourMixer.update(delta);
        if (xMixer) xMixer.update(delta);
        if (drone1Mixer) drone1Mixer.update(delta);
        if (drone2Mixer) drone2Mixer.update(delta);
        if (instagramSocialMixer) instagramSocialMixer.update(delta);
        if (telegramSocialMixer) telegramSocialMixer.update(delta);
        if (xSocialMixer) xSocialMixer.update(delta);
        if (emailSocialMixer) emailSocialMixer.update(delta);

        renderer.render(scene, camera);
      };
      animate();

      window.addEventListener('resize', handleResize);
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      renderer.domElement.addEventListener('click', handleClick);
      renderer.domElement.addEventListener('wheel', handleWheel);
      renderer.domElement.addEventListener('mousedown', handleMouseDown);
      renderer.domElement.addEventListener('mouseup', handleMouseUp);
      renderer.domElement.addEventListener('mousemove', handleMouseMove);
      // اضافه کردن لیسنرهای لمسی
      renderer.domElement.addEventListener('touchstart', handleTouchStart, { passive: false });
      renderer.domElement.addEventListener('touchmove', handleTouchMove, { passive: false });
      renderer.domElement.addEventListener('touchend', handleTouchEnd, { passive: false });

      // جلوگیری از zoom ناخواسته
      const preventDefault = (e) => e.preventDefault();
      document.addEventListener('gesturestart', preventDefault);
      document.addEventListener('gesturechange', preventDefault);
      document.addEventListener('gestureend', preventDefault);

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        isMounted = false;
        clearTimeout(loadTimeout);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keyup', handleKeyUp);
        renderer.domElement.removeEventListener('click', handleClick);
        renderer.domElement.removeEventListener('wheel', handleWheel);
        renderer.domElement.removeEventListener('mousedown', handleMouseDown);
        renderer.domElement.removeEventListener('mouseup', handleMouseUp);
        renderer.domElement.removeEventListener('mousemove', handleMouseMove);

        renderer.domElement.removeEventListener('touchstart', handleTouchStart);
        renderer.domElement.removeEventListener('touchmove', handleTouchMove);
        renderer.domElement.removeEventListener('touchend', handleTouchEnd);

        document.removeEventListener('gesturestart', preventDefault);
        document.removeEventListener('gesturechange', preventDefault);
        document.removeEventListener('gestureend', preventDefault);

        scene.traverse((object) => {
          if(object.isMesh || object.isLineSegments) {
            if (object.geometry) object.geometry.dispose();
            if (object.material) {
              if (Array.isArray(object.material)) {
                object.material.forEach((mat) => mat.dispose());
              } else {
                object.material.dispose();
              }
            }
          }
        });

        if (idleAction) idleAction.stop();
        if (walkAction) walkAction.stop();
        if (humanMixer) humanMixer.stopAllAction();

        renderer.dispose();
        renderer.forceContextLoss();
        const canvasElement = document.getElementById('three-canvas');
        if (canvasElement) canvasElement.remove();
      };
    };

    const focusHandler = () => {
      document.getElementById('three-container').focus();
    };
    document.addEventListener('click', focusHandler);

    initializeScene();

    document.getElementById('three-container').focus();

    const button = document.querySelector('.button');
    if (button) {
      button.addEventListener('animationstart', () => {
        console.log('Wave animation started');
      });
      button.addEventListener('animationend', () => {
        console.log('Wave animation ended');
      });
    }
  
    return () => {
      isMounted = false;
      clearTimeout(loadTimeout);
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener('click', focusHandler);
      cleanupScene();
    };
  }, []);

  const handleStartButtonClick = () => {
    setIsButtonAnimating(true);
    setTimeout(() => {
      mainSceneActiveRef.current = true;
      setShowStartScreen(false);
      setIsButtonAnimating(false);
      console.log("Animation completed, hiding start screen");
    }, 2000);
    // setShowStartScreen(false);
  };

  return (
    <div
      id="three-container"
      tabIndex="0"
      style={{ width: '100%', height: '100vh', position: 'relative' }}
    >
      {(loading || showStartScreen) && !error && (
        <PenguinLoadingOverlay
          progress={progress}
          ready={showStartScreen && !loading}
          isEntering={isButtonAnimating}
          onEnter={handleStartButtonClick}
        />
      )}
      {error && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'red',
            zIndex: 1000,
          }}
        >
          <h2>Loading Error</h2>
          <p>{error}</p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}
          >
            Retry
          </button>
        </div>
      )}
      {/* {(loading || showStartScreen || error) &&(
        
      )} */}

{!showStartScreen && !loading && !error && (
  <div>
      <div className='joystic-container' style={{zIndex: 999 }}>
          <Joystick
            size={100}
            baseColor="#1f168890"
            border="1px solid #24d3a4"
            stickColor="black"
            move={handleJoystickMove}
            stop={handleJoystickStop}
          />
        </div>
      <div className="dpad-container">
        <div className="dpad">
          {/* <div className="dpad-button empty"></div> */}
          <div
            className="dpad-button" draggable="false"
            onMouseDown={() => handleButtonPress('ArrowUp')}
            onMouseUp={() => handleButtonRelease('ArrowUp')}
            // onTouchStart={() => handleButtonPress('ArrowUp')}
            // onTouchEnd={() => handleButtonRelease('ArrowUp')}
            onTouchStart={(e) => {
              e.preventDefault(); // جلوگیری از رفتار پیش‌فرض
              handleButtonPress('ArrowUp');
            }}
            onTouchEnd={(e) => {
              e.preventDefault(); // جلوگیری از رفتار پیش‌فرض
              handleButtonRelease('ArrowUp');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              handleButtonRelease('ArrowUp');
            }}
          >
            ↑
          </div>
          {/* <LongPressButton keyValue="ArrowUp">⬆️</LongPressButton> */}
          {/* <div className="dpad-button empty"></div> */}
          {/* <div
            className="dpad-button"
            onMouseDown={() => handleButtonPress('ArrowLeft')}
            onMouseUp={() => handleButtonRelease('ArrowLeft')}
            onTouchStart={() => handleButtonPress('ArrowLeft')}
            onTouchEnd={() => handleButtonRelease('ArrowLeft')}
          >
            ←
          </div>
          <div className="dpad-button empty"></div>
          <div
            className="dpad-button"
            onMouseDown={() => handleButtonPress('ArrowRight')}
            onMouseUp={() => handleButtonRelease('ArrowRight')}
            onTouchStart={() => handleButtonPress('ArrowRight')}
            onTouchEnd={() => handleButtonRelease('ArrowRight')}
          >
            →
          </div> */}
          {/* <div className="dpad-button empty"></div> */}
          <div
            className="dpad-button" draggable="false"
            onMouseDown={() => handleButtonPress('ArrowDown')}
            onMouseUp={() => handleButtonRelease('ArrowDown')}
            // onTouchStart={() => handleButtonPress('ArrowDown')}
            // onTouchEnd={() => handleButtonRelease('ArrowDown')}
            onTouchStart={(e) => {
              e.preventDefault(); // جلوگیری از رفتار پیش‌فرض
              handleButtonPress('ArrowDown');
            }}
            onTouchEnd={(e) => {
              e.preventDefault(); // جلوگیری از رفتار پیش‌فرض
              handleButtonRelease('ArrowDown');
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              handleButtonRelease('ArrowDown');
            }}
          >
            ↓
          </div>
          {/* <LongPressButton keyValue="ArrowDown">⬇️</LongPressButton> */}
          {/* <div className="dpad-button empty"></div> */}
        </div>
      </div>
  </div>
)}
      <style>
        {`
        .theme {
          --color-active: hsl(187, 100%, 50%);
          --color-active-hover: hsl(180, 100%, 60%);
          --color-active-pressed: hsl(162, 100%, 50%);
        }
    
        .theme_color_light {
          --color-bg-default: #032585;
          --light: 51, 54, 255;
          --shadow: 0, 0, 60;
          --light-mod: 0.4;
          --shadow-mod: 3;
        }
    
        .startbody {
          margin: 0;
          /*
          background: 
            linear-gradient(
              120deg, 
              rgba(var(--shadow), calc(0 * var(--shadow-mod))) 30%, 
              rgba(var(--shadow), calc(0.2 * var(--shadow-mod)))
            ),
            linear-gradient(var(--color-bg-default), var(--color-bg-default));
            
            background: #E700FF;
background: radial-gradient(circle, rgba(231, 0, 255, 1) 0%, rgba(3, 191, 254, 1) 50%, rgba(231, 0, 255, 1) 100%);
*/
background: #2A003E;
background: linear-gradient(90deg, rgba(42, 0, 62, 1) 0%, rgba(0, 4, 62, 1) 100%);

        }
    
        .startbodycontainer {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          width: 100%;
          overflow: hidden;
        }
    
        .button {
          --button-content-color: var(--color-active);
          position: relative;
          z-index: 1;
          display: block;
          -webkit-appearance: none;
          appearance: none;
          width: 85px;
          height: 85px;
          padding: 0;
          border: none;
          border-radius: 50%;
          box-sizing: border-box;
          background: 
            radial-gradient(
              circle at 20% 20%, 
              rgba(var(--light), calc(0.9 * var(--light-mod))) 25%, 
              rgba(var(--shadow),calc(0.1 * var(--shadow-mod)))
            ),
            linear-gradient(
              120deg, rgba(var(--shadow), 0.1), rgba(var(--shadow),0.3)
            );
          /*
          box-shadow: 
            inset 10px 15px 40px -10px rgba(var(--light), calc(1 * var(--light-mod))),
            inset -20px -30px 12px -32px rgba(var(--shadow), calc(0.4 * var(--shadow-mod))),
            inset -20px -30px 40px -20px rgba(var(--shadow), calc(0.3 * var(--shadow-mod))),
            -10px -15px 16px -2px rgba(var(--light), calc(1 * var(--light-mod))),
            12px 18px 12px -18px rgba(var(--shadow), calc(0.4 * var(--shadow-mod))),
            13px 20px 20px -12px rgba(var(--shadow), calc(0.2 * var(--shadow-mod)));
          outline: none;
          */
         box-shadow: 
    inset 5px 8px 20px -5px rgba(var(--light), calc(0.5 * var(--light-mod))), /* کاهش سایه داخلی */
    inset -10px -15px 6px -16px rgba(var(--shadow), calc(0.2 * var(--shadow-mod))), /* کاهش سایه داخلی */
    inset -10px -15px 20px -10px rgba(var(--shadow), calc(0.15 * var(--shadow-mod))), /* کاهش سایه داخلی */
    -5px -8px 8px -1px rgba(var(--light), calc(0.5 * var(--light-mod))), /* کاهش سایه خارجی */
    6px 9px 6px -9px rgba(var(--shadow), calc(0.2 * var(--shadow-mod))), /* کاهش سایه خارجی */
    7px 10px 10px -6px rgba(var(--shadow), calc(0.1 * var(--shadow-mod))); /* کاهش سایه خارجی */
  outline: none;
        }
    
        .button::before {
          /*content: '';*/
          position: absolute;
          z-index: 2;
          top: -100%;
          left: -100%;
          bottom: -100%;
          right: -100%;
          backdrop-filter: blur(5px);
          pointer-events: none;
        }
    
        .button::after {
          content: '';
          position: absolute;
          left: 10%;
          top: 10%;
          right: 10%;
          bottom: 10%;
          border-radius: 99em;
          background: 
            radial-gradient(
              circle at 80% 80%, 
              rgba(var(--light), calc(0.9 * var(--light-mod))) 25%, 
              rgba(var(--shadow), calc(0.28 * var(--shadow-mod)))
            );
          opacity: 0;
          filter: blur(12px);
        }
    
        .button__play {
          --glow: 0 -3px;
          position: absolute;
          z-index: 2;
          top: 50%;
          left: 41%;
          width: 8px;
          height: 44px;
          border-radius: 99em;
          background-color: rgba(var(--light), 1);
          transform-origin: 24px center;
          transform: translate(-50%, -50%) scale(1);
          filter: blur(0.4px);
          box-shadow: 
            0 0 0 -3px var(--button-content-color),
            inset -1.2px -0.8px 1px 0.8px rgba(var(--light), calc(0.6 * var(--light-mod))),
            inset 1.2px 0.8px 1px 0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
            inset 0 1px 3px 3px var(--button-content-color);
          transition: box-shadow 0.4s;
        }
    
        .button__play::before, .button__play::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 106%;
          left: 10px;
          border-radius: 99em;
          background-color: rgba(var(--light), 1);
          transition: box-shadow 0.4s;
        }
    
        .button__play::before {
          top: 0;
          transform-origin: left top;
          transform: rotate(-63deg);
          box-shadow: 
            0 0 0 -3px var(--button-content-color),
            inset 1.2px -0.8px 1px 0.8px rgba(var(--light), calc(0.6 * var(--light-mod))),
            inset -1.2px 0.8px 1px 0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
            inset 0 0px 3px 3px var(--button-content-color);
        }
    
        .button__play::after {
          bottom: 0;
          transform-origin: left bottom;
          transform: rotate(63deg);
          box-shadow: 
            0 0 0 -3px var(--button-content-color),
            inset -1.2px 0px 1px 0.8px rgba(var(--light), calc(0.6 * var(--light-mod))),
            inset 1.2px -1.2px 1px 0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.16 * var(--shadow-mod))),
            inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
            inset 0 0px 3px 3px var(--button-content-color);
        }
    
        .button__waves {
          opacity: 0;
        }
    
        .button__waves,
        .button__waves::before,
        .button__waves::after {
          --scale: 0.7;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          border-radius: 99em;
          transform: translate(-50%, -50%) scale(1);
        }
    
        .button__waves::before, .button__waves::after { 
          content: ''; 
          box-shadow: 
            inset -14px -21px 20px -10px rgba(var(--light), calc(1 * var(--light-mod))),
            inset 14px 21px 20px -10px rgba(var(--shadow), calc(0.4 * var(--shadow-mod))),
            inset 10px 15px 20px -10px rgba(var(--light), calc(1 * var(--light-mod))),
            inset -20px -30px 12px -32px rgba(var(--shadow), calc(0.4 * var(--shadow-mod))),
            inset -20px -30px 40px -20px rgba(var(--shadow), calc(0.3 * var(--shadow-mod))),
            -10px -15px 16px -2px rgba(var(--light), calc(1 * var(--light-mod))),
            12px 18px 12px -18px rgba(var(--shadow), calc(0.4 * var(--shadow-mod))),
            13px 20px 20px -12px rgba(var(--shadow), calc(0.2 * var(--shadow-mod)));
        }
    
        .button:hover {
          --button-content-color: var(--color-active-hover);
          cursor: pointer;
        }
    
        .button:focus:hover::after {
          animation: ButtonInnerShadowAnimation 0.8s ease both;
        }
    
        .button:focus:hover .button__play {
          animation: PlayMainAnimation 0.8s ease;
        }
    
        .button:focus:hover .button__play::before {
          animation: PlayBeforeAnimation 0.8s ease; 
        }
    
        .button:focus:hover .button__play::after {
          animation: PlayAfterAnimation 0.8s ease; 
        }
    
        .button:focus:hover .button__waves {
          animation: WaveMainAnimation 2s linear both; 
        }
    
        .button:focus:hover .button__waves::before {
          animation: WaveBeforeAnimation 1.1s 0.1s linear both; 
        }
    
        .button:focus:hover .button__waves::after {
          animation: WaveBeforeAnimation 0.9s 0.55s linear both; 
        }
    
        .button:focus:active .button::after,
        .button:focus:active:hover .button::after,
        .button:focus:active .button__play,
        .button:focus:active:hover .button__play,
        .button:focus:active .button__play::before,
        .button:focus:active:hover .button__play::before,
        .button:focus:active .button__play::after,
        .button:focus:active:hover .button__play::after,
        .button:focus:active .button__waves,
        .button:focus:active:hover .button__waves,
        .button:focus:active .button__waves::before,
        .button:focus:active:hover .button__waves::before,
        .button:focus:active .button__waves::after,
        .button:focus:active:hover .button__waves::after {
          animation-name: none !important;
        }
    
        @keyframes ButtonInnerShadowAnimation {
          0% { opacity: 0; }
          50% { opacity: 1; }
          100% { opacity: 0; }
        }
    
        @keyframes PlayMainAnimation {
          50% {
            --button-content-color: var(--color-active-pressed);
            transform: translate(-50%, -50%) scale(0.94);
            box-shadow: 
              0 0 16px -3px var(--button-content-color),
              inset -1.2px -0.8px 1px 0.8px rgba(var(--light), calc(0.24 * var(--light-mod))),
              inset 1.2px 0.8px 1px 0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
              inset 0 1px 3px 3px var(--button-content-color);
          }
        }
    
        @keyframes PlayBeforeAnimation {
          50% {
            box-shadow: 
              0 0 16px -3px var(--button-content-color),
              inset 1.2px -0.8px 1px 0.8px rgba(var(--light), calc(0.24 * var(--light-mod))),
              inset -1.2px 0.8px 1px 0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
              inset 0 0px 3px 3px var(--button-content-color);
          }
        }
    
        @keyframes PlayAfterAnimation {
          50% {
            box-shadow: 
              0 0 16px -3px var(--button-content-color),
              inset -1.2px 0px 1px 0.8px rgba(var(--light), calc(0.24 * var(--light-mod))),
              inset 1.2px -1.2px 1px 0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 1.2px 1.2px 1px -0.8px rgba(var(--shadow), calc(0.12 * var(--shadow-mod))),
              inset 0 0 1px 2px rgba(var(--light), calc(0.5 * var(--light-mod))),
              inset 0 0px 3px 3px var(--button-content-color);
          }
        }
    
        @keyframes WaveMainAnimation {
          30% { opacity: 1; }
        }
    
        @keyframes WaveBeforeAnimation {
          0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(1.5);
          }
          30% { opacity: 1; }
          100% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(4.8);
          }
        }
        
        .button.animating::after {
          animation: ButtonInnerShadowAnimation 0.8s ease both;
        }
      
        .button.animating .button__play {
          animation: PlayMainAnimation 0.8s ease;
        }
      
        .button.animating .button__play::before {
          animation: PlayBeforeAnimation 0.8s ease; 
        }
      
        .button.animating .button__play::after {
          animation: PlayAfterAnimation 0.8s ease; 
        }
      
        .button.animating .button__waves {
          animation: WaveMainAnimation 2s linear both; 
        }
      
        .button.animating .button__waves::before {
          animation: WaveBeforeAnimation 1.1s 0.1s linear both; 
        }
      
        .button.animating .button__waves::after {
          animation: WaveBeforeAnimation 0.9s 0.55s linear both; 
        }

        svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color:#fff;
        }

        button.clicked {
          animation: shadowFadeOut 200ms ease-out forwards,
          shadowFadeIn 200ms 300ms ease-in forwards;
        }

        button.clicked svg {
          animation: fillFadeOut 200ms ease-out forwards,
          fillFadeIn 200ms 300ms ease-in forwards;
        }
        
        /*
          .loader {
            --s: 25px;
            --g: 5px;  
            height: calc(1.353*var(--s) + var(--g));
            aspect-ratio: 3;
            background:
              linear-gradient(#ff1818 0 0) left/33% 100% no-repeat,
              conic-gradient(from -90deg at var(--s) calc(0.353*var(--s)),
                #fff 135deg, #666 0 270deg, #aaa 0); 
            background-blend-mode: multiply;
            --_m:
              linear-gradient(to bottom right,
                #0000 calc(0.25*var(--s)), #000 0 calc(100% - calc(0.25*var(--s)) - 1.414*var(--g)), #0000 0),
              conic-gradient(from -90deg at right var(--g) bottom var(--g), #000 90deg, #0000 0);
            -webkit-mask: var(--_m);
            mask: var(--_m);
            background-size: calc(100%/3) 100%;
            -webkit-mask-size: calc(100%/3) 100%;
            mask-size: calc(100%/3) 100%;
            -webkit-mask-composite: source-in;
            mask-composite: intersect;
            animation: l7 steps(3) 1.5s infinite;
          }
          @keyframes l7 {
            to {background-position: 150% 0%}
          }
            */
           .loader {
  display: inline-flex;
  gap: 10px;
}
.loader:before,
.loader:after {
  content: "";
  height: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side,#000 95%,#0000) 35% 35%/6px 6px no-repeat
    #fff;
  animation: l5 3s infinite;
}
@keyframes l5 {
  0%,11%   {background-position:35% 35%}
  14%,36%  {background-position:65% 35%}
  38%,61%  {background-position:65% 65%}
  64%,86%  {background-position:35% 65%}
  88%,100% {background-position:35% 35%}
}
          .dpad-container {
            position: fixed;
            bottom: 20px;
            right: 20px;
            display: none;
            z-index: 1000;
          }
          .dpad {
            display: grid;
            grid-template-columns: repeat(1, 60px);
            grid-template-rows: repeat(2, 60px);
            gap: 5px;
          }
          .dpad-button {
            background-color: rgba(255, 255, 255, 0.4);
            border: 2px solid rgba(255, 255, 255, 0.5);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            color: white;
            cursor: pointer;
            touch-action: manipulation;
            transition: background-color 0.2s;

            user-select: none; /* جلوگیری از انتخاب متن */
  -webkit-user-select: none; /* پشتیبانی از مرورگرهای WebKit */
  -moz-user-select: none; /* پشتیبانی از فایرفاکس */
  -ms-user-select: none; /* پشتیبانی از Edge */
  touch-action: manipulation; /* جلوگیری از رفتارهای پیش‌فرض لمسی */
  -webkit-touch-callout: none; /* جلوگیری از منوی متنی در iOS */
  -webkit-tap-highlight-color: transparent; /* حذف افکت هایلایت در موبایل */
  outline: none; /* حذف فوکوس پیش‌فرض */
          }
          .dpad-button:active {
            background-color: rgba(255, 255, 255, 0.5);
          }
          .dpad-button.empty {
            background-color: transparent;
            border: none;
          }
          .dpad-button:focus {
  outline: none; /* اطمینان از حذف فوکوس */
}
          .joystic-container {
            position: fixed;
            bottom: 20px;
            left: 20px;
            display: none;
            z-index: 1000;
          }
          .joystic-container *{
            user-select: none; /* جلوگیری از انتخاب متن */
            -webkit-user-select: none; /* پشتیبانی از مرورگرهای WebKit */
            -moz-user-select: none; /* پشتیبانی از فایرفاکس */
            -ms-user-select: none; /* پشتیبانی از Edge */
            touch-action: manipulation; /* جلوگیری از رفتارهای پیش‌فرض لمسی */
            -webkit-touch-callout: none; /* جلوگیری از منوی متنی در iOS */
            -webkit-tap-highlight-color: transparent; /* حذف افکت هایلایت در موبایل */
            outline: none; /* حذف فوکوس پیش‌فرض */
          }
          *{
            user-select: none; /* جلوگیری از انتخاب متن */
            -webkit-user-select: none; /* پشتیبانی از مرورگرهای WebKit */
            -moz-user-select: none; /* پشتیبانی از فایرفاکس */
            -ms-user-select: none; /* پشتیبانی از Edge */
            touch-action: manipulation; /* جلوگیری از رفتارهای پیش‌فرض لمسی */
            -webkit-touch-callout: none; /* جلوگیری از منوی متنی در iOS */
            -webkit-tap-highlight-color: transparent; /* حذف افکت هایلایت در موبایل */
            outline: none; /* حذف فوکوس پیش‌فرض */
          }  
          @media (max-width: 1024px) {
            .dpad-container {
              display: block;
            }
            .joystic-container{
              display: block;
            }  
          }
          .joystic-container div{
            border: 1px solid #24d3a4 !important;
          }
          .joystic-container div button{
            background: rgb(42, 0, 62) !important;
            border: 1px solid #762ad6 !important;
          }
        `}
      </style>
      
    </div>
  );
};

export default ThreeScene;

const LongPressButton = ({ keyValue, children }) => {
  const intervalRef = useRef(null);

  const startPress = (e) => {
    e.preventDefault(); // جلوگیری از رفتار پیش‌فرض مرورگر (مانند انتخاب متن یا باز شدن context menu)
    handleButtonPress(keyValue); // اولین فشار
    intervalRef.current = setInterval(() => {
      handleButtonPress(keyValue); // فراخوانی مداوم در حین لانگ تپ
    }, 100); // هر 100 میلی‌ثانیه
  };

  const endPress = (e) => {
    e.preventDefault(); // جلوگیری از رفتار پیش‌فرض در پایان لمس
    clearInterval(intervalRef.current); // توقف interval
    handleButtonRelease(keyValue); // آزاد کردن دکمه
  };

  return (
    <button
      className="dpad-button"
      onMouseDown={startPress}
      onMouseUp={endPress}
      onMouseLeave={endPress}
      onTouchStart={startPress}
      onTouchEnd={endPress}
      onTouchCancel={endPress} // مدیریت لغو لمس (مثلاً وقتی انگشت از دکمه خارج می‌شود)
      style={{ touchAction: 'manipulation' }} // جلوگیری از رفتارهای پیش‌فرض لمسی
    >
      {children}
    </button>
  );
};
// end v184